import React, { useState, useEffect, useCallback, useRef, createContext, useContext } from "react";
import { BrowserRouter, Routes, Route, Navigate, NavLink, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import toast from "react-hot-toast";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { reservations as resApi, ref as refApi, auth, projects, appSettings, addWithDupGuard, waBiz, staffTasks } from "./services/api"; // v3.4.187 waBiz (شارة الرقم الرئيسي)
import PhoneInput from "./components/PhoneInput"; // v3.3.749 — إدخال جوال موحّد
import LoginPage from "./pages/LoginPage";
import ProjectsPage from "./pages/ProjectsPage";
import AnalyticsPage from "./pages/AnalyticsPage";
import ReservationsSchedulerPage from "./pages/ReservationsSchedulerPage";
import { PaymentsPage, CollectionsPage, CommissionsPage, AdminFeesPage, CashFlowPage, BenchmarkingPage, FinancialReportsPage, CompanyAssetsPage, CashFlowStatementPage } from "./pages/FinancialAnalysisPages";
// v3.3.576 — Treasury (الخزينة المالية)
import TreasuryPage from "./pages/TreasuryPage";
import FinanceDashboardPage from "./pages/FinanceDashboardPage"; // v3.4.327 — الداشبورد المالي
import ChairmanMailPage from "./pages/ChairmanMailPage"; // v3.4.328 — Chairman Office › الإيميلات
import ChairmanCalendarPage from "./pages/ChairmanCalendarPage"; // v3.4.339 — Chairman Office › التقويم
import ChairmanCommPage from "./pages/ChairmanCommPage"; // v3.4.342 — Chairman Office › التواصل الخارجي (واتساب ابوبدر 2 / بزنس)
import ChairmanContactsPage from "./pages/ChairmanContactsPage"; // v3.4.345 — Chairman Office › جهات الاتصال
import MediaLibraryPage from "./pages/MediaLibraryPage"; // v3.4.361 — مكتبة الميديا والجرافيك
import CapexPage from "./pages/CapexPage";
import SukukPage from "./pages/SukukPage";
import AccountingPage from "./pages/AccountingPage";
import UnitFullPage from "./pages/UnitFullPage";
import CompletenessPage from "./pages/CompletenessPage"; // v3.4.136 — فحص اكتمال بيانات المبيعات
import HrPage from "./pages/HrPage"; // v3.4.192 — الموارد البشرية
import UserManagement from "./pages/UserManagement";
import SettingsPage from "./pages/SettingsPage";
import RefListPage from "./pages/RefListPage";
import ClientGroupsPage from "./pages/ClientGroupsPage";
import MarketerGroupsPage from "./pages/MarketerGroupsPage";
import ProspectGroupsPage from "./pages/ProspectGroupsPage";
import AuditLogPage from "./pages/AuditLogPage";
import DisbursementsPage from "./pages/DisbursementsPage";
import ContractsPage from "./pages/ContractsPage";
import CommunicationPage from "./pages/CommunicationPage";
import WhatsAppSettingsPage from "./pages/WhatsAppSettingsPage";
import BusinessCommPage from "./pages/BusinessCommPage";
import WaUpdatesGroupPage from "./pages/WaUpdatesGroupPage"; // v3.4.271 — إدارة جروب التحديثات (واتس)
import WaAdminPage from "./pages/WaAdminPage"; // v3.4.513 — إدارة الواتس (الحدود وإجراءات الحماية)
import InvitationsPage from "./pages/InvitationsPage"; // v3.4.062 — الدعوات صفحة مستقلة
import ProspectsPage from "./pages/ProspectsPage";
import { ClientProspectsPage, ClientProspectGroupsPage } from "./pages/ClientProspectsPage";
import PortalAccountsPage from "./pages/PortalAccountsPage"; // v3.4.060 — إدارة حسابات البوابة
import DalilakReservationsPage from "./pages/DalilakReservationsPage"; // v3.4.250 — حجوزات دليلك صفحة مستقلة
import SocialCampaignsPage from "./pages/SocialCampaignsPage"; // v3.4.280 — إدارة السوشل ميديا والحملات
import LandOffersPage from "./pages/LandOffersPage"; // v3.3.824 — عروض الأراضي
import AqarListingsPage from "./pages/AqarListingsPage"; // v3.4.399 — إعلانات عقار
import SubcontractorsPage from "./pages/SubcontractorsPage"; // v3.4.412 — قائمة المقاولين
import LegalPage from "./pages/LegalPage"; // v3.4.420 — الإدارة القانونية
import StaffTasksPage from "./pages/StaffTasksPage"; // v3.4.207 — قائمة المهام للموظفين
import ProjectOffersPage from "./pages/ProjectOffersPage"; // v3.3.828 — عروض المشاريع
import CallCenterPage, { BusinessChatPage, CompanyWhatsAppPage } from "./pages/CallCenterPage"; // v3.4.180 CompanyWhatsAppPage // v3.3.923 — إدارة الكول سنتر (Yeastar) — v3.4.042: إدارة البزنس شات صفحة مستقلة
import ConstructionPage, { ContractPaymentsPage, ReceiptRequestsPage, DrawingsReferencePage, PmAccountsPage } from "./pages/ConstructionPage"; // v3.3.849/868
import SalesPage from "./pages/SalesPage"; // v3.4.538 — المبيعات
import PayrollPage from "./pages/PayrollPage"; // v3.4.837 — إدارة الرواتب
import QuotationsPage from "./pages/QuotationsPage"; // v3.4.561 — عروض الأسعار
import VouchersPage from "./pages/VouchersPage"; // v3.4.611 — سندات القبض والصرف
import DigitalAccountsPage from "./pages/DigitalAccountsPage"; // v3.4.547 — مرجع الحسابات الإلكترونية
import SupplyContractsPage from "./pages/SupplyContractsPage"; /* v3.4.621 — عقود التوريدات والخدمات الاستشارية */
import UnitAreasReferencePage from "./pages/UnitAreasReferencePage"; // v3.4.724 — مرجع مساحة الوحدات (المساحات البيعية)
import PaymentOrdersHub from "./pages/PaymentOrdersHub"; // v3.4.442 — نظام أوامر الصرف (تابان)/882/971/987 — المشاريع الإنشائية + أوامر الصرف + دفعات المقاولين + رفع مستخلص استلام + مرجع الخرائط — v3.4.028: إدارة مستخدمي قسم المشاريع صفحة مستقلة
import OfficeVisitorsPage from "./pages/OfficeVisitorsPage"; // v3.3.718 — سجل زوار المكتب
import PmPortalPage from "./pages/PmPortalPage"; // v3.3.979 — تطبيق إدارة المشاريع (بوابة خارجية)
import MarketingAnalyticsPage from "./pages/MarketingAnalyticsPage"; // v3.3.759 — تحليل التسويق الداخلي
import PortalPage from "./pages/PortalPage"; // v3.3.769 — البوابة الخارجية
import TicketsPage from "./pages/TicketsPage";
import CloudBillingPage from "./pages/CloudBillingPage"; // v3.4.255 — فواتير الكلاود
import StorageMapPage from "./pages/StorageMapPage"; // v3.4.425 — خريطة التخزين
import TwoFactorPage from "./pages/TwoFactorPage"; // v3.4.510 — التحقق بخطوتين
import WebsitesPage from "./pages/WebsitesPage"; // v3.4.489 — المواقع الإلكترونية
import ScreenAdminPage from "./pages/ScreenAdminPage"; // v3.4.492 — الشاشة التفاعلية الموحّدة
import { screenMedia as screenMediaApi } from "./services/api"; // v3.4.492 — مشاريع الشاشة في القائمة الجانبية
import DalalaTooltip from "./components/DalalaTooltip";
import ReservationNotesCell from "./components/ReservationNotesCell";
// v3.3.547 — Page tracking hook (records every navigation to /api/login-history/track-page)
import usePageTracking from "./hooks/usePageTracking";
import MobilePage from "./pages/MobilePage";
import ColumnHeaderMenu from "./components/ColumnHeaderMenu";
import ColumnToggle from "./components/ColumnToggle";
import ReservationsHealthPanel from "./components/ReservationsHealthPanel"; // v3.4.143 — صحة الحجوزات
import ReservationStatsPanel from "./components/ReservationStatsPanel"; // v3.4.690 — إحصائيات الحجوزات
import { FiTag, FiMail, FiHome, FiUsers, FiLogOut, FiMenu, FiX, FiSearch, FiPlus, FiFilter, FiTrash2, FiSave, FiChevronLeft, FiChevronRight, FiXCircle, FiSettings, FiBriefcase, FiUserCheck, FiTrendingUp, FiEdit2, FiLayers, FiActivity, FiEye, FiDollarSign, FiFileText, FiGrid, FiMessageCircle, FiBarChart2, FiCreditCard, FiTrendingDown, FiPercent, FiRefreshCw, FiCalendar, FiDatabase, FiTool, FiMapPin, FiPhoneCall, FiImage, FiCloud } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa"; // v3.3.970 — أيقونة ربط واتساب بالقائمة الجانبية
import { FiHardDrive, FiInbox } from "react-icons/fi";
import OfficialLettersPage from "./pages/OfficialLettersPage"; // v3.4.815 — الخطابات الرسمية
import AlmaCapitalPage from "./pages/AlmaCapitalPage"; // v3.4.817 — Alma Capital: موقع ألما الإلكتروني (الرسائل + بيانات التواصل + الالتزام التنظيمي)
import ClientCollectionPage from "./pages/ClientCollectionPage"; // v3.4.801 — تحليل تحصيل العميل // v3.4.425 — خريطة التخزين
import { FiSmartphone, FiKey, FiMonitor, FiCheckSquare } from "react-icons/fi"; // v3.4.207 FiCheckSquare — المهام // v3.3.982 — أيقونة روابط التطبيقات الخارجية — v3.4.028: FiKey لإدارة مستخدمي قسم المشاريع
import ReservationQuotePicker, { ReservationQuoteCard } from "./components/ReservationQuotePicker"; // v3.4.601 — الحجز من عرض سعر
import "./styles/app.css";

// =============================================
// Reference Data Context - loaded once, shared everywhere
// =============================================
const RefContext = createContext({});
export function RefProvider({ children }) {
  const [options, setOptions] = useState({});
  const [optionsRaw, setOptionsRaw] = useState({});
  const [clients, setClients] = useState([]);
  const [developers, setDevelopers] = useState([]);
  const [marketers, setMarketers] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const lastFetch = useRef(0);
  const fetching = useRef(false);

  const reload = useCallback(async (force = false) => {
    const now = Date.now();
    // منع الاستدعاء المتكرر: 30 ثانية cache إلا إذا force=true
    if (!force && (fetching.current || (now - lastFetch.current < 30000 && lastFetch.current > 0))) return;
    fetching.current = true;
    try {
      const [o, c, d, m] = await Promise.all([
        refApi.getOptions(), refApi.getClients(), refApi.getDevelopers(), refApi.getMarketers(),
      ]);
      const opts = {};
      const raw = {};
      Object.entries(o.data.options).forEach(([k, arr]) => {
        opts[k] = arr.map(i => i.label);
        raw[k] = arr;
      });
      setOptions(opts);
      setOptionsRaw(raw);
      setClients(c.data.items);
      setDevelopers(d.data.items);
      setMarketers(m.data.items);
      lastFetch.current = Date.now();
    } catch (e) { console.error(e); }
    fetching.current = false;
    setLoaded(true);
  }, []);

  // reload مرة واحدة عند التحميل
  useEffect(() => { reload(true); }, [reload]);
  // v3.4.134 — إعادة تحميل المراجع فورًا عند تعديل القوائم في الإعدادات (حدث rael:refs-changed) وعند العودة للتبويب
  useEffect(() => {
    const onChanged = () => reload(true);
    const onFocus = () => reload();
    window.addEventListener("rael:refs-changed", onChanged);
    window.addEventListener("focus", onFocus);
    return () => { window.removeEventListener("rael:refs-changed", onChanged); window.removeEventListener("focus", onFocus); };
  }, [reload]);

  return <RefContext.Provider value={{ options, optionsRaw, clients, developers, marketers, reload, loaded }}>{children}</RefContext.Provider>;
}
const useRef2 = () => useContext(RefContext);

// =============================================
const STATUS_COLORS = { "تمت العمليه": "#22c55e", "لم تتم العمليه": "#ef4444", "بإنتظار إكمال الإجرءات": "#f59e0b", "تمت العمليه بإنتظار الدلاله": "#3b82f6", "تمت العمليه و لايوجد دلاله": "#a855f7" };
const OP_COLORS = { "حجز مسوق داخلي": "#2563eb", "حجز مسوق خارجي": "#059669", "حجز داخلي خارجي": "#d97706" };
const fmt = (n) => n ? Number(n).toLocaleString("en-SA") : "0";

const EMPTY_FORM = {
  serial_number: "", date: new Date().toISOString().slice(0, 10), operation_type: "", client_name: "", client_type: "",
  developer: "", unit_type: "", readiness: "", value: 0, deposit_amount: 0, deposit_status: "", bank_account: "",
  dalala_amount: 0, operation_status: "بإنتظار إكمال الإجرءات", marketer: "", notes: "",
  ext_marketer_share: 0, int_marketer_share: 0, waha_share: 0, sales_mgr_share: 0, mkt_mgr_share: 0, company_share: 0,
  commission_status_res: "", commission_status_acc: "", notes_extra: "",
  purchase_purpose: "",
  // v3.3.162 - حقول اختيار الوحدة
  selected_project_id: null, selected_building_id: null, selected_floor: "", selected_unit_code: "",
  quotation_id: null, // v3.4.601 — عرض السعر الذي بُني عليه الحجز
};

const FIELD_PERMS = {
  date: "can_edit_info", operation_type: "can_edit_info", client_name: "can_edit_info",
  client_type: "can_edit_info", developer: "can_edit_info", unit_type: "can_edit_info",
  readiness: "can_edit_info", marketer: "can_edit_info", operation_status: "can_edit_info", notes: "can_edit_info",
  value: "can_edit_finance", deposit_amount: "can_edit_finance", deposit_status: "can_edit_finance",
  bank_account: "can_edit_finance", dalala_amount: "can_edit_finance", notes_extra: "can_edit_finance",
  ext_marketer_share: "can_edit_commission", int_marketer_share: "can_edit_commission",
  waha_share: "can_edit_commission", sales_mgr_share: "can_edit_commission",
  mkt_mgr_share: "can_edit_commission", company_share: "can_edit_commission",
  commission_status_res: "can_edit_status_res", commission_status_acc: "can_edit_status_acc",
};

const ALL_COLUMNS = [
  { key: "id", label: "#", perm: null },
  { key: "date", label: "التاريخ", perm: "can_edit_info" },
  { key: "operation_status", label: "حالة العملية", perm: "can_edit_info" }, // v3.4.115 — نُقل إلى المقدمة (كان بعد حالة إرجاع العربون)
  { key: "operation_type", label: "نوع العملية", perm: "can_edit_info" },
  { key: "reservation_kind", label: "نوع الحجز", perm: null, readonly: true }, // v3.4.374 — حجز جديد / إعادة بيع - 1 / إعادة بيع - 2
  { key: "client_name", label: "العميل", perm: "can_edit_info" },
  { key: "client_type", label: "نوع العميل", perm: "can_edit_info" },
  { key: "developer", label: "المطور", perm: "can_edit_info" },
  { key: "unit_type", label: "الوحدة", perm: "can_edit_info" },
  { key: "readiness", label: "الجاهزية", perm: "can_edit_info" },
  { key: "purchase_purpose", label: "هدف الشراء", perm: "can_edit_info" },
  { key: "value", label: "القيمة", perm: "can_edit_finance" },
  { key: "deposit_amount", label: "العربون", perm: "can_edit_finance" },
  { key: "deposit_status", label: "حالة العربون", perm: "can_edit_finance" },
  { key: "bank_account", label: "الحساب", perm: "can_edit_finance" },
  { key: "dalala_amount", label: "الدلالة", perm: "can_edit_finance" },
  { key: "dalala_status", label: "حالة صرف الدلالة", perm: null, readonly: true },
  { key: "arboun_status", label: "حالة إرجاع العربون", perm: null, readonly: true },
  { key: "marketer", label: "المسوق", perm: "can_edit_info" },
  { key: "notes", label: "ملاحظات", perm: "can_edit_info" },
  { key: "ext_marketer_share", label: "خارجي", perm: "can_edit_commission" },
  { key: "int_marketer_share", label: "داخلي", perm: "can_edit_commission" },
  { key: "waha_share", label: "الإدارة", perm: "can_edit_commission" }, // v3.4.120 — كان «الواحة»
  { key: "sales_mgr_share", label: "م.مبيعات", perm: "can_edit_commission" },
  { key: "mkt_mgr_share", label: "م.مسوقات", perm: "can_edit_commission" },
  { key: "company_share", label: "الشركة", perm: "can_edit_commission" },
  { key: "commission_status_res", label: "حالة(إدارة)", perm: "can_edit_status_res" },
  { key: "commission_status_acc", label: "حالة(محاسبة)", perm: "can_edit_status_acc" },
  { key: "notes_extra", label: "ملاحظات٢", perm: "can_edit_finance" },
];

// =============================================
// POPUP for adding new client/developer/marketer
// =============================================
function AddPopup({ type, onClose, onAdded }) {
  const [name, setName] = useState("");
  const [extra, setExtra] = useState({});
  const { reload } = useRef2();

  const handleSave = async () => {
    if (!name.trim()) return toast.error("الاسم مطلوب");
    try {
      // v3.3.741 — حارس التكرار للعملاء والمسوقين
      if (type === "client") await addWithDupGuard(refApi.addClient, { name, client_type: extra.client_type || "", phone: extra.phone || "" });
      else if (type === "developer") await refApi.addDeveloper({ name });
      else if (type === "marketer") await addWithDupGuard(refApi.addMarketer, { name, office: extra.office || "", phone: extra.phone || "" });
      toast.success("تمت الإضافة");
      reload();
      onAdded(name);
      onClose();
    } catch (e) { toast.error(e.response?.data?.error || "فشل الإضافة"); }
  };

  const titles = { client: "إضافة عميل جديد", developer: "إضافة مطور جديد", marketer: "إضافة مسوق جديد" };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center" }} onClick={onClose}>
      <div style={{ background: "#fff", borderRadius: 12, padding: 24, width: 380, boxShadow: "0 8px 30px rgba(0,0,0,0.15)" }} onClick={e => e.stopPropagation()}>
        <h3 style={{ fontSize: 16, marginBottom: 14 }}>{titles[type]}</h3>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <div><label style={{ fontSize: 11, color: "#64748b" }}>الاسم *</label>
            <input value={name} onChange={e => setName(e.target.value)} autoFocus style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontFamily: "inherit", fontSize: 13, marginTop: 3 }} /></div>
          {/* v3.3.749 — إدخال جوال موحّد (تحويل عربي، لا فراغات، تحقق سعودي، زر دولي) */}
          {type === "client" && <>
            <div><label style={{ fontSize: 11, color: "#64748b" }}>رقم الجوال</label>
              <div style={{ marginTop: 3 }}>
                <PhoneInput value={extra.phone || ""} intl={extra._phone_intl}
                  onChange={v => setExtra({ ...extra, phone: v })} onIntlChange={v => setExtra({ ...extra, _phone_intl: v })} />
              </div></div>
          </>}
          {type === "marketer" && <>
            <div><label style={{ fontSize: 11, color: "#64748b" }}>المكتب</label>
              <input value={extra.office || ""} onChange={e => setExtra({ ...extra, office: e.target.value })} style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontFamily: "inherit", fontSize: 13, marginTop: 3 }} /></div>
            <div><label style={{ fontSize: 11, color: "#64748b" }}>رقم الجوال</label>
              <div style={{ marginTop: 3 }}>
                <PhoneInput value={extra.phone || ""} intl={extra._phone_intl}
                  onChange={v => setExtra({ ...extra, phone: v })} onIntlChange={v => setExtra({ ...extra, _phone_intl: v })} />
              </div></div>
          </>}
        </div>
        <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
          <button onClick={handleSave} style={{ flex: 1, padding: "9px", background: "#2563eb", color: "#fff", border: "none", borderRadius: 7, fontFamily: "inherit", fontSize: 13, cursor: "pointer" }}>إضافة واختيار</button>
          <button onClick={onClose} style={{ padding: "9px 16px", background: "#f1f5f9", border: "1px solid #e2e8f0", borderRadius: 7, fontFamily: "inherit", fontSize: 13, cursor: "pointer" }}>إلغاء</button>
        </div>
      </div>
    </div>
  );
}


// =============================================
// SEARCHABLE SELECT - dropdown with search (متطلب 2)
// =============================================
function SearchableSelect({ label, value, options, onChange, span2, readOnly }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const optList = options || [];
  // القيمة غير موجودة في القائمة = تحذير بالأحمر
  const isUnknown = value && value.trim() !== "" && !optList.includes(value);
  const filtered = optList.filter(o => o.toLowerCase().includes(q.toLowerCase()));
  const display = value || "";

  if (readOnly) return (
    <div className={"field" + (span2 ? " span2" : "")}><label>{label}</label>
      <div style={{ padding:"8px 10px", border:"1px solid "+(isUnknown?"#fca5a5":"#e2e8f0"), borderRadius:6, fontSize:13, background:isUnknown?"#fff1f2":"#f8fafc", color:isUnknown?"#dc2626":"#64748b" }}>
        {display || "—"}{isUnknown && <span title="هذه القيمة غير موجودة في قائمة الإعدادات" style={{marginRight:6,fontSize:11}}>⚠️</span>}
      </div>
    </div>
  );

  return (
    <div className={"field" + (span2 ? " span2" : "")} ref={ref}>
      <label>{label}</label>
      <div style={{ position:"relative" }}>
        <div onClick={() => { if (!readOnly) { setOpen(o => !o); setQ(""); } }}
          style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"8px 10px",
            border:"1px solid "+(open?"#93c5fd":isUnknown?"#fca5a5":"#e2e8f0"),
            borderRadius:6, cursor:"pointer", background:isUnknown?"#fff1f2":"#fff", fontSize:13, userSelect:"none" }}>
          <span style={{ color: isUnknown ? "#dc2626" : display ? "#1e293b" : "#94a3b8", display:"flex", alignItems:"center", gap:6 }}>
            {isUnknown && <span title="هذه القيمة غير موجودة في قائمة الإعدادات">⚠️</span>}
            {display || "اختر..."}
          </span>
          <span style={{ color:"#94a3b8", fontSize:10 }}>{open?"▲":"▼"}</span>
        </div>
        {open && (
          <div style={{ position:"absolute", top:"calc(100% + 2px)", right:0, left:0, background:"#fff", border:"1px solid #e2e8f0", borderRadius:8, zIndex:999, boxShadow:"0 4px 16px rgba(0,0,0,0.12)", maxHeight:240, display:"flex", flexDirection:"column" }}>
            <div style={{ padding:"6px 8px", borderBottom:"1px solid #f1f5f9" }}>
              <input autoFocus value={q} onChange={e => setQ(e.target.value)}
                placeholder="بحث..." onClick={e => e.stopPropagation()}
                style={{ width:"100%", padding:"5px 8px", border:"1px solid #e2e8f0", borderRadius:5, fontFamily:"inherit", fontSize:12, outline:"none" }} />
            </div>
            <div style={{ overflowY:"auto", flex:1 }}>
              <div onClick={() => { onChange(""); setOpen(false); }}
                style={{ padding:"7px 12px", cursor:"pointer", color:"#94a3b8", fontSize:12 }}>-- اختر --</div>
              {/* إذا القيمة غير موجودة اعرضها أولاً بتحذير */}
              {isUnknown && (
                <div style={{ padding:"7px 12px", background:"#fff1f2", borderBottom:"1px solid #fecaca" }}>
                  <div style={{ fontSize:11, color:"#dc2626", marginBottom:3 }}>⚠️ القيمة الحالية غير موجودة في الإعدادات:</div>
                  <div style={{ fontSize:13, color:"#dc2626", fontWeight:600 }}>{value}</div>
                  <div style={{ fontSize:11, color:"#ef4444", marginTop:2 }}>اختر بديلاً من القائمة أو أضف هذه القيمة في الإعدادات</div>
                </div>
              )}
              {filtered.length === 0 && <div style={{ padding:"10px 12px", color:"#94a3b8", fontSize:12 }}>لا توجد نتائج</div>}
              {filtered.map(o => (
                <div key={o} onClick={() => { onChange(o); setOpen(false); }}
                  style={{ padding:"7px 12px", cursor:"pointer", fontSize:13, background: value===o ? "#eff6ff" : "transparent", color: value===o ? "#2563eb" : "#1e293b", fontWeight: value===o ? 600 : 400 }}
                  onMouseEnter={e => { if (value!==o) e.currentTarget.style.background="#f8fafc"; }}
                  onMouseLeave={e => { if (value!==o) e.currentTarget.style.background="transparent"; }}>
                  {o}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}


// =============================================
// SELECT WITH ADD + SEARCH (متطلب 2)
// =============================================
function SelectWithAdd({ label, value, items, onChange, addType, span2, multi }) {
  const [showAdd, setShowAdd] = useState(false);
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const wRef = useRef(null);
  const { reload, loaded } = useRef2();

  useEffect(() => {
    const handler = (e) => { if (wRef.current && !wRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  // Reload items when dropdown opens if items are empty
  const handleOpen = () => {
    setOpen(o => !o);
    setQ("");
    if ((!items || items.length === 0) && !loaded) {
      reload(true);
    }
  };

  const list = (items || []).map(i => typeof i === "string" ? { id: i, name: i } : i);
  const filtered = list.filter(i => {
    if (!i.name) return false;
    const searchTerm = q.toLowerCase().replace('#', '');
    // Search by name OR by ID
    return i.name.toLowerCase().includes(searchTerm) || String(i.id).includes(searchTerm);
  });
  const selected = multi ? (Array.isArray(value) ? value : []) : [];
  const selectedIds = selected.map(x => String(x.id));

  const toggleItem = (item) => {
    if (!multi) { onChange(item.name); setOpen(false); return; }
    const already = selectedIds.includes(String(item.id));
    if (already) onChange(selected.filter(x => String(x.id) !== String(item.id)));
    else onChange([...selected, { id: item.id, name: item.name }]);
  };

  const removeItem = (id) => onChange(selected.filter(x => String(x.id) !== String(id)));
  const display = multi ? null : (value || null);

  return (
    <div className={"field" + (span2 ? " span2" : "")} ref={wRef}>
      <label>{label}{multi && <span style={{color:"#94a3b8",fontWeight:400,fontSize:11}}> (متعدد)</span>}</label>
      <div style={{ display:"flex", gap:4 }}>
        <div style={{ flex:1, position:"relative" }}>
          <div onClick={handleOpen}
            style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"6px 10px", border:"1px solid "+(open?"#93c5fd":"#e2e8f0"), borderRadius:6, cursor:"pointer", background:"#fff", fontSize:13, userSelect:"none", minHeight:36, flexWrap:"wrap", gap:4 }}>
            {multi && selected.length > 0 ? (
              <div style={{ display:"flex", flexWrap:"wrap", gap:3, flex:1 }}>
                {selected.map(x => (
                  <span key={x.id} style={{ background:"#eff6ff", color:"#2563eb", padding:"2px 8px", borderRadius:12, fontSize:12, display:"flex", alignItems:"center", gap:4 }}>
                    {/* v3.3.561 — Show the entity ID badge next to the name so the user can see
                        which exact entity is linked (and tell apart similar names) */}
                    {x.id && !String(x.id).startsWith("_new_") && (
                      <span style={{
                        background:"#1d4ed8", color:"#fff",
                        padding:"0 5px", borderRadius:8,
                        fontSize:9, fontWeight:700, fontFamily:"monospace",
                      }}>#{x.id}</span>
                    )}
                    {x.name}
                    <span onClick={e => { e.stopPropagation(); removeItem(x.id); }} style={{ cursor:"pointer", color:"#93c5fd", fontWeight:700 }}>x</span>
                  </span>
                ))}
              </div>
            ) : (
              <span style={{ color: display ? "#1e293b" : "#94a3b8" }}>{display || "اختر..."}</span>
            )}
            <span style={{ color:"#94a3b8", fontSize:10 }}>{open?"▲":"▼"}</span>
          </div>
          {open && (
            <div style={{ position:"absolute", top:"calc(100% + 2px)", right:0, left:0, background:"#fff", border:"1px solid #e2e8f0", borderRadius:8, zIndex:9999, boxShadow:"0 4px 16px rgba(0,0,0,0.12)", maxHeight:240, display:"flex", flexDirection:"column" }}>
              <div style={{ padding:"6px 8px", borderBottom:"1px solid #f1f5f9" }}>
                <input autoFocus value={q} onChange={e => setQ(e.target.value)} placeholder="بحث..." onClick={e => e.stopPropagation()}
                  style={{ width:"100%", padding:"5px 8px", border:"1px solid #e2e8f0", borderRadius:5, fontFamily:"inherit", fontSize:12, outline:"none" }} />
              </div>
              <div style={{ overflowY:"auto", flex:1 }}>
                {!multi && <div onClick={() => { onChange(""); setOpen(false); }} style={{ padding:"7px 12px", cursor:"pointer", color:"#94a3b8", fontSize:12 }}>-- اختر --</div>}
                {filtered.length === 0 && <div style={{ padding:"10px 12px", color:"#94a3b8", fontSize:12 }}>لا توجد نتائج</div>}
                {filtered.map(item => {
                  const isSel = multi ? selectedIds.includes(String(item.id)) : value === item.name;
                  // Show ID for clients, developers, marketers (unique database ID)
                  const showId = ["client", "developer", "marketer"].includes(addType);
                  return (
                    <div key={item.id} onClick={() => toggleItem(item)}
                      style={{ padding:"7px 12px", cursor:"pointer", fontSize:13, display:"flex", alignItems:"center", gap:8, background: isSel ? "#eff6ff" : "transparent", color: isSel ? "#2563eb" : "#1e293b", fontWeight: isSel ? 600 : 400 }}>
                      {multi && <span style={{ width:16, height:16, border:"2px solid "+(isSel?"#2563eb":"#cbd5e1"), borderRadius:4, background:isSel?"#2563eb":"#fff", display:"inline-flex", alignItems:"center", justifyContent:"center", flexShrink:0, fontSize:10, color:"#fff" }}>{isSel && "v"}</span>}
                      {showId && <span style={{ background:"#f1f5f9", color:"#64748b", padding:"1px 6px", borderRadius:4, fontSize:10, fontWeight:600, fontFamily:"monospace", flexShrink:0 }}>#{item.id}</span>}
                      {item.name}
                    </div>
                  );
                })}
              </div>
              {multi && selected.length > 0 && <div style={{ padding:"6px 10px", borderTop:"1px solid #f1f5f9", fontSize:12, color:"#64748b" }}>تم اختيار {selected.length}</div>}
            </div>
          )}
        </div>
        <button onClick={() => setShowAdd(true)} style={{ width:34, background:"#eff6ff", border:"1px solid #bfdbfe", borderRadius:6, color:"#2563eb", cursor:"pointer", fontSize:16, display:"flex", alignItems:"center", justifyContent:"center" }} title="اضافة جديد">+</button>
      </div>
      {showAdd && <AddPopup type={addType} onClose={() => setShowAdd(false)} onAdded={name => { reload(true); if (!multi) onChange(name); }} />}
    </div>
  );
}

// =============================================
// INPUT FIELD (stable)
// =============================================
function InputField({ label, value, onChange, type = "text", options, span2, readOnly, min, max }) { // v3.4.126 — min/max للنسب
  if (options) return (
    <div className={`field ${span2 ? "span2" : ""}`}><label>{label}</label>
      <select value={value || ""} onChange={e => onChange(e.target.value)} disabled={readOnly}>
        <option value="">اختر...</option>{options.map(o => <option key={o} value={o}>{o}</option>)}
      </select></div>
  );
  if (type === "textarea") return (
    <div className={`field ${span2 ? "span2" : ""}`}><label>{label}</label>
      <textarea defaultValue={value || ""} onBlur={e => onChange(e.target.value)} rows={2} readOnly={readOnly} /></div>
  );
  if (type === "checkbox") return (
    <div className={`field ${span2 ? "span2" : ""}`}><label>{label}</label>
      <label className="check-label"><input type="checkbox" checked={value || false} onChange={e => onChange(e.target.checked)} disabled={readOnly} /><span>نعم</span></label></div>
  );
  return (
    <div className={`field ${span2 ? "span2" : ""}`}><label>{label}</label>
      <input type={type} defaultValue={value ?? ""} min={min} max={max}
        onBlur={e => {
          if (type !== "number") return onChange(e.target.value);
          let v = Number(e.target.value) || 0;
          if (max != null && v > max) v = max; // v3.4.126 — النسبة لا تتجاوز 100
          if (min != null && v < min) v = min;
          if (String(v) !== e.target.value) e.target.value = v;
          onChange(v);
        }}
        onKeyDown={e => { if (e.key === "Enter") e.target.blur(); }} readOnly={readOnly} /></div>
  );
}



// =============================================
// ENTITY RESERVATIONS PANEL
// =============================================
function EntityReservationsPanel({ entity, onClose, onOpenReservation }) {
  const [reservations, setReservations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [resolvedId, setResolvedId] = useState(null);
  const [resolveStatus, setResolveStatus] = useState(null); // 'resolving'|'resolved'|'not_found'|'ambiguous'
  const { optionsRaw } = useRef2();

  useEffect(() => {
    if (!entity) return;
    setLoading(true);
    setResolvedId(null);

    // v3.3.560 — If entity already has a real ID, use it directly.
    // If not, resolve by exact name match — and ONLY filter by junction ID, NEVER by name
    // (to avoid pulling reservations of different people with similar names, e.g.
    // "أحمد عبده" pulling "أحمد عبده يماني").
    const fetchWithId = async (id) => {
      const params = { limit: 9999 };
      if (entity.type === "marketer") params.linked_marketer_id = id;
      else if (entity.type === "developer") params.linked_developer_id = id;
      else if (entity.type === "client") params.linked_client_id = id;
      const r = await resApi.list(params);
      setReservations(r.data.reservations || []);
      setLoading(false);
    };

    if (entity.id) {
      setResolvedId(entity.id);
      setResolveStatus('resolved');
      fetchWithId(entity.id).catch(() => setLoading(false));
      return;
    }

    // No ID — try to resolve by exact name match
    setResolveStatus('resolving');
    const fetchEntityList = entity.type === "marketer" ? refApi.getMarketers
                          : entity.type === "developer" ? refApi.getDevelopers
                          : refApi.getClients;
    fetchEntityList().then(r => {
      // refApi returns the array directly or under a key — handle both
      const data = r.data;
      const list = Array.isArray(data) ? data
                 : data?.marketers || data?.developers || data?.clients || data?.items || [];
      // Exact, case-insensitive, whitespace-normalized match
      const norm = s => String(s || "").trim().replace(/\s+/g, " ");
      const target = norm(entity.name);
      const matches = list.filter(x => norm(x.name) === target);
      if (matches.length === 1) {
        setResolvedId(matches[0].id);
        setResolveStatus('resolved');
        fetchWithId(matches[0].id);
      } else if (matches.length > 1) {
        // Ambiguous — multiple entities with the same exact name
        setResolveStatus('ambiguous');
        setReservations([]);
        setLoading(false);
      } else {
        // No match at all — this entity isn't in the database
        setResolveStatus('not_found');
        setReservations([]);
        setLoading(false);
      }
    }).catch(() => { setLoading(false); setResolveStatus('not_found'); });
  }, [entity]);

  if (!entity) return null;

  const typeLabel = entity.type === "marketer" ? "مسوق" : entity.type === "developer" ? "مطور" : "عميل";
  const typeIcon = entity.type === "marketer" ? "👤" : entity.type === "developer" ? "🏗️" : "🏠";

  const totalValue = reservations.reduce((s, r) => s + (Number(r.value) || 0), 0);
  const totalDalala = reservations.reduce((s, r) => s + (Number(r.dalala_amount) || 0), 0);
  const completed = reservations.filter(r => r.operation_status === "تمت العمليه").length;

  const getStatusColor = (status) => {
    if (status === "تمت العمليه") return "#22c55e";
    if (status === "لم تتم العمليه") return "#ef4444";
    return "#f59e0b";
  };

  return (
    <div className="overlay" onClick={onClose}>
      <div className="side-panel" dir="rtl" onClick={e => e.stopPropagation()} style={{ width: 680, maxWidth:"95vw" }}>

        {/* Header */}
        <div className="panel-head" style={{ background:"linear-gradient(135deg,#1e293b,#334155)" }}>
          <div>
            <div style={{ fontSize:12, color:"#94a3b8", marginBottom:4 }}>{typeIcon} {typeLabel}</div>
            <h2 style={{ color:"#fff", margin:0, fontSize:18 }}>{entity.name}</h2>
            {/* v3.3.560 — Show resolution status */}
            {resolvedId && (
              <div style={{ fontSize:10, color:"#94a3b8", marginTop:4 }}>
                ID: <span style={{ fontFamily:"monospace", color:"#cbd5e1" }}>#{resolvedId}</span>
              </div>
            )}
          </div>
          <button className="btn-icon" onClick={onClose} style={{ color:"#fff" }}><FiX size={20}/></button>
        </div>

        {/* v3.3.560 — Warning banner for ambiguous/not_found resolution */}
        {resolveStatus === 'ambiguous' && (
          <div style={{
            background:"#fef3c7", border:"1px solid #fcd34d",
            padding:"10px 14px", fontSize:12, color:"#92400e",
            borderBottom:"1px solid #e2e8f0",
          }}>
            ⚠️ يوجد أكثر من {typeLabel} بنفس الاسم في قاعدة البيانات.
            لا يمكن تحديد {typeLabel} الصحيح للفلترة.
            <br />
            <span style={{ fontSize:11 }}>افتح حجزاً يحتويه وأعد ربطه من قسم التعديل لتحديد الأيقونة بدقة.</span>
          </div>
        )}
        {resolveStatus === 'not_found' && (
          <div style={{
            background:"#fee2e2", border:"1px solid #fca5a5",
            padding:"10px 14px", fontSize:12, color:"#991b1b",
            borderBottom:"1px solid #e2e8f0",
          }}>
            ⚠️ {typeLabel} "{entity.name}" غير موجود في قاعدة بيانات {typeLabel}ين.
            <br />
            <span style={{ fontSize:11 }}>هذا اسم نصي قديم — افتح الحجز وأعد ربطه باستخدام القائمة المنسدلة.</span>
          </div>
        )}

        {/* Stats */}
        {!loading && (
          <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:1, background:"#e2e8f0", borderBottom:"1px solid #e2e8f0" }}>
            {[
              { label:"إجمالي الحجوزات", value: reservations.length, color:"#2563eb" },
              { label:"مكتملة", value: completed, color:"#22c55e" },
              { label:"إجمالي القيمة", value: fmt(totalValue)+" ر.س", color:"#7c3aed" },
              { label:"إجمالي الدلالة", value: fmt(totalDalala)+" ر.س", color:"#f59e0b" },
            ].map(s => (
              <div key={s.label} style={{ background:"#fff", padding:"12px 16px", textAlign:"center" }}>
                <div style={{ fontSize:18, fontWeight:800, color:s.color }}>{s.value}</div>
                <div style={{ fontSize:11, color:"#64748b", marginTop:2 }}>{s.label}</div>
              </div>
            ))}
          </div>
        )}

        {/* List */}
        <div style={{ flex:1, overflowY:"auto" }}>
          {loading ? (
            <div style={{ padding:40, textAlign:"center", color:"#94a3b8" }}>جاري التحميل...</div>
          ) : reservations.length === 0 ? (
            <div style={{ padding:40, textAlign:"center", color:"#94a3b8" }}>لا توجد حجوزات</div>
          ) : (
            <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
              <thead>
                <tr style={{ background:"#f8fafc", borderBottom:"2px solid #e2e8f0" }}>
                  {["#","التاريخ","نوع العملية","العميل","المطور","القيمة","الحالة"].map(h => (
                    <th key={h} style={{ padding:"8px 12px", textAlign:"right", fontWeight:600, color:"#64748b", fontSize:11, whiteSpace:"nowrap" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {reservations.map((r, i) => (
                  <tr key={r.id} onClick={() => onOpenReservation(r.id)}
                    style={{ borderBottom:"1px solid #f1f5f9", cursor:"pointer", transition:"background 0.1s" }}
                    onMouseEnter={e => e.currentTarget.style.background="#f8fafc"}
                    onMouseLeave={e => e.currentTarget.style.background="transparent"}>
                    <td style={{ padding:"8px 12px" }}>
                      <span 
                        onClick={(e) => { e.stopPropagation(); onOpenReservation(r.id); }}
                        style={{ 
                          color:"#2563eb", 
                          fontWeight:700, 
                          cursor:"pointer",
                          background:"#eff6ff",
                          padding:"3px 8px",
                          borderRadius:6,
                          border:"1px solid #bfdbfe",
                          display:"inline-flex",
                          alignItems:"center",
                          gap:4
                        }}
                        title={`اضغط لفتح الحجز #${r.id}`}>
                        {/* v3.3.562 — Use only the internal id everywhere; serial_number stays in DB but is hidden */}
                        #{r.id} <span style={{ fontSize:10, opacity:0.7 }}>↗</span>
                      </span>
                    </td>
                    <td style={{ padding:"8px 12px", color:"#64748b", whiteSpace:"nowrap" }}>{r.date?.slice(0,10)}</td>
                    <td style={{ padding:"8px 12px" }}>
                      <span style={{ background: r.operation_type?.includes("خارجي") ? "#dbeafe" : "#f0fdf4", color: r.operation_type?.includes("خارجي") ? "#2563eb" : "#166534", padding:"2px 8px", borderRadius:12, fontSize:11, whiteSpace:"nowrap" }}>
                        {r.operation_type}
                      </span>
                    </td>
                    <td style={{ 
                      padding:"8px 12px", 
                      fontWeight:600, 
                      maxWidth:120, 
                      overflow:"hidden", 
                      textOverflow:"ellipsis", 
                      whiteSpace:"nowrap",
                      background: (!r.linked_clients?.length && r.client_name) ? "#fef2f2" : "transparent",
                      color: (!r.linked_clients?.length && r.client_name) ? "#dc2626" : "inherit"
                    }}
                      title={(!r.linked_clients?.length && r.client_name) ? "⚠️ غير مربوط - اضغط لتعديل الحجز وربط العميل" : ""}
                    >
                      {r.linked_clients?.length ? (
                        r.linked_clients.map(c=>c.name).join("، ")
                      ) : (
                        <>{r.client_name} {r.client_name && <span style={{ fontSize:10 }}>⚠️</span>}</>
                      )}
                    </td>
                    <td style={{ 
                      padding:"8px 12px", 
                      maxWidth:100, 
                      overflow:"hidden", 
                      textOverflow:"ellipsis", 
                      whiteSpace:"nowrap",
                      background: (!r.linked_developers?.length && r.developer) ? "#fef2f2" : "transparent",
                      color: (!r.linked_developers?.length && r.developer) ? "#dc2626" : "#64748b"
                    }}
                      title={(!r.linked_developers?.length && r.developer) ? "⚠️ غير مربوط - اضغط لتعديل الحجز وربط المطور" : ""}
                    >
                      {r.linked_developers?.length ? (
                        r.linked_developers.map(d=>d.name).join("، ")
                      ) : (
                        <>{r.developer} {r.developer && <span style={{ fontSize:10 }}>⚠️</span>}</>
                      )}
                    </td>
                    <td style={{ padding:"8px 12px", fontWeight:700, color:"#7c3aed", textAlign:"left", direction:"ltr" }}>
                      {fmt(r.value)}
                    </td>
                    <td style={{ padding:"8px 12px" }}>
                      <span style={{ background: getStatusColor(r.operation_status)+"22", color: getStatusColor(r.operation_status), padding:"2px 8px", borderRadius:12, fontSize:11, whiteSpace:"nowrap" }}>
                        {r.operation_status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

      </div>
    </div>
  );
}

// =============================================
// LINKED UNIT PAYMENTS SUMMARY - ملخص السداد من الوحدة المربوطة (للعرض فقط)
// =============================================
function LinkedUnitPaymentsSummary({ unitId, reservation }) {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);

  const priceSale = Number(reservation?.value) || 0;
  const totalPayments = payments.reduce((s, p) => s + Number(p.amount), 0);
  // المتبقي = سعر البيع تنفيذ - الدفعات المسددة (بدون العربون)
  const remaining = priceSale - totalPayments;

  useEffect(() => {
    if (!unitId) { setLoading(false); return; }
    const load = async () => {
      try {
        // Use fetch directly to get unit payments from projects API
        const response = await fetch(`${window.location.origin}/api/projects/units/${unitId}/payments`, { /* v3.4.482 */
          credentials: 'include'
        });
        const data = await response.json();
        setPayments(data.payments || []);
      } catch (e) { 
        console.error(e);
      }
      setLoading(false);
    };
    load();
  }, [unitId]);

  if (loading) return <div style={{ padding:16, textAlign:"center", color:"#94a3b8", fontSize:12 }}>جاري التحميل...</div>;

  return (
    <div style={{ background:"#eff6ff", border:"1px solid #bfdbfe", borderRadius:10, padding:16, marginTop:16 }}>
      <div style={{ fontWeight:600, color:"#1d4ed8", marginBottom:12, fontSize:14 }}>💳 ملخص السداد</div>
      <div style={{ fontSize:11, color:"#64748b", marginBottom:10 }}>— يُعرض من الوحدة المربوطة (للتعديل اذهب لصفحة المشاريع)</div>
      
      <div style={{ background:"#fff", borderRadius:8, padding:12 }}>
        <div style={{ display:"flex", justifyContent:"space-between", fontSize:12, marginBottom:6 }}>
          <span style={{ color:"#64748b" }}>الدفعات المسددة</span>
          <span style={{ fontWeight:600, color:"#059669" }}>{fmt(totalPayments)} ر.س</span>
        </div>
        <div style={{ display:"flex", justifyContent:"space-between", fontSize:13, fontWeight:700, paddingTop:8, borderTop:"1px solid #e2e8f0" }}>
          <span style={{ color:"#dc2626" }}>المتبقي</span>
          <span style={{ color:"#dc2626" }}>{fmt(remaining)} ر.س</span>
        </div>
      </div>
    </div>
  );
}

// =============================================
// =============================================
// RESERVATION PANEL (View + Edit)
// =============================================
function WizardSidePanel({ record, isNew, onClose, onSave, onDelete, permissions, allowedColumnKeys, prefillQuoteId, prefillUnit }) { // v3.4.607 prefillQuoteId — حجز جديد من عرض سعر · v3.4.608 prefillUnit — من لوحة الوحدة
  const { user } = useAuth();
  const navigate = useNavigate(); // v3.4.119 — فتح الوحدة المرتبطة في صفحة المشاريع
  const { options, optionsRaw, clients, developers, marketers, reload, loaded } = useRef2(); // v3.4.127 optionsRaw لأنواع التوزيع
  useEffect(() => { reload(); }, [reload]); // v3.4.134 — تحديث القوائم عند فتح النموذج (يحترم كاش 30 ثانية)
  const p = permissions || {};
  const isAdmin = user?.role === "admin" && !user?.impersonating;
  // For existing records, old perm flags still control editability per section
  // For new records (isNew), any visible column is editable
  // v3.4.111 — الحجز المباع مقفل: بعد تحويل وحدته إلى «مُباع» لا يعدّله إلا الأدمن (الخلفية تمنع أيضًا)
  const soldLocked = !isNew && !!record?.sold_locked;
  const canEdit = !(soldLocked && !isAdmin) && (isNew || p.can_edit_info || p.can_edit_finance || p.can_edit_commission || p.can_edit_status_res || p.can_edit_status_acc);
  const canEditSection = (permKey) => isNew || p[permKey] || isAdmin;

  // Column visibility: if allowedColumnKeys is set, only those columns are visible/editable
  // null = all columns allowed (admin or no restriction)
  const canSee = (key) => !allowedColumnKeys || allowedColumnKeys.includes(key);
  const canSeeAny = (...keys) => keys.some(k => canSee(k));

  // Reload reference data when panel opens if not loaded
  useEffect(() => {
    if (!loaded || clients.length === 0 || developers.length === 0 || marketers.length === 0) {
      reload(true);
    }
  }, [loaded, clients.length, developers.length, marketers.length, reload]);

  const initForm = (rec) => {
    if (!rec) return { ...EMPTY_FORM, client_ids: [], developer_ids: [], marketer_ids: [] };
    
    // Ensure linked arrays exist and have proper structure
    let clientIds = (rec.linked_clients || []).map(x => ({ id: x.id, name: x.name }));
    let developerIds = (rec.linked_developers || []).map(x => ({ id: x.id, name: x.name }));
    let marketerIds = (rec.linked_marketers || []).map(x => ({ id: x.id, name: x.name }));
    
    // للحجوزات القديمة: إذا لا توجد بيانات مرتبطة لكن يوجد نص، حاول إيجاد الربط
    if (clientIds.length === 0 && rec.client_name && clients.length > 0) {
      const names = rec.client_name.split(/[,،]/).map(s => s.trim()).filter(Boolean);
      names.forEach(name => {
        const found = clients.find(c => c.name === name || c.name.includes(name) || name.includes(c.name));
        if (found) clientIds.push({ id: found.id, name: found.name });
      });
    }
    
    if (developerIds.length === 0 && rec.developer && developers.length > 0) {
      const names = rec.developer.split(/[,،]/).map(s => s.trim()).filter(Boolean);
      names.forEach(name => {
        const found = developers.find(d => d.name === name || d.name.includes(name) || name.includes(d.name));
        if (found) developerIds.push({ id: found.id, name: found.name });
      });
    }
    
    if (marketerIds.length === 0 && rec.marketer && marketers.length > 0) {
      const names = rec.marketer.split(/[,،]/).map(s => s.trim()).filter(Boolean);
      names.forEach(name => {
        const found = marketers.find(m => m.name === name || m.name.includes(name) || name.includes(m.name));
        if (found) marketerIds.push({ id: found.id, name: found.name });
      });
    }
    
    // v3.3.558 — Auto-migrate legacy reservations from amounts → percentages.
    // If the record has *_share values but no *_pct values, derive percentages from the
    // amounts at display time. The user can then save, which writes back both columns.
    const dalalaVal = Number(rec.dalala_amount) || 0;
    const hasAnyPct = rec.ext_pct != null || rec.int_pct != null
      || rec.marketer1_pct != null || rec.marketer2_pct != null || rec.dalilak_pct != null
      || rec.waha_pct != null || rec.sales_mgr_pct != null
      || rec.mkt_mgr_pct != null || rec.company_pct != null;
    let migratedPcts = {};
    if (!hasAnyPct && dalalaVal > 0) {
      const extA = Number(rec.ext_marketer_share) || 0;
      const intA = Number(rec.int_marketer_share) || 0;
      const m1A  = Number(rec.marketer1_share) || 0;
      const m2A  = Number(rec.marketer2_share) || 0;
      const dlA  = Number(rec.dalilak_share) || 0;
      const whA  = Number(rec.waha_share) || 0;
      const smA  = Number(rec.sales_mgr_share) || 0;
      const mmA  = Number(rec.mkt_mgr_share) || 0;
      const coA  = Number(rec.company_share) || 0;
      const pct = (n) => dalalaVal > 0 ? Math.round((n / dalalaVal) * 1000) / 10 : 0;
      // For company part: percentages of the COMPANY residual (must sum to 100% locally)
      const companyResidualAmt = whA + smA + mmA + coA;
      const localPct = (n) => companyResidualAmt > 0 ? Math.round((n / companyResidualAmt) * 1000) / 10 : 0;
      migratedPcts = {
        ext_pct: pct(extA),
        int_pct: pct(intA),
        marketer1_pct: pct(m1A),
        marketer2_pct: pct(m2A),
        dalilak_pct: pct(dlA),
        waha_pct: localPct(whA),
        sales_mgr_pct: localPct(smA),
        mkt_mgr_pct: localPct(mmA),
        company_pct: localPct(coA),
      };
    }

    // v3.3.559 — Build marketer_types map from the junction so the UI can show
    // the role assignments saved previously.
    const marketerTypesMap = {};
    (rec.linked_marketers || []).forEach(m => {
      if (m.marketer_type) marketerTypesMap[m.id] = m.marketer_type;
    });

    return {
      ...rec,
      ...migratedPcts,
      date: rec.date?.slice(0, 10) || "",
      client_ids: clientIds,
      developer_ids: developerIds,
      marketer_ids: marketerIds,
      // v3.3.557 — keep raw marketer list accessible to the dalala UI so it can show names
      _linked_marketers: marketerIds.map(m => {
        // Re-attach marketer_type from junction (initForm originally drops it)
        const fromJunction = (rec.linked_marketers || []).find(x => x.id === m.id);
        return { ...m, marketer_type: fromJunction?.marketer_type || null };
      }),
      // v3.3.559 — Map of marketerId → 'internal'|'external'|null for save
      marketer_types: marketerTypesMap,
    };
  };

  const [form, setForm] = useState(() => initForm(isNew ? null : record));
  const [editMode, setEditMode] = useState(isNew);
  const [splitKey, setSplitKey] = useState(0); // v3.4.127 — إعادة تركيب حقول تقسيمة الإدارة والشركة بعد التعبئة التلقائية
  const [intKey, setIntKey] = useState(0); // v3.4.133 — إعادة تركيب حقول بوكس الداخلي بعد التعبئة التلقائية
  const formRef = useRef(form);
  // v3.4.248 — شبكة أمان: أي تحديث للنموذج (حتى عبر setForm مباشرة) يُعكس على المرجع الذي يقرأه زر الحفظ.
  // كان تغيير المسوق يظهر على الشاشة لكن الحفظ يرسل المسوق القديم لأن المرجع لم يُحدّث (#6156).
  useEffect(() => { formRef.current = form; }, [form]);

  // v3.3.751 — الوحدات المرتبطة بهذا الحجز من طرف الوحدة (حجوزات كثيرة غير مربوطة من طرف الحجز
  // بينما الوحدة نفسها مربوطة بها — هذا البوكس يكشف الربط من الجهة الأخرى)
  const [unitSideLinks, setUnitSideLinks] = useState(null); // null = يحمّل
  useEffect(() => {
    if (isNew || !record?.id) { setUnitSideLinks([]); return; }
    let alive = true;
    resApi.getLinkedUnits(record.id)
      .then(r => { if (alive) setUnitSideLinks(r.data.units || []); })
      .catch(() => { if (alive) setUnitSideLinks([]); });
    return () => { alive = false; };
  }, [record?.id, isNew]);

  // Re-initialize form when record changes
  // v3.3.747 — لا تُعاد تهيئة النموذج أثناء وضع التعديل (كانت تمسح تعديلات المستخدم
  // عندما يصل جلب التفاصيل الكاملة أو تحديث خلفي للسجل)
  useEffect(() => {
    if (!isNew && record && !editMode) {
      const f = initForm(record);
      setForm(f);
      formRef.current = f;
    }
    // eslint-disable-next-line
  }, [record, isNew]);
  
  // Re-sync form when entering edit mode to ensure linked data is present
  useEffect(() => {
    if (editMode && !isNew && record) {
      // Force re-initialize the linked data from record
      let clientIds = (record.linked_clients || []).map(x => ({ id: x.id, name: x.name }));
      let developerIds = (record.linked_developers || []).map(x => ({ id: x.id, name: x.name }));
      let marketerIds = (record.linked_marketers || []).map(x => ({ id: x.id, name: x.name }));
      
      // للحجوزات القديمة: إذا لا توجد بيانات مرتبطة لكن يوجد نص، حاول إيجاد الربط
      if (clientIds.length === 0 && record.client_name) {
        const names = record.client_name.split(/[,،]/).map(s => s.trim()).filter(Boolean);
        names.forEach(name => {
          const found = clients.find(c => c.name === name || c.name.includes(name) || name.includes(c.name));
          if (found) clientIds.push({ id: found.id, name: found.name });
        });
      }
      
      if (developerIds.length === 0 && record.developer) {
        const names = record.developer.split(/[,،]/).map(s => s.trim()).filter(Boolean);
        names.forEach(name => {
          const found = developers.find(d => d.name === name || d.name.includes(name) || name.includes(d.name));
          if (found) developerIds.push({ id: found.id, name: found.name });
        });
      }
      
      if (marketerIds.length === 0 && record.marketer) {
        const names = record.marketer.split(/[,،]/).map(s => s.trim()).filter(Boolean);
        names.forEach(name => {
          const found = marketers.find(m => m.name === name || m.name.includes(name) || name.includes(m.name));
          if (found) marketerIds.push({ id: found.id, name: found.name });
        });
      }
      
      setForm(prev => {
        // v3.3.747 — لا تدهس اختيار المستخدم: هذا الـ effect يعاد تشغيله كلما تحدثت
        // قوائم المرجعيات (كل ~30ث)، وكان يعيد المسوق/العميل/المطور للقيم القديمة
        // بصمت أثناء التعديل. الآن نزامن فقط إذا كانت قيمة النموذج ما زالت مطابقة
        // لقيمة السجل الأصلية (أي أن المستخدم لم يغيّرها).
        const userTouched = (prevList, recList) => {
          const p = (prevList || []).map(x => String(x.id)).sort().join(",");
          const r0 = (recList || []).map(x => String(x.id)).sort().join(",");
          return p !== "" && p !== r0;
        };
        const updated = {
          ...prev,
          client_ids: userTouched(prev.client_ids, record.linked_clients) ? prev.client_ids
            : (clientIds.length > 0 ? clientIds : prev.client_ids),
          developer_ids: userTouched(prev.developer_ids, record.linked_developers) ? prev.developer_ids
            : (developerIds.length > 0 ? developerIds : prev.developer_ids),
          marketer_ids: userTouched(prev.marketer_ids, record.linked_marketers) ? prev.marketer_ids
            : (marketerIds.length > 0 ? marketerIds : prev.marketer_ids),
        };
        formRef.current = updated;
        return updated;
      });
    }
  }, [editMode, isNew, record, clients, developers, marketers]);

  const set = (k, v) => { setForm(f => { const u = { ...f, [k]: v }; formRef.current = u; return u; }); };

  // ── Unit Selection State (for developers linked to projects) ──
  const [unitSelectionData, setUnitSelectionData] = useState(null);
  const [loadingUnits, setLoadingUnits] = useState(false);
  
  // Get the selected developer's linked project
  const selectedDeveloper = form.developer_ids?.[0];
  const developerInfo = selectedDeveloper ? developers.find(d => String(d.id) === String(selectedDeveloper.id)) : null;
  const linkedProjectId = developerInfo?.linked_project_id;
  const linkedProjectName = developerInfo?.linked_project_name;
  
  // Load units when developer with linked project is selected
  useEffect(() => {
    if (linkedProjectId && editMode) {
      setLoadingUnits(true);
      import('./services/api').then(({ projects: projectsApi }) => {
        projectsApi.getUnitsForSelection(linkedProjectId)
          .then(res => {
            setUnitSelectionData(res.data.buildings || []);
            setLoadingUnits(false);
          })
          .catch(err => {
            console.error('Failed to load units:', err);
            setLoadingUnits(false);
          });
      });
    } else {
      setUnitSelectionData(null);
    }
  }, [linkedProjectId, editMode]);
  
  // Get floors for selected building
  const selectedBuilding = unitSelectionData?.find(b => b.id === form.selected_building_id);
  const availableFloors = selectedBuilding?.floors || [];
  
  // Get units for selected floor (convert to string for comparison since select returns string)
  const selectedFloorData = availableFloors.find(f => String(f.floor) === String(form.selected_floor));
  const availableUnits = selectedFloorData?.units || [];
  // v3.4.601 — وحدة الحجز لعروض السعر: معرّف الوحدة المختارة من القائمة، وإلا كودها داخل المشروع، وإلا الوحدة المربوطة بالحجز
  const quoteUnit = (() => {
    const code = form.selected_unit_code;
    if (code) {
      const u = availableUnits.find(x => String(x.unit_code || x.unit_number) === String(code));
      return { unitId: u?.id || null, projectId: form.selected_project_id || linkedProjectId || null, unitCode: code };
    }
    return { unitId: (!isNew && record?.linked_unit_id) || null, projectId: null, unitCode: null };
  })();
  const pickQuotation = (q) => setForm(f => {
    const u = { ...f, quotation_id: q.id, value: q.total_price }; // v3.4.607 — قيمة الحجز = السعر النهائي للعرض
    // عميل العرض يُملأ تلقائيًا إن لم يُختر عميل بعد — أو كان العميل الحالي مملوءًا من عرض سابق (تبديل العرض)
    const cur = f.client_ids || [];
    const autoFilled = cur.length === 1 && f._quote_client_id && String(cur[0].id) === String(f._quote_client_id);
    if ((!cur.length || autoFilled) && q.client_id) {
      const c = clients.find(x => String(x.id) === String(q.client_id));
      if (c) { u.client_ids = [{ id: c.id, name: c.name }]; u._quote_client_id = c.id; }
    }
    formRef.current = u; return u;
  });
  const clearQuotation = () => set("quotation_id", null);
  // v3.4.607 — «تحويل العرض إلى حجز» من قائمة العروض: يُعبَّأ الحجز الجديد من العرض (المطوّر المرتبط بالمشروع، العميل، الوحدة، العرض وسعره)
  const [prefillQuote, setPrefillQuote] = useState(null);
  const [quoteCandidates, setQuoteCandidates] = useState(0); // v3.4.608 — عدد العروض السارية على الوحدة المختارة
  const prefillStep = useRef({ base: false, unit: false });
  // v3.4.608 — «إنشاء حجز جديد» من لوحة الوحدة: المطوّر المرتبط بالمشروع والوحدة تُعبَّأ تلقائيًا (والعرض الساري يُختار من المنتقي)
  const prefillTarget = prefillQuote ? { project_id: prefillQuote.project_id, unit_id: prefillQuote.unit_id } : (isNew && !prefillQuoteId && prefillUnit) || null;
  useEffect(() => {
    if (!isNew || prefillQuoteId || !prefillUnit || prefillStep.current.base || !developers.length) return;
    prefillStep.current.base = true;
    const dev = developers.find(d => Number(d.linked_project_id) === Number(prefillUnit.project_id));
    if (!dev) return;
    setForm(f => { const u = { ...f, developer_ids: [{ id: dev.id, name: dev.name }], selected_project_id: prefillUnit.project_id }; formRef.current = u; return u; });
  }, [isNew, prefillQuoteId, prefillUnit, developers]);
  useEffect(() => {
    if (!isNew || !prefillQuoteId) return;
    resApi.quotation(prefillQuoteId).then(r => setPrefillQuote(r.data.quotation)).catch(e => toast.error(e.response?.data?.error || "تعذّر جلب عرض السعر"));
  }, [isNew, prefillQuoteId]);
  useEffect(() => {
    if (!prefillQuote || prefillStep.current.base || !developers.length) return;
    prefillStep.current.base = true;
    if (prefillQuote.expired) toast.error("انتهت صلاحية العرض — مدّده من قائمة العروض قبل إنشاء الحجز");
    const dev = developers.find(d => Number(d.linked_project_id) === Number(prefillQuote.project_id));
    const cl = clients.find(c => String(c.id) === String(prefillQuote.client_id));
    if (!dev) toast("لم يُعثر على مطوّر مرتبط بمشروع العرض — اختر المطوّر والوحدة يدويًا", { icon: "ℹ️" });
    setForm(f => {
      const u = { ...f, quotation_id: prefillQuote.expired ? null : prefillQuote.id, value: prefillQuote.total_price };
      if (prefillQuote.deposit_amount) { u.deposit_amount = prefillQuote.deposit_amount; u.deposit_status = u.deposit_status || "مدفوع"; } // v3.4.617 — من سند قبض العربون
      if (dev) { u.developer_ids = [{ id: dev.id, name: dev.name }]; u.selected_project_id = prefillQuote.project_id; }
      if (cl) { u.client_ids = [{ id: cl.id, name: cl.name }]; u._quote_client_id = cl.id; }
      formRef.current = u; return u;
    });
  }, [prefillQuote, developers, clients]);
  useEffect(() => {
    if (!prefillTarget || !prefillStep.current.base || prefillStep.current.unit || !unitSelectionData) return;
    for (const b of unitSelectionData) for (const fl of (b.floors || [])) {
      const u0 = (fl.units || []).find(x => Number(x.id) === Number(prefillTarget.unit_id));
      if (u0) {
        prefillStep.current.unit = true;
        setForm(f => { const u = { ...f, selected_project_id: prefillTarget.project_id, selected_building_id: b.id, selected_floor: String(fl.floor), selected_unit_code: u0.unit_code || u0.unit_number }; formRef.current = u; return u; });
        return;
      }
    }
  }, [prefillTarget, unitSelectionData]); // eslint-disable-line

  const ext = Number(form.ext_marketer_share) || 0;
  const int_ = Number(form.int_marketer_share) || 0;
  const waha = Number(form.waha_share) || 0;
  const sm = Number(form.sales_mgr_share) || 0;
  const mm = Number(form.mkt_mgr_share) || 0;
  const co = Number(form.company_share) || 0;
  const dalala = Number(form.dalala_amount) || 0;

  // ──────────────────────────────────────────────────────────────────
  // v3.3.557 — Percentage-based dalala distribution
  // ──────────────────────────────────────────────────────────────────
  // All inputs are percentages 0-100. Amounts are computed as percentage × total dalala.
  // The company part is divided by percentages OF THE COMPANY RESIDUAL (must sum to 100%).
  // v3.4.129 — نوع البيعة يحدد الجدول: خارجي فقط = 100/0، داخلي فقط = 0/100، داخلي خارجي = من الحقول
  const __ot = form.operation_type || "";
  const __extOnly = __ot.includes("خارجي") && !__ot.includes("داخلي خارجي") && !__ot.includes("داخلي");
  const __intOnly = (__ot.includes("داخلي") && !__ot.includes("داخلي خارجي")) || __ot.includes("مسوق داخلي");
  const __mixed = __ot.includes("داخلي خارجي");
  const showTop = !__extOnly && !__intOnly;      // جدول التقسيم خارجي/داخلي
  // v3.4.132 — «داخلي خارجي» يتطلب مسوّقَين على الأقل؛ بمسوّق واحد يجب اختيار داخلي أو خارجي فقط
  const mixedNeedsTwo = __mixed && (form.marketer_ids || []).length < 2;
  const showExtBox = __extOnly || __mixed || (!__intOnly && !__mixed && (Number(form.ext_pct) || 0) > 0);
  const showIntBox = !__extOnly;
  const extPct = __extOnly ? 100 : __intOnly ? 0 : (Number(form.ext_pct) || 0);
  const intPct = __extOnly ? 0 : __intOnly ? 100 : (Number(form.int_pct) || 0);
  // المسوّقان الخارجيان: إن لم يُدخل شيء يأخذ الأول كامل حصة الخارجي
  const __e1in = form.ext1_pct !== undefined && form.ext1_pct !== null && String(form.ext1_pct).trim() !== "";
  const __e2in = form.ext2_pct !== undefined && form.ext2_pct !== null && String(form.ext2_pct).trim() !== "";
  const ext2Pct = __e2in ? (Number(form.ext2_pct) || 0) : 0;
  const ext1Pct = __e1in ? (Number(form.ext1_pct) || 0) : Math.max(0, Math.round((extPct - ext2Pct) * 100) / 100);
  // v3.4.819 — حجز «خارجي فقط»: صندوق الداخلي مخفي، فنسب المسوّقين الداخليين/الإدارة المتبقية من نوع سابق (مثل #6187: 25%) تُهمل
  // بدل أن تمنع الحفظ برسالة «مجموع المسوّقين يتجاوز الحصة الداخلية (0%)»
  const marketer1Pct = __extOnly ? 0 : (Number(form.marketer1_pct) || 0);
  const marketer2Pct = __extOnly ? 0 : (Number(form.marketer2_pct) || 0);
  const dalilakPct = __extOnly ? 0 : (Number(form.dalilak_pct) || 0);
  const wahaPct = __extOnly ? 0 : (Number(form.waha_pct) || 0);
  const salesMgrPct = __extOnly ? 0 : (Number(form.sales_mgr_pct) || 0);
  const mktMgrPct = __extOnly ? 0 : (Number(form.mkt_mgr_pct) || 0);
  const companyPct = __extOnly ? 0 : (Number(form.company_pct) || 0);

  // Amount calculations (rounded to 2 decimals)
  const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;
  const extAmount = round2(dalala * extPct / 100);
  const ext1Amount = round2(dalala * ext1Pct / 100), ext2Amount = round2(dalala * ext2Pct / 100); // v3.4.129
  const intAmount = round2(dalala * intPct / 100);
  const marketer1Amount = round2(dalala * marketer1Pct / 100);
  const marketer2Amount = round2(dalala * marketer2Pct / 100);
  const dalilakAmount = round2(dalala * dalilakPct / 100);
  const marketersTotalPct = round2(marketer1Pct + marketer2Pct + dalilakPct);
  const marketersTotalAmount = round2(marketer1Amount + marketer2Amount + dalilakAmount);
  // Company residual = (internal %) - (marketers part %) — what's left for the company split
  const companyResidualPct = round2(intPct - marketersTotalPct);
  const companyResidualAmount = round2(dalala * companyResidualPct / 100);
  // Company part — local percentages must sum to 100% of companyResidualAmount
  const companyLocalSum = round2(wahaPct + salesMgrPct + mktMgrPct + companyPct);
  const wahaAmount = round2(companyResidualAmount * wahaPct / 100);
  const salesMgrAmount = round2(companyResidualAmount * salesMgrPct / 100);
  const mktMgrAmount = round2(companyResidualAmount * mktMgrPct / 100);
  const companyAmount = round2(companyResidualAmount * companyPct / 100);

  // Validation flags (tolerate ±0.01 rounding)
  // v3.4.120 — القاعدة: إن لم يُدخل أي رقم في التقسيمات يُسمح بالحفظ بقيمة الدلالة فقط؛
  // وإن أُدخل أي رقم فيجب أن تكون النسب صحيحة: خارجي + داخلي = 100، المسوّقون لا يتجاوزون الداخلي،
  // ونسب تقسيمة الشركة = 100% من المتبقي (إن كان هناك متبقٍ). الحفظ يُمنع عند الخطأ.
  const eq = (a, b) => Math.abs(a - b) < 0.01;
  const pctEntered = (v) => v !== undefined && v !== null && String(v).trim() !== "";
  const anyPctEntered = ["ext_pct", "int_pct", "marketer1_pct", "marketer2_pct", "dalilak_pct", "waha_pct", "sales_mgr_pct", "mkt_mgr_pct", "company_pct"].some(k => pctEntered(form[k]));
  const topSplitValid = !anyPctEntered || !showTop || eq(extPct + intPct, 100);
  const extSplitValid = !showExtBox || eq(ext1Pct + ext2Pct, extPct); // v3.4.129 — الخارجي 1 + 2 = حصة الخارجي
  const marketersValid = marketersTotalPct <= intPct + 0.01;  // marketers can't exceed internal
  const companyLocalValid = !anyPctEntered || companyResidualPct <= 0.01 || eq(companyLocalSum, 100);
  const zeroDalala = !(Number(dalala) > 0); // v3.4.370 — دلالة صفر (عميل شركة مباشر): لا شيء يُوزَّع فلا تُفحص النسب
  const allValid = zeroDalala || (extSplitValid && (!anyPctEntered || (topSplitValid && marketersValid && companyLocalValid)));
  const splitErrorMsg = zeroDalala ? "" : !extSplitValid ? `المسوّقون الخارجيون: ${fmt(ext1Pct)}% + ${fmt(ext2Pct)}% يجب أن يساوي حصة الخارجي ${fmt(extPct)}%` : !anyPctEntered ? "" : !topSplitValid ? "التقسيم الرئيسي: خارجي + داخلي يجب أن يساوي 100%"
    : !marketersValid ? `مجموع المسوّقين (${fmt(marketersTotalPct)}%) يتجاوز الحصة الداخلية (${fmt(intPct)}%)`
    : !companyLocalValid ? `تقسيمة الإدارة والشركة: مجموع النسب ${fmt(companyLocalSum)}% ويجب أن يكون 100%` : "";

  // ──────────────────────────────────────────────────────────────────
  // v3.3.559 — Smart marketer classification based on operation_type + per-marketer type
  // ──────────────────────────────────────────────────────────────────
  // Operation_type drives the default:
  //   - "حجز مسوق خارجي" → all marketers are external
  //   - "حجز مسوق داخلي" → all marketers are internal
  //   - "حجز داخلي خارجي" → mixed: read per-marketer marketer_type from junction
  //                              (user picks per marketer in the UI)
  const linkedMarketers = (form._linked_marketers || []);
  const opType = form.operation_type || "";
  const isExternalOnly = opType.includes("خارجي") && !opType.includes("داخلي خارجي") && !opType.includes("داخلي");
  const isInternalOnly = (opType.includes("داخلي") && !opType.includes("داخلي خارجي")) || opType.includes("مسوق داخلي");
  const isMixed = opType.includes("داخلي خارجي");

  // Derive each marketer's role
  const getMarketerType = (m) => {
    // If explicit type stored in junction, use it
    if (m.marketer_type === 'internal' || m.marketer_type === 'external') return m.marketer_type;
    // Otherwise infer from operation_type
    if (isExternalOnly) return 'external';
    if (isInternalOnly) return 'internal';
    // Mixed without explicit type → default null (user needs to pick)
    return null;
  };

  const externalMarketers = linkedMarketers.filter(m => getMarketerType(m) === 'external');
  const internalMarketers = linkedMarketers.filter(m => getMarketerType(m) === 'internal');
  const untypedMarketers  = linkedMarketers.filter(m => getMarketerType(m) === null);

  // Display labels (legacy fallbacks)
  // v3.4.126 — اسم الحقل ثابت والمسوّق بين قوسين: «المسوّق الداخلي 1 (ابوريما)»
  const extMarketerName = "المسوّق الخارجي 1" + (externalMarketers[0]?.name ? ` (${externalMarketers[0].name})` : "");
  const ext2MarketerName = "المسوّق الخارجي 2" + (externalMarketers[1]?.name ? ` (${externalMarketers[1].name})` : ""); // v3.4.129
  const marketer1Name = "المسوّق الداخلي 1" + (internalMarketers[0]?.name ? ` (${internalMarketers[0].name})` : "");
  const marketer2Name = "المسوّق الداخلي 2" + (internalMarketers[1]?.name ? ` (${internalMarketers[1].name})` : "");
  const anySalaried = internalMarketers.some(m => Number(m.monthly_salary) > 0); // موظف على نظام الرواتب

  // Helper for the user to assign a type in mixed mode
  const setMarketerType = (marketerId, type) => {
    setForm(f => {
      const updatedLinked = (f._linked_marketers || []).map(m =>
        m.id === marketerId ? { ...m, marketer_type: type } : m
      );
      const types = { ...(f.marketer_types || {}) };
      types[marketerId] = type;
      const u = { ...f, _linked_marketers: updatedLinked, marketer_types: types };
      formRef.current = u; // v3.4.248
      return u;
    });
  };

  // ── View Row Helper ──
  const VRow = ({ label, value, mono, money, color }) => (
    <div style={{ display:"flex", flexDirection:"column", gap:2 }}>
      <span style={{ fontSize:10, color:"#94a3b8", fontWeight:600, textTransform:"uppercase", letterSpacing:0.5 }}>{label}</span>
      <span style={{ fontSize:13, color: color || (value ? "#1e293b" : "#cbd5e1"), fontWeight: money ? 700 : 500,
        fontFamily: mono || money ? "'JetBrains Mono',monospace" : "inherit" }}>
        {money ? fmt(value) + " ر.س" : (value || "—")}
      </span>
    </div>
  );

  // v3.3.563 — View mode: show entity rows with the database ID badge next to each name
  // so users can disambiguate between similar-named clients/marketers/developers.
  // Falls back to plain text if no linked entities (legacy data).
  const VRowEntities = ({ label, entities, fallbackText, badgeColor = "#1d4ed8", phoneOf }) => ( /* v3.4.813 phoneOf — جوال الكيان (العميل) من قاعدة العملاء */
    <div style={{ display:"flex", flexDirection:"column", gap:2 }}>
      <span style={{ fontSize:10, color:"#94a3b8", fontWeight:600, textTransform:"uppercase", letterSpacing:0.5 }}>{label}</span>
      <span style={{ fontSize:13, color: (entities?.length || fallbackText) ? "#1e293b" : "#cbd5e1", fontWeight:500, display:"flex", flexWrap:"wrap", gap:6, alignItems:"center" }}>
        {entities && entities.length > 0
          ? entities.map((e, i) => (
              <span key={e.id || i} style={{ display:"inline-flex", alignItems:"center", gap:4 }}>
                {e.id && !String(e.id).startsWith("_new_") && (
                  <span style={{
                    background: badgeColor, color: "#fff",
                    padding: "1px 6px", borderRadius: 4,
                    fontSize: 9, fontWeight: 700, fontFamily: "monospace",
                  }}>#{e.id}</span>
                )}
                <span>{e.name}</span>
                {phoneOf && e.id && phoneOf(e.id) && ( /* v3.4.813 — رقم الجوال من قاعدة بيانات العملاء (اضغط للاتصال) */
                  <a href={"tel:" + String(phoneOf(e.id)).replace(/\s/g, "")} dir="ltr" title="جوال العميل — من قاعدة بيانات العملاء"
                    style={{ fontFamily: "monospace", fontSize: 12, color: "#0f766e", background: "#f0fdfa", border: "1px solid #99f6e4", borderRadius: 6, padding: "0 6px", textDecoration: "none", fontWeight: 700 }}>📱 {phoneOf(e.id)}</a>
                )}
                {i < entities.length - 1 && <span style={{ color: "#94a3b8" }}>،</span>}
              </span>
            ))
          : (fallbackText || "—")}
      </span>
    </div>
  );

  const SectionTitle = ({ icon, title }) => (
    <div style={{ display:"flex", alignItems:"center", gap:8, padding:"10px 0 6px", borderBottom:"2px solid #e2e8f0", marginBottom:14 }}>
      <span style={{ fontSize:16 }}>{icon}</span>
      <span style={{ fontSize:14, fontWeight:700, color:"#1e293b" }}>{title}</span>
    </div>
  );

  return (
    <div className="overlay" onClick={onClose}>
      <div className="side-panel" dir="rtl" onClick={e => e.stopPropagation()}>

        {/* ── Header ── */}
        <div className="panel-head">
          <h2 style={{ display:"flex", alignItems:"center", gap:8 }}>
            {isNew ? "حجز جديد" : `حجز #${form.id}`}
            {soldLocked && ( // v3.4.111
              <span title={isAdmin ? "الوحدة مُباعة — الحجز مقفل، وبصفتك أدمن يمكنك التعديل" : "الوحدة مُباعة — الحجز مقفل: التعديل لمدير النظام فقط"}
                style={{ fontSize:11, background:"#fee2e2", color:"#991b1b", padding:"2px 8px", borderRadius:12, fontWeight:700 }}>🔒 {String(form.operation_status || "").includes("لم تتم") ? "لم تتم العمليه — مقفل" : "مُباع — مقفل"}{isAdmin ? "" : " (أدمن فقط)"}</span>
            )}
            {/* v3.4.137 — حالة صرف الدلالة عند «تمت العمليه»: لم يُرفع / تم رفع أمر صرف / تم الصرف / مرفوض — مع رقم الطلب وفتحه في صفحة صرف الدلالات */}
            {!isNew && String(form.operation_status || "").includes("تمت العمليه") && (() => {
              const st = record?.dalala_status ?? form.dalala_status ?? null;
              const rid = record?.dalala_request_id ?? form.dalala_request_id ?? null;
              const c = st === "تم الصرف" ? ["✅ تم صرف الدلالة", "#dcfce7", "#166534"]
                : st === "مرفوض" ? ["✗ طلب صرف الدلالة مرفوض", "#fee2e2", "#991b1b"]
                : (st === "بانتظار الاعتماد" || st === "بانتظار الصرف" || rid) ? [`📤 تم رفع أمر صرف دلالة${st ? " — " + st : ""}`, "#fef3c7", "#92400e"]
                : ["💰 لم يُرفع طلب صرف الدلالة", "#f1f5f9", "#64748b"];
              const clickable = !!rid;
              return (
                <span onClick={clickable ? () => navigate(`/disbursements?req=${rid}`) : undefined}
                  title={clickable ? "فتح الطلب في صفحة صرف الدلالات" : "لا يوجد طلب صرف لهذا الحجز بعد"}
                  style={{ fontSize:11, background:c[1], color:c[2], padding:"2px 8px", borderRadius:12, fontWeight:700, cursor: clickable ? "pointer" : "default", textDecoration: clickable ? "underline dotted" : "none" }}>
                  {c[0]}{rid ? ` #${rid}` : ""}
                </span>
              );
            })()}
            {/* v3.4.139 — حالة صرف/إرجاع العربون للحجز المباع (مثل الدلالة): لم يُرفع / تم رفع طلب / تم الإرجاع / مرفوض — مع رقم الطلب */}
            {!isNew && (soldLocked || String(form.operation_status || "").includes("تمت العمليه")) && (() => {
              const st = record?.arboun_status ?? form.arboun_status ?? null;
              const rid = record?.arboun_request_id ?? form.arboun_request_id ?? null;
              const amt = Number(record?.deposit_amount ?? form.deposit_amount) || 0;
              const c = st === "تم الإرجاع" ? ["✅ تم صرف العربون", "#dcfce7", "#166534"]
                : st === "مرفوض" ? ["✗ طلب صرف العربون مرفوض", "#fee2e2", "#991b1b"]
                : (st === "بانتظار الاعتماد" || st === "بانتظار الإرجاع" || rid) ? [`📤 تم رفع طلب صرف العربون${st ? " — " + st : ""}`, "#fef3c7", "#92400e"]
                : ["🏦 لم يُرفع طلب صرف العربون", "#f1f5f9", "#64748b"];
              const clickable = !!rid;
              return (
                <span onClick={clickable ? () => navigate(`/disbursements?req=${rid}`) : undefined}
                  title={`${amt ? "العربون: " + amt.toLocaleString("en-US") + " ر.س — " : ""}${clickable ? "فتح الطلب في صفحة صرف الدلالات" : "لا يوجد طلب صرف عربون لهذا الحجز بعد"}`}
                  style={{ fontSize:11, background:c[1], color:c[2], padding:"2px 8px", borderRadius:12, fontWeight:700, cursor: clickable ? "pointer" : "default", textDecoration: clickable ? "underline dotted" : "none" }}>
                  {c[0]}{rid ? ` #${rid}` : ""}
                </span>
              );
            })()}
            {!isNew && !editMode && (
              <span style={{ fontSize:11, background:"#f0fdf4", color:"#16a34a", padding:"2px 8px", borderRadius:12, fontWeight:600 }}>عرض</span>
            )}
            {editMode && !isNew && (
              <span style={{ fontSize:11, background:"#eff6ff", color:"#2563eb", padding:"2px 8px", borderRadius:12, fontWeight:600 }}>تعديل</span>
            )}
          </h2>
          <div className="panel-head-btns" style={{ display:"flex", gap:6, alignItems:"center" }}>
            {!isNew && !editMode && canEdit && (
              <button onClick={() => { setForm(initForm(record)); setEditMode(true); }}
                style={{ display:"flex", alignItems:"center", gap:5, padding:"6px 14px", background:"#2563eb", border:"none", borderRadius:7, color:"#fff", cursor:"pointer", fontFamily:"inherit", fontSize:12, fontWeight:600 }}>
                <FiEdit2 size={14} /> تعديل
              </button>
            )}
            {editMode && !isNew && (
              <button onClick={() => { setEditMode(false); setForm(initForm(record)); }}
                style={{ padding:"6px 12px", background:"#f1f5f9", border:"1px solid #e2e8f0", borderRadius:7, color:"#64748b", cursor:"pointer", fontFamily:"inherit", fontSize:12 }}>
                إلغاء التعديل
              </button>
            )}
            {!isNew && p.can_delete && (
              <button className="btn-icon danger" onClick={() => { if (window.confirm("حذف؟")) onDelete(form.id); }}><FiTrash2 /></button>
            )}
            <button className="btn-icon" onClick={onClose}><FiX size={20} /></button>
          </div>
        </div>

        {/* ── Body ── */}
        <div className="panel-body" style={{ overflowY:"auto" }}>

          {/* ══ حالة العملية (منفصلة في الأعلى) ══ */}
          {canSee("operation_status") && (
            <div style={{ marginBottom:16 }}>
              {editMode && canEditSection("can_edit_info") ? (
                <div style={{ background:"linear-gradient(135deg, #fef3c7 0%, #fef9c3 100%)", border:"1px solid #fcd34d", borderRadius:10, padding:14 }}>
                  <SearchableSelect label="حالة العملية" value={form.operation_status} onChange={v => set("operation_status",v)} options={options.operation_status||[]} />
                </div>
              ) : (
                <div style={{ background:"linear-gradient(135deg, #fef3c7 0%, #fef9c3 100%)", border:"1px solid #fcd34d", borderRadius:10, padding:14, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                  <span style={{ fontWeight:600, color:"#92400e", fontSize:13 }}>📌 حالة العملية</span>
                  <span style={{ 
                    background: form.operation_status === "تمت العمليه" ? "#dcfce7" : form.operation_status === "لم تتم العمليه" ? "#fee2e2" : "#e0e7ff",
                    color: form.operation_status === "تمت العمليه" ? "#166534" : form.operation_status === "لم تتم العمليه" ? "#991b1b" : "#3730a3",
                    padding:"6px 16px", borderRadius:20, fontWeight:700, fontSize:13
                  }}>{form.operation_status || "—"}</span>
                </div>
              )}
            </div>
          )}

          {/* ══ SECTION 1: البيانات الأساسية ══ */}
          {canSeeAny("date","operation_type","client_name","client_type","developer","unit_type","readiness","purchase_purpose","marketer","notes") && (
            <div style={{ marginBottom:24 }}>
              <SectionTitle icon="📋" title="البيانات الأساسية" />
              {editMode && canEditSection("can_edit_info") ? (
                <div className="field-grid" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                  {/* صف 1: التاريخ فقط */}
                  {canSee("date") && <InputField label="التاريخ" value={form.date} onChange={v => set("date", v)} type="date" />}
                  <div></div>
                  
                  {/* صف 2: العميل + مصدر العميل */}
                  {canSee("client_name") && <SelectWithAdd label="اسم العميل" value={form.client_ids} items={clients} onChange={v => set("client_ids",v)} addType="client" multi />}
                  {canSee("client_type") && <SearchableSelect label="مصدر العميل" value={form.client_type} onChange={v => set("client_type",v)} options={options.client_type||[]} />}
                  
                  {/* صف 3: المطور (صف كامل) */}
                  {canSee("developer") && <div style={{ gridColumn:"1/-1" }}><SelectWithAdd label="المطور" value={form.developer_ids} items={developers} onChange={v => {
                    set("developer_ids", v);
                    // Reset unit selection when developer changes
                    set("selected_project_id", null);
                    set("selected_building_id", null);
                    set("selected_floor", "");
                    set("selected_unit_code", "");
                  }} addType="developer" multi /></div>}
                  
                  {/* ══ تنبيه إذا المطور شركة لكن غير مرتبط بمشروع ══ */}
                  {developerInfo?.is_company_project && !linkedProjectId && (
                    <div style={{ gridColumn:"1/-1", background:"#fef3c7", border:"1px solid #fcd34d", borderRadius:10, padding:12, marginTop:4 }}>
                      <div style={{ fontSize:12, color:"#92400e", display:"flex", alignItems:"center", gap:6 }}>
                        ⚠️ المطور "{developerInfo.name}" مُعرّف كمطور مشروع شركة لكنه <strong style={{ margin:"0 4px" }}>غير مرتبط بمشروع</strong>.
                        <span style={{ fontSize:11, color:"#a16207" }}>يرجى ربطه بمشروع من صفحة المطورين.</span>
                      </div>
                    </div>
                  )}
                  
                  {/* ══ اختيار الوحدة (يظهر فقط إذا المطور مرتبط بمشروع فعلياً) ══ */}
                  {linkedProjectId && (
                    <div style={{ gridColumn:"1/-1", background:"#f0fdf4", border:"1px solid #bbf7d0", borderRadius:10, padding:14, marginTop:4 }}>
                      <div style={{ fontSize:12, fontWeight:700, color:"#166534", marginBottom:10, display:"flex", alignItems:"center", gap:6 }}>
                        🏢 اختيار الوحدة من مشروع "{linkedProjectName || developerInfo?.name || `مشروع ${linkedProjectId}`}"
                      </div>
                      {loadingUnits ? (
                        <div style={{ textAlign:"center", padding:16, color:"#64748b" }}>⏳ جاري تحميل الوحدات...</div>
                      ) : unitSelectionData && unitSelectionData.length > 0 ? (
                        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:10 }}>
                          {/* المبنى */}
                          <div>
                            <label style={{ fontSize:10, color:"#166534", fontWeight:600, display:"block", marginBottom:4 }}>المبنى</label>
                            <select 
                              value={form.selected_building_id || ""} 
                              onChange={e => {
                                const val = e.target.value ? parseInt(e.target.value) : null;
                                set("selected_building_id", val);
                                set("selected_project_id", linkedProjectId);
                                set("selected_floor", "");
                                set("selected_unit_code", "");
                              }}
                              style={{ width:"100%", padding:"8px 10px", border:"1px solid #bbf7d0", borderRadius:6, fontFamily:"inherit", fontSize:12, background:"#fff" }}
                            >
                              <option value="">— اختر المبنى —</option>
                              {unitSelectionData.map(b => (
                                <option key={b.id} value={b.id}>{b.name}</option>
                              ))}
                            </select>
                          </div>
                          
                          {/* الدور */}
                          <div>
                            <label style={{ fontSize:10, color:"#166534", fontWeight:600, display:"block", marginBottom:4 }}>الدور</label>
                            <select 
                              value={form.selected_floor || ""} 
                              onChange={e => {
                                set("selected_floor", e.target.value);
                                set("selected_unit_code", "");
                              }}
                              disabled={!form.selected_building_id}
                              style={{ width:"100%", padding:"8px 10px", border:"1px solid #bbf7d0", borderRadius:6, fontFamily:"inherit", fontSize:12, background: form.selected_building_id ? "#fff" : "#f1f5f9" }}
                            >
                              <option value="">— اختر الدور —</option>
                              {availableFloors.map(f => (
                                <option key={f.floor} value={f.floor}>{f.label || `الدور ${f.floor}`}</option>
                              ))}
                            </select>
                          </div>
                          
                          {/* الوحدة */}
                          <div>
                            <label style={{ fontSize:10, color:"#166534", fontWeight:600, display:"block", marginBottom:4 }}>الوحدة</label>
                            <select 
                              value={form.selected_unit_code || ""} 
                              onChange={e => set("selected_unit_code", e.target.value)}
                              disabled={!form.selected_floor}
                              style={{ width:"100%", padding:"8px 10px", border:"1px solid #bbf7d0", borderRadius:6, fontFamily:"inherit", fontSize:12, background: form.selected_floor ? "#fff" : "#f1f5f9" }}
                            >
                              <option value="">— اختر الوحدة —</option>
                              {availableUnits.map(u => (
                                <option 
                                  key={u.id} 
                                  value={u.unit_code || u.unit_number}
                                  disabled={!u.available}
                                  style={{ color: u.available ? "#166534" : "#dc2626" }}
                                >
                                  {u.unit_code || u.unit_number} {!u.available ? "❌ محجوزة" : `✓ ${u.price ? `(${Number(u.price).toLocaleString()} ر.س)` : ''}`}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      ) : (
                        <div style={{ textAlign:"center", padding:12, color:"#64748b", fontSize:12 }}>
                          لا توجد وحدات متاحة في هذا المشروع
                        </div>
                      )}
                      {form.selected_unit_code && (
                        <div style={{ marginTop:10, padding:"8px 12px", background:"#dcfce7", borderRadius:6, fontSize:11, color:"#166534", fontWeight:600 }}>
                          ✅ الوحدة المختارة: {form.selected_unit_code}
                        </div>
                      )}
                    </div>
                  )}
                  
                  {/* صف 4: المسوق + نوع العملية */}
                  {/* v3.3.557 — When marketers change, also update _linked_marketers so the
                      dalala distribution UI can show the marketer names live */}
                  {canSee("marketer") && <SelectWithAdd label="المسوق" value={form.marketer_ids} items={marketers} onChange={v => setForm(f => { const u = { ...f, marketer_ids: v, _linked_marketers: v }; formRef.current = u; return u; })} addType="marketer" multi />}{/* v3.4.248 — تحديث المرجع أيضًا */}
                  {canSee("operation_type") && <SearchableSelect label="نوع العملية" value={form.operation_type} onChange={v => set("operation_type",v)} options={options.operation_type||[]} />}
                  
                  {/* صف 5: نوع الوحدة + الجاهزية + هدف الشراء */}
                  <div style={{ gridColumn:"1/-1", display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:12 }}>
                    {canSee("unit_type") && <SearchableSelect label="نوع الوحدة" value={form.unit_type} onChange={v => set("unit_type",v)} options={options.unit_type||[]} />}
                    {canSee("readiness") && <SearchableSelect label="الجاهزية" value={form.readiness} onChange={v => set("readiness",v)} options={options.readiness||[]} />}
                    {canSee("purchase_purpose") && <SearchableSelect label="هدف الشراء" value={form.purchase_purpose} onChange={v => set("purchase_purpose",v)} options={options.purchase_purpose||[]} />}
                  </div>
                  
                  {/* صف 6: ملاحظات */}
                  {canSee("notes") && <div style={{ gridColumn:"1/-1" }}><InputField label="ملاحظات" value={form.notes} onChange={v => set("notes",v)} type="textarea" /></div>}
                </div>
              ) : (
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"12px 20px" }}>
                  {/* صف 1: التاريخ */}
                  {canSee("date") && <VRow label="التاريخ" value={form.date} />}
                  <div></div>
                  
                  {/* صف 2: العميل + مصدر العميل */}
                  {canSee("client_name") && <VRowEntities label="اسم العميل" entities={form.client_ids} fallbackText={form.client_name} badgeColor="#1d4ed8" phoneOf={(id) => (record?.linked_clients || []).find(x => String(x.id) === String(id))?.phone || (clients || []).find(c => String(c.id) === String(id))?.phone || ""} />}{/* v3.4.813 — جوال العميل */}
                  {canSee("client_type") && <VRow label="مصدر العميل" value={form.client_type} />}
                  
                  {/* صف 3: المطور */}
                  {canSee("developer") && <div style={{ gridColumn:"1/-1" }}><VRowEntities label="المطور" entities={form.developer_ids} fallbackText={form.developer} badgeColor="#15803d" /></div>}
                  
                  {/* عرض الوحدة المختارة إن وجدت */}
                  {form.selected_unit_code && (() => { // v3.4.119 — الضغط على الوحدة يفتح نافذتها في صفحة المشاريع
                    const uid = record?.linked_unit_id, pid = record?.linked_unit_project_id || record?.selected_project_id;
                    const canOpen = !!(uid && pid);
                    return (
                      <div onClick={() => { if (canOpen) navigate(`/projects?id=${pid}&unit=${uid}`); }}
                        title={canOpen ? "فتح الوحدة في صفحة المشاريع" : undefined}
                        style={{ gridColumn:"1/-1", background:"#f0fdf4", border:"1px solid #bbf7d0", borderRadius:8, padding:"10px 14px", display:"flex", alignItems:"center", gap:10, cursor: canOpen ? "pointer" : "default" }}>
                        <span style={{ fontSize:14 }}>🏢</span>
                        <div style={{ flex:1 }}>
                          <div style={{ fontSize:10, color:"#166534", fontWeight:600 }}>الوحدة المخصصة للحجز</div>
                          <div style={{ fontSize:13, color:"#166534", fontWeight:700, textDecoration: canOpen ? "underline dotted" : "none" }}>{form.selected_unit_code}</div>
                        </div>
                        {canOpen && <span style={{ fontSize:11, color:"#166534", fontWeight:700 }}>فتح الوحدة ↗</span>}
                      </div>
                    );
                  })()}
                  
                  {/* صف 4: المسوق + نوع العملية */}
                  {canSee("marketer") && <VRowEntities label="المسوق" entities={form.marketer_ids} fallbackText={form.marketer} badgeColor="#a21caf" />}
                  {canSee("operation_type") && <VRow label="نوع العملية" value={form.operation_type} />}
                  
                  {/* صف 5: نوع الوحدة + الجاهزية + هدف الشراء */}
                  <div style={{ gridColumn:"1/-1", display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:12 }}>
                    {canSee("unit_type") && <VRow label="نوع الوحدة" value={form.unit_type} />}
                    {canSee("readiness") && <VRow label="الجاهزية" value={form.readiness} />}
                    {canSee("purchase_purpose") && <VRow label="هدف الشراء" value={form.purchase_purpose} />}
                  </div>
                  
                  {/* v3.3.373 — صف 6: ملاحظات تراكمية موحَّدة */}
                  {canSee("notes") && form.id && (
                    <div style={{ gridColumn:"1/-1", border: "1px solid #e2e8f0", borderRadius: 8, padding: "8px 12px", background: "#fafbfc" }}>
                      <div style={{ fontSize: 11, fontWeight: 600, color: "#475569", marginBottom: 6 }}>📝 ملاحظات الحجز التراكمية</div>
                      <ReservationNotesCell reservationId={form.id} notesLog={[]} compact={false} />
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          {/* ══ SECTION 2: التفاصيل المالية ══ */}
          {canSeeAny("value","deposit_amount","deposit_status","bank_account","dalala_amount","notes_extra") && (
            <div style={{ marginBottom:24 }}>
              <SectionTitle icon="💰" title="التفاصيل المالية" />
              
              {/* ─── بوكس 1: سعر البيع ─── */}
              <div style={{ background:"#fefce8", border:"1px solid #fef08a", borderRadius:10, padding:16, marginBottom:16 }}>
                <div style={{ fontWeight:600, color:"#854d0e", marginBottom:12, fontSize:14 }}>💵 سعر البيع</div>
                
                {/* السعر الرسمي والخصم يظهران فقط إذا الحجز مربوط بوحدة (للعرض فقط) */}
                {record?.linked_unit_id && record?.linked_unit_price && !form.quotation_id && (/* v3.4.601 — مع عرض سعر مرتبط تظهر تفاصيله بدل هذا */
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:12 }}>
                    <VRow label="السعر الرسمي (من الوحدة)" value={record.linked_unit_price} money />
                    <VRow label="الخصم" value={(Number(record.linked_unit_price) || 0) - (Number(form.value) || 0)} money />
                  </div>
                )}
                
                {/* v3.4.601 — السعر من عرض سعر معتمد للوحدة؛ الإدخال اليدوي فقط إن لم يُختر عرض */}
                {editMode && canEditSection("can_edit_finance") ? (
                  <div style={{ display:"grid", gridTemplateColumns:"1fr", gap:12 }}>
                    {canSee("value") && <ReservationQuotePicker unit={quoteUnit} reservationId={isNew ? null : record?.id} value={form.quotation_id || null} linked={record?.linked_quotation}
                      clientIds={form.client_ids} onPick={pickQuotation} onClear={clearQuotation} hasUnitPicker={!!linkedProjectId} canOpenQuotations={isAdmin || !!user?.can_view_quotations}
                      autoPick={isNew} onCandidates={setQuoteCandidates} />}{/* v3.4.608 — حجز جديد: العرض الساري يُختار تلقائيًا */}
                    {canSee("value") && (form.quotation_id ? (
                      <div style={{ background:"#fef9c3", padding:"10px 14px", borderRadius:8, display:"flex", justifyContent:"space-between", alignItems:"center", gap:10, flexWrap:"wrap" }}>
                        <span style={{ fontWeight:600, color:"#713f12" }}>سعر البيع تنفيذ <small style={{ fontWeight:500 }}>{isNew && quoteCandidates > 0 ? "(السعر المعتمد في عرض السعر الساري على الوحدة)" : "(من عرض السعر — لتعديله ألغِ اختيار العرض)"}</small></span>
                        <span style={{ fontWeight:700, color:"#854d0e", fontSize:16 }}>{fmt(form.value)} ر.س</span>
                      </div>
                    ) : (isNew && quoteCandidates > 0) ? (/* v3.4.608 — وحدة عليها عرض ساري: السعر من العرض لا يُدخل يدويًا */
                      <div style={{ background:"#fff7ed", border:"1px solid #fdba74", padding:"10px 14px", borderRadius:8, fontSize:12.5, fontWeight:600, color:"#9a3412" }}>
                        على هذه الوحدة {quoteCandidates} عروض سعر سارية — اختر العرض الذي يُبنى عليه الحجز من القائمة أعلاه؛ سعر البيع يؤخذ من العرض المعتمد.
                      </div>
                    ) : <InputField key={"val-" + (form.id || "new")} label="سعر البيع تنفيذ (القيمة)" value={form.value} onChange={v => set("value",v)} type="number" />)}
                  </div>
                ) : (
                  <>
                    {form.quotation_id && record?.linked_quotation && <ReservationQuoteCard quote={record.linked_quotation} />}
                    <div style={{ background:"#fef9c3", padding:"10px 14px", borderRadius:8, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                      <span style={{ fontWeight:600, color:"#713f12" }}>سعر البيع تنفيذ</span>
                      <span style={{ fontWeight:700, color:"#854d0e", fontSize:16 }}>{fmt(form.value)} ر.س</span>
                    </div>
                  </>
                )}
              </div>

              {/* ─── بوكس 2: العربون ─── */}
              <div style={{ background:"#f0fdf4", border:"1px solid #bbf7d0", borderRadius:10, padding:16, marginBottom:16 }}>
                <div style={{ fontWeight:600, color:"#166534", marginBottom:12, fontSize:14 }}>🏦 العربون</div>
                {editMode && canEditSection("can_edit_finance") ? (
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:12 }}>
                    {canSee("deposit_amount") && <InputField label="العربون" value={form.deposit_amount} onChange={v => set("deposit_amount",v)} type="number" />}
                    {canSee("deposit_status") && <SearchableSelect label="حالة العربون" value={form.deposit_status} onChange={v => set("deposit_status",v)} options={options.deposit_status||[]} />}
                    {canSee("bank_account") && <SearchableSelect label="البنك" value={form.bank_account} onChange={v => set("bank_account",v)} options={options.bank_account||[]} />}
                  </div>
                ) : (
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:12 }}>
                    {canSee("deposit_amount") && <VRow label="العربون" value={form.deposit_amount} money />}
                    {canSee("deposit_status") && <VRow label="حالة العربون" value={form.deposit_status} />}
                    {canSee("bank_account") && <VRow label="البنك" value={form.bank_account} />}
                  </div>
                )}
              </div>

              {/* ─── بوكس 3: ملخص السداد (للعرض فقط - من الوحدة المربوطة) ─── */}
              {!isNew && record?.linked_unit_id && (
                <LinkedUnitPaymentsSummary unitId={record.linked_unit_id} reservation={record} />
              )}

              {/* ─── ملاحظات إضافية ─── */}
              {canSee("notes_extra") && (editMode ? (
                <div style={{ background:"#f8fafc", border:"1px solid #e2e8f0", borderRadius:10, padding:16, marginTop:16 }}>
                  <InputField label="ملاحظات إضافية" value={form.notes_extra} onChange={v => set("notes_extra",v)} type="textarea" span2 />
                </div>
              ) : form.notes_extra && (
                <div style={{ background:"#f8fafc", border:"1px solid #e2e8f0", borderRadius:10, padding:16, marginTop:16 }}>
                  <VRow label="ملاحظات إضافية" value={form.notes_extra} />
                </div>
              ))}
            </div>
          )}

          {/* ══ SECTION 3: الدلالة وتوزيعها — v3.3.557 percentage-based ══ */}
          {canSeeAny("dalala_amount","ext_marketer_share","int_marketer_share","waha_share","sales_mgr_share","mkt_mgr_share","company_share") && (
            <div style={{ marginBottom:24 }}>
              <SectionTitle icon="💎" title="الدلالة وتوزيعها" />
              <div style={{ background:"#faf5ff", border:"1px solid #e9d5ff", borderRadius:10, padding:16 }}>
              {editMode ? (
                <>
                  {/* قيمة الدلالة */}
                  {canSee("dalala_amount") && (
                    <div style={{ marginBottom:16 }}>
                      <InputField label="قيمة الدلالة (ر.س)" value={form.dalala_amount} onChange={v => set("dalala_amount",v)} type="number" />
                    </div>
                  )}
                  <div className="comm-total"><span>إجمالي الدلالة</span><strong>{fmt(dalala)} ر.س = 100%</strong></div>

                  {/* ───── v3.4.131 — بوكس مستقل للتقسيم بين الخارجي والداخلي (لـ«داخلي خارجي») يضم تحديد دور كل مسوّق ───── */}
                  {showTop && <div style={{ background: "linear-gradient(135deg, #fefce8 0%, #fef3c7 100%)", border: "2px solid #fcd34d", borderRadius: 8, padding: 12, marginBottom: 10 }}>
                  <div style={{ fontSize:11, fontWeight:700, color:"#92400e", marginBottom:8, display:"flex", alignItems:"center", gap:6, justifyContent:"space-between" }}>
                    <span>🔀 التقسيم بين الخارجي والداخلي (% من الإجمالي = 100%)</span>
                    {mixedNeedsTwo && <span style={{ flexBasis:"100%", background:"#fee2e2", color:"#991b1b", border:"1px solid #fca5a5", borderRadius:6, padding:"6px 10px", fontSize:11.5, fontWeight:800 }}>✗ نوع العملية «داخلي خارجي» يتطلب أكثر من مسوّق — أضف مسوّقًا ثانيًا أو غيّر نوع العملية إلى داخلي أو خارجي فقط</span>}{/* v3.4.132 */}
                    <span style={{ fontSize:10, fontWeight:500, color:"#475569", background:"#fff", padding:"2px 8px", borderRadius:10 }}>🔀 داخلي + خارجي</span>
                  </div>
                    {/* v3.3.559 — Mixed-mode: let the user assign role per marketer */}
                    {isMixed && linkedMarketers.length > 0 && (
                      <div style={{
                        marginBottom:10, padding:"8px 10px", borderRadius:6,
                        background:"#fef3c7", border:"1px solid #fcd34d",
                        fontSize:11, color:"#92400e",
                      }}>
                        👥 حدّد دور كل مسوّق في هذه البيعة (خارجي / داخلي):
                        <div style={{ display:"flex", flexDirection:"column", gap:6, marginTop:8 }}>
                          {linkedMarketers.map(m => (
                            <div key={m.id} style={{
                              display:"flex", alignItems:"center", gap:8,
                              padding:"6px 10px", background:"#fff", borderRadius:5,
                            }}>
                              <span style={{ flex:1, fontSize:12, fontWeight:600, color:"#0f172a" }}>{m.name}</span>
                              <button
                                onClick={() => setMarketerType(m.id, 'external')}
                                style={{
                                  padding:"4px 12px", fontSize:11, fontWeight:600,
                                  background: getMarketerType(m) === 'external' ? "#3b82f6" : "#f1f5f9",
                                  color: getMarketerType(m) === 'external' ? "#fff" : "#475569",
                                  border:"1px solid " + (getMarketerType(m) === 'external' ? "#2563eb" : "#cbd5e1"),
                                  borderRadius:5, cursor:"pointer", fontFamily:"inherit",
                                }}>
                                🌐 خارجي
                              </button>
                              <button
                                onClick={() => setMarketerType(m.id, 'internal')}
                                style={{
                                  padding:"4px 12px", fontSize:11, fontWeight:600,
                                  background: getMarketerType(m) === 'internal' ? "#16a34a" : "#f1f5f9",
                                  color: getMarketerType(m) === 'internal' ? "#fff" : "#475569",
                                  border:"1px solid " + (getMarketerType(m) === 'internal' ? "#15803d" : "#cbd5e1"),
                                  borderRadius:5, cursor:"pointer", fontFamily:"inherit",
                                }}>
                                🏠 داخلي
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                  <div className="field-grid">
                    {canSee("ext_marketer_share") && (
                      <div>
                        <InputField label="% المسوق الخارجي" value={form.ext_pct ?? ""} onChange={v => set("ext_pct", v)} type="number" min={0} max={100} />
                        <div style={{ fontSize:10, color:"#64748b", marginTop:2 }}>= {fmt(extAmount)} ر.س</div>
                      </div>
                    )}
                    {canSee("int_marketer_share") && (
                      <div>
                        <InputField label="% الداخلي (المسوقين + الشركة)" value={form.int_pct ?? ""} onChange={v => set("int_pct", v)} type="number" min={0} max={100} />
                        <div style={{ fontSize:10, color:"#64748b", marginTop:2 }}>= {fmt(intAmount)} ر.س</div>
                      </div>
                    )}
                  </div>
                  <div className={`comm-check ${topSplitValid?"ok":"err"}`}>
                    {fmt(extPct)}% + {fmt(intPct)}% = {fmt(extPct+intPct)}% {topSplitValid?"✓":"✗ يجب أن يكون 100%"}
                  </div>
                  </div>}
                  {!showTop && <div style={{ fontSize:11, color:"#64748b", margin:"6px 0 10px" }}>{__extOnly ? "🌐 حجز خارجي: كامل الدلالة (100%) للمسوّقين الخارجيين" : "🏠 حجز داخلي: كامل الدلالة (100%) للداخلي (المسوّقون + الإدارة والشركة)"}</div>}

                  {/* v3.4.129 — بوكس المسوّقين الخارجيين (خارجي فقط أو داخلي خارجي) */}
                  {showExtBox && (
                    <div style={{ background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)", border: "2px solid #93c5fd", borderRadius: 8, padding: 12, marginBottom: 10 }}>
                      <div style={{ fontSize:11, fontWeight:700, color:"#1e40af", marginBottom:8, display:"flex", alignItems:"center", gap:6, justifyContent:"space-between" }}>
                        <span>🌐 المسوّقون الخارجيون (% من الإجمالي)</span>
                        <span style={{ fontSize:10, fontWeight:500, color:"#475569", background:"#fff", padding:"2px 8px", borderRadius:10 }}>حصة الخارجي: {fmt(extPct)}% = {fmt(extAmount)} ر.س</span>
                      </div>
                      <div className="field-grid">
                        <div>
                          <InputField label={`% ${extMarketerName}`} value={form.ext1_pct ?? (__e2in ? "" : "")} onChange={v => set("ext1_pct", v)} type="number" min={0} max={100} />
                          <div style={{ fontSize:10, color:"#1e40af", marginTop:2, fontWeight:600 }}>= {fmt(ext1Amount)} ر.س{!__e1in && <span style={{ color:"#94a3b8" }}> (تلقائي: باقي حصة الخارجي)</span>}</div>
                        </div>
                        <div>
                          <InputField label={`% ${ext2MarketerName}`} value={form.ext2_pct ?? ""} onChange={v => set("ext2_pct", v)} type="number" min={0} max={100} />
                          <div style={{ fontSize:10, color:"#1e40af", marginTop:2, fontWeight:600 }}>= {fmt(ext2Amount)} ر.س</div>
                        </div>
                      </div>
                      <div style={{ marginTop:8, padding:"6px 10px", borderRadius:6, background: extSplitValid ? "#dcfce7" : "#fee2e2", border: "1px solid " + (extSplitValid ? "#86efac" : "#fca5a5"), fontSize:11, color: extSplitValid ? "#166534" : "#991b1b", fontWeight:600 }}>
                        مجموع الخارجيين: {fmt(ext1Pct + ext2Pct)}% = {fmt(ext1Amount + ext2Amount)} ر.س {extSplitValid ? "✓" : `✗ يجب أن يساوي ${fmt(extPct)}%`}
                      </div>
                    </div>
                  )}

                  {/* ───── الحصة الداخلية: المسوقين + الشركة ───── */}
                  {showIntBox && <h4 className="section-label">توزيع الحصة الداخلية ({fmt(intAmount)} ر.س | {fmt(intPct)}%)</h4>}

                  {/* ─── الجزء العلوي: المسوقين (خلفية مميزة) — v3.4.129: للداخلي والمختلط ─── */}
                  {showIntBox && <div style={{
                    background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
                    border: "2px solid #93c5fd",
                    borderRadius: 8,
                    padding: 12,
                    marginBottom: 10,
                  }}>
                    <div style={{ fontSize:11, fontWeight:700, color:"#1e40af", marginBottom:8, display:"flex", alignItems:"center", gap:6, justifyContent:"space-between" }}>
                      <span>🏠 المسوّقون الداخليون والشركة (% من الإجمالي)</span>
                      {/* v3.4.133 — استُبدل وسم نوع الحجز هنا بقائمة التعبئة التلقائية (الوسم موجود في بوكس التقسيم أعلاه) */}
                      {/* v3.4.133 — نوع التوزيع الداخلي: من إعدادات القوائم (أنواع توزيع الحصة الداخلية) — يعبّئ م1/م2/دليلك ويمكن تعديلها بعده */}
                      <select value="" onChange={e => {
                          const it = (optionsRaw?.internal_split_preset || []).find(x => String(x.id) === e.target.value);
                          if (!it) return;
                          const a = String(it.group_name || "").split("/").map(x => Number(x) || 0);
                          set("marketer1_pct", a[0] || 0); set("marketer2_pct", a[1] || 0); set("dalilak_pct", a[2] || 0);
                          setIntKey(k => k + 1);
                        }}
                        style={{ padding:"4px 8px", border:"1px solid #93c5fd", borderRadius:6, fontFamily:"inherit", fontSize:11, background:"#fff", color:"#0f172a", maxWidth:260 }}>
                        <option value="">— نوع التوزيع الداخلي (تعبئة تلقائية) —</option>
                        {(optionsRaw?.internal_split_preset || []).map(it => <option key={it.id} value={it.id}>{it.label}</option>)}
                      </select>
                    </div>

                    <div className="field-grid" key={intKey}>
                      {/* ─── Internal Marketer 1 — visible when internal role applies ─── */}
                      {true && (
                        <div>
                          <InputField
                            label={`% ${marketer1Name}`}
                            value={form.marketer1_pct ?? ""}
                            onChange={v => set("marketer1_pct", v)}
                            type="number" min={0} max={100}
                          />
                          <div style={{ fontSize:10, color:"#1e40af", marginTop:2, fontWeight:600 }}>= {fmt(marketer1Amount)} ر.س</div>
                        </div>
                      )}

                      {/* ─── Internal Marketer 2 — visible when 2+ internal expected ─── */}
                      {true && (
                        <div>
                          <InputField
                            label={`% ${marketer2Name}`}
                            value={form.marketer2_pct ?? ""}
                            onChange={v => set("marketer2_pct", v)}
                            type="number" min={0} max={100}
                          />
                          <div style={{ fontSize:10, color:"#1e40af", marginTop:2, fontWeight:600 }}>= {fmt(marketer2Amount)} ر.س</div>
                        </div>
                      )}

                      {/* ─── Dalilak (always shown, third-party share) ─── */}
                      <div>
                        <InputField
                          label={`% حصة دليلك (إذا الموظف على نظام الرواتب — 30%)${anySalaried ? " ⚠ موظف على الرواتب" : ""}`}
                          value={form.dalilak_pct ?? ""}
                          onChange={v => set("dalilak_pct", v)}
                          type="number" min={0} max={100}
                        />
                        <div style={{ fontSize:10, color:"#1e40af", marginTop:2, fontWeight:600 }}>= {fmt(dalilakAmount)} ر.س</div>
                      </div>
                      {/* v3.4.120 — حصة الشركة: تُحسب تلقائيًا = المتبقي من الحصة الداخلية بعد المسوّقين ودليلك (وهي نفسها التي تُقسَّم في البوكس أدناه) */}
                      <div>
                        <InputField label="% الإدارة والشركة (تلقائي — يتوزع أدناه)" value={fmt(companyResidualPct)} onChange={() => {}} type="text" readOnly />
                        <div style={{ fontSize:10, color: companyResidualPct < 0 ? "#991b1b" : "#1e40af", marginTop:2, fontWeight:600 }}>= {fmt(companyResidualAmount)} ر.س{companyResidualPct < 0 ? " ✗" : ""}</div>
                      </div>
                    </div>
                    <div style={{
                      marginTop:8, padding:"6px 10px", borderRadius:6,
                      background: marketersValid ? "#dcfce7" : "#fee2e2",
                      border: "1px solid " + (marketersValid ? "#86efac" : "#fca5a5"),
                      fontSize:11, color: marketersValid ? "#166534" : "#991b1b", fontWeight:600,
                    }}>
                      مجموع المسوقين: {fmt(marketersTotalPct)}% = {fmt(marketersTotalAmount)} ر.س · الإدارة والشركة: {fmt(companyResidualPct)}% = {fmt(companyResidualAmount)} ر.س
                      {!marketersValid && ` ✗ يتجاوز الحصة الداخلية (${fmt(intPct)}%)`}
                      {marketersValid && " ✓"}
                    </div>
                  </div>}

                  {/* ─── الجزء السفلي: تقسيمة الإدارة والشركة — v3.4.129: للداخلي والمختلط ─── */}
                  {showIntBox && <div style={{
                    background: "#f8fafc",
                    border: "1px solid #cbd5e1",
                    borderRadius: 8,
                    padding: 12,
                  }}>
                    <div style={{ fontSize:11, fontWeight:700, color:"#475569", marginBottom:4, display:"flex", alignItems:"center", gap:6, flexWrap:"wrap" }}>
                      🏢 تقسيمة الإدارة والشركة (% من حصة الإدارة والشركة)
                      {/* v3.4.127 — نوع التوزيع: من إعدادات القوائم (أنواع توزيع الإدارة والشركة) — يعبّئ النسب ويمكن تعديلها يدويًا بعده */}
                      <select value="" onChange={e => {
                          const it = (optionsRaw?.commission_split_preset || []).find(x => String(x.id) === e.target.value);
                          if (!it) return;
                          const a = String(it.group_name || "").split("/").map(x => Number(x) || 0);
                          set("waha_pct", a[0] || 0); set("sales_mgr_pct", a[1] || 0); set("mkt_mgr_pct", a[2] || 0); set("company_pct", a[3] || 0);
                          setSplitKey(k => k + 1);
                        }}
                        style={{ marginInlineStart:"auto", padding:"4px 8px", border:"1px solid #cbd5e1", borderRadius:6, fontFamily:"inherit", fontSize:11, background:"#fff", color:"#0f172a", maxWidth:260 }}>
                        <option value="">— نوع التوزيع (تعبئة تلقائية) —</option>
                        {(optionsRaw?.commission_split_preset || []).map(it => <option key={it.id} value={it.id}>{it.label}</option>)}
                      </select>
                    </div>
                    <div style={{ fontSize:10, color:"#64748b", marginBottom:10 }}>
                      حصة الإدارة والشركة (من الأعلى): {fmt(companyResidualPct)}% من الإجمالي = <strong style={{ color:"#0f172a" }}>{fmt(companyResidualAmount)} ر.س</strong>
                      <br />
                      <span style={{ color:"#94a3b8" }}>النسب أدناه يجب أن يكون مجموعها 100% من حصة الإدارة والشركة</span>
                    </div>
                    <div className="field-grid" key={splitKey}>{/* v3.4.127 */}
                      {canSee("waha_share") && (
                        <div>
                          <InputField label="% الإدارة" value={form.waha_pct ?? ""} onChange={v => set("waha_pct", v)} type="number" min={0} max={100} />{/* v3.4.120 — كان «الواحة» */}
                          <div style={{ fontSize:10, color:"#475569", marginTop:2, fontWeight:600 }}>= {fmt(wahaAmount)} ر.س</div>
                        </div>
                      )}
                      {canSee("sales_mgr_share") && (
                        <div>
                          <InputField label="% مدير المبيعات" value={form.sales_mgr_pct ?? ""} onChange={v => set("sales_mgr_pct", v)} type="number" min={0} max={100} />
                          <div style={{ fontSize:10, color:"#475569", marginTop:2, fontWeight:600 }}>= {fmt(salesMgrAmount)} ر.س</div>
                        </div>
                      )}
                      {canSee("mkt_mgr_share") && (
                        <div>
                          <InputField label="% مديرة المسوقات" value={form.mkt_mgr_pct ?? ""} onChange={v => set("mkt_mgr_pct", v)} type="number" min={0} max={100} />
                          <div style={{ fontSize:10, color:"#475569", marginTop:2, fontWeight:600 }}>= {fmt(mktMgrAmount)} ر.س</div>
                        </div>
                      )}
                      {canSee("company_share") && (
                        <div>
                          <InputField label="% الشركة" value={form.company_pct ?? ""} onChange={v => set("company_pct", v)} type="number" min={0} max={100} />
                          <div style={{ fontSize:10, color:"#475569", marginTop:2, fontWeight:600 }}>= {fmt(companyAmount)} ر.س</div>
                        </div>
                      )}
                    </div>
                    <div style={{
                      marginTop:8, padding:"6px 10px", borderRadius:6,
                      background: companyLocalValid ? "#dcfce7" : "#fee2e2",
                      border: "1px solid " + (companyLocalValid ? "#86efac" : "#fca5a5"),
                      fontSize:11, color: companyLocalValid ? "#166534" : "#991b1b", fontWeight:600,
                    }}>
                      مجموع نسب الإدارة والشركة: {fmt(companyLocalSum)}% من حصة الإدارة والشركة
                      {companyLocalValid ? " ✓" : " ✗ يجب أن يكون 100%"}
                    </div>
                  </div>}

                  <div className={`comm-grand ${allValid?"ok":"err"}`}>
                    {allValid ? (zeroDalala ? "✓ بلا دلالة (0 ر.س) — لا يلزم توزيع" : anyPctEntered ? "✓ التوزيع صحيح" : "✓ بلا تقسيم — تُحفظ قيمة الدلالة فقط") : `✗ ${splitErrorMsg} — لن يُحفظ الحجز حتى تصحيح النسب`}
                  </div>
                </>
              ) : (
                <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:"12px 20px" }}>
                  {canSee("dalala_amount") && <VRow label="إجمالي الدلالة" value={form.dalala_amount} money />}
                  {/* External + Internal */}
                  {showTop && canSee("ext_marketer_share") && <VRow label={`خارجي (${fmt(extPct)}%)`} value={extAmount || form.ext_marketer_share} money />}
                  {showTop && canSee("int_marketer_share") && <VRow label={`داخلي (${fmt(intPct)}%)`} value={intAmount || form.int_marketer_share} money />}
                  {showExtBox && ( /* v3.4.129 */
                    <div style={{ gridColumn:"1/-1", background:"#eff6ff", padding:8, borderRadius:6, border:"1px solid #bfdbfe" }}>
                      <div style={{ fontSize:10, fontWeight:700, color:"#1e40af", marginBottom:6 }}>🌐 المسوّقون الخارجيون ({fmt(extPct)}%)</div>
                      <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:8 }}>
                        <VRow label={`${extMarketerName} (${fmt(ext1Pct)}%)`} value={ext1Amount || form.ext1_share} money />
                        <VRow label={`${ext2MarketerName} (${fmt(ext2Pct)}%)`} value={ext2Amount || form.ext2_share} money />
                      </div>
                    </div>
                  )}
                  {/* Marketers */}
                  {showIntBox && <div style={{ gridColumn:"1/-1", background:"#eff6ff", padding:8, borderRadius:6, border:"1px solid #bfdbfe" }}>
                    <div style={{ fontSize:10, fontWeight:700, color:"#1e40af", marginBottom:6 }}>🏠 المسوّقون الداخليون والشركة</div>
                    <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:8 }}>
                      <VRow label={`${marketer1Name} (${fmt(marketer1Pct)}%)`} value={marketer1Amount || form.marketer1_share} money />
                      <VRow label={`${marketer2Name} (${fmt(marketer2Pct)}%)`} value={marketer2Amount || form.marketer2_share} money />
                      <VRow label={`دليلك (${fmt(dalilakPct)}%)`} value={dalilakAmount || form.dalilak_share} money />
                    </div>
                  </div>}
                  {/* Company part */}
                  {showIntBox && <div style={{ gridColumn:"1/-1", background:"#f8fafc", padding:8, borderRadius:6, border:"1px solid #cbd5e1" }}>
                    <div style={{ fontSize:10, fontWeight:700, color:"#475569", marginBottom:6 }}>🏢 تقسيمة الإدارة والشركة ({fmt(companyResidualPct)}%)</div>
                    <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:8 }}>
                      {canSee("waha_share") && <VRow label={`الإدارة (${fmt(wahaPct)}%)`} value={wahaAmount || form.waha_share} money />}{/* v3.4.120 */}
                      {canSee("sales_mgr_share") && <VRow label={`مدير المبيعات (${fmt(salesMgrPct)}%)`} value={salesMgrAmount || form.sales_mgr_share} money />}
                      {canSee("mkt_mgr_share") && <VRow label={`مديرة المسوقات (${fmt(mktMgrPct)}%)`} value={mktMgrAmount || form.mkt_mgr_share} money />}
                      {canSee("company_share") && <VRow label={`الشركة (${fmt(companyPct)}%)`} value={companyAmount || form.company_share} money />}
                    </div>
                  </div>}
                  <div style={{ gridColumn:"1/-1" }}>
                    <div className={`comm-grand ${allValid?"ok":"err"}`} style={{ marginTop:0 }}>
                      {allValid ? "✓ التوزيع صحيح" : "✗ يوجد فرق في التوزيع"}
                    </div>
                  </div>
                </div>
              )}
              </div>
            </div>
          )}

          {/* ══ v3.3.751 — الوحدة المرتبطة بهذا الحجز (من طرف الوحدة) ══ */}
          {!isNew && (
            <div style={{ marginBottom:16 }}>
              <SectionTitle icon="🏠" title="الوحدة المرتبطة بهذا الحجز" />
              {unitSideLinks === null ? (
                <div style={{ fontSize:11, color:"#94a3b8" }}>جاري التحقق من ربط الوحدات...</div>
              ) : unitSideLinks.length === 0 ? (
                <div style={{ background:"#fafafa", border:"1px dashed #e2e8f0", borderRadius:8, padding:"10px 12px",
                  fontSize:12, color:"#94a3b8", fontWeight:600 }}>
                  لا توجد وحدة مربوطة بهذا الحجز من طرف الوحدة
                </div>
              ) : (
                <div style={{ display:"grid", gap:8 }}>
                  {unitSideLinks.map(u => (
                    <div key={u.id} style={{ background:"#f0fdf4", border:"1px solid #bbf7d0", borderRadius:8,
                      padding:"10px 12px", display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, flexWrap:"wrap" }}>
                      <div style={{ display:"flex", alignItems:"center", gap:16, flexWrap:"wrap" }}>
                        <span style={{ fontSize:12.5, color:"#166534", fontWeight:800 }}>🏗 {u.project_name || "مشروع غير محدد"}</span>
                        <span style={{ fontSize:12.5, color:"#1e293b", fontWeight:800 }}>🏠 وحدة {u.unit_label || u.unit_number || `#${u.id}`}{u.resale && <span style={{ fontSize:11, fontWeight:800, color: u.resale.kind === 2 ? "#9a3412" : "#166534", marginInlineStart:6 }}>({u.resale.kind === 2 ? "إعادة بيع - 2" : "إعادة بيع - 1"})</span>}</span>
                        {u.resale && <div style={{ width:"100%", fontSize:11.5, color:"#475569", marginTop:2 }}>{/* v3.4.374 — دورة البيع السابقة */}
                          👤 العميل السابق: <b style={{ color:"#0f172a" }}>{u.resale.prev_client || "—"}</b>{u.resale.prev_reservation_id ? <span style={{ color:"#94a3b8" }}> (حجز #{u.resale.prev_reservation_id})</span> : null}
                          <span style={{ margin:"0 8px", color:"#cbd5e1" }}>|</span>🏷️ اشترى بـ <b style={{ color:"#0f172a" }}>{fmt(u.resale.prev_value)} ر.س</b>
                          <span style={{ margin:"0 8px", color:"#cbd5e1" }}>|</span>💵 إجمالي ما دفعه <b style={{ color:"#166534" }}>{fmt(u.resale.prev_paid)} ر.س</b>
                        </div>}
                        {u.status && (
                          <span style={{ fontSize:10, fontWeight:700, borderRadius:10, padding:"1px 10px",
                            background: u.status === "sold" ? "#fee2e2" : u.status === "reserved" ? "#fef3c7" : "#dcfce7",
                            color: u.status === "sold" ? "#991b1b" : u.status === "reserved" ? "#92400e" : "#166534" }}>
                            {u.status === "sold" ? "مباعة" : u.status === "reserved" ? "محجوزة" : u.status === "available" ? "متاحة" : u.status}
                          </span>
                        )}
                      </div>
                      <span style={{ fontSize:10, color:"#16a34a", fontWeight:700 }}>✓ مربوطة بهذا الحجز من طرف الوحدة</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* ══ SECTION 4: حالات الاعتماد ══ */}
          {canSeeAny("commission_status_res","commission_status_acc") && (
            <div style={{ marginBottom:16 }}>
              <SectionTitle icon="✅" title="حالات الاعتماد" />
              {editMode ? (
                <div className="field-grid">
                  {canSee("commission_status_res") && p.can_edit_status_res && <SearchableSelect label="حالة الدلالة (إدارة الحجوزات)" value={form.commission_status_res} onChange={v => set("commission_status_res",v)} options={options.commission_status_res||[]} />}
                  {canSee("commission_status_acc") && p.can_edit_status_acc && <SearchableSelect label="حالة الدلالة (المحاسبة)" value={form.commission_status_acc} onChange={v => set("commission_status_acc",v)} options={options.commission_status_acc||[]} />}
                </div>
              ) : (
                <div style={{ display:"grid", gridTemplateColumns:"repeat(2,1fr)", gap:"12px 20px" }}>
                  {canSee("commission_status_res") && <VRow label="حالة الدلالة (إدارة الحجوزات)" value={form.commission_status_res} />}
                  {canSee("commission_status_acc") && <VRow label="حالة الدلالة (المحاسبة)" value={form.commission_status_acc} />}
                </div>
              )}
            </div>
          )}

          {/* ══ v3.3.715 — سجل التغييرات (مثل سجل الوحدة) ══ */}
          {!isNew && !editMode && form.id && <ReservationAuditLog reservationId={form.id} />}

        </div>

        {/* ── Footer ── */}
        <div className="panel-foot">
          {editMode ? (
            <>
              <button className="btn-save" onClick={() => { if (mixedNeedsTwo) { toast.error("نوع العملية «داخلي خارجي» يتطلب أكثر من مسوّق — أضف مسوّقًا ثانيًا أو اختر داخلي أو خارجي فقط", { duration: 7000 }); return; } if (!allValid) { toast.error("نسب الدلالة غير صحيحة: " + splitErrorMsg, { duration: 6000 }); return; }
                /* v3.4.147 — التحويل إلى «لم تتم العمليه» يقفل الحجز: تأكيد صريح قبل الحفظ */
                if (String(formRef.current.operation_status || "").includes("لم تتم") && !String(record?.operation_status || "").includes("لم تتم")) {
                  if (!window.confirm(["تأكيد تحويل الحجز إلى «لم تتم العمليه»", "", "• أؤكد أنني تحققت من بيانات الحجز.", "• بعد التحويل يُقفل الحجز ولا يمكن تعديله لاحقًا (إلا بواسطة مدير النظام).", "", "هل تريد المتابعة؟"].join(String.fromCharCode(10)))) return;
                }
                onSave({ ...formRef.current, ext_pct: extPct, int_pct: intPct, ext1_pct: showExtBox ? ext1Pct : 0, ext2_pct: showExtBox ? ext2Pct : 0 }); setEditMode(false); }}>{/* v3.4.129 — النسب الفعّالة حسب نوع البيعة */}{/* v3.4.120 — منع الحفظ عند خطأ التقسيم */}
                <FiSave /> {isNew ? "إنشاء الحجز" : "حفظ التغييرات"}
              </button>
              <button className="btn-cancel" onClick={() => { if(isNew) onClose(); else { setEditMode(false); setForm(initForm(record)); } }}>إلغاء</button>
            </>
          ) : (
            <button className="btn-cancel" onClick={onClose}>إغلاق</button>
          )}
        </div>
      </div>
    </div>
  );
}
// =============================================
// v3.3.715 — سجل تغييرات الحجز (داخل نافذة العرض)
// =============================================
const RES_LOG_ACTIONS = {
  create:                   { label: "إنشاء الحجز", icon: "🆕", bg: "#dcfce7", color: "#166534" },
  update:                   { label: "تعديل الحجز", icon: "✏️", bg: "#eff6ff", color: "#1d4ed8" },
  delete:                   { label: "حذف الحجز", icon: "🗑️", bg: "#fee2e2", color: "#991b1b" },
  restore:                  { label: "استرجاع الحجز", icon: "♻️", bg: "#dcfce7", color: "#166534" },
  link_reservation_unit:    { label: "ربط وحدة", icon: "🔗", bg: "#dcfce7", color: "#166534" },
  unlink_reservation_unit:  { label: "فك ربط وحدة", icon: "⛓️", bg: "#fef3c7", color: "#92400e" },
  approve_unit_request:     { label: "اعتماد طلب الوحدة", icon: "👍", bg: "#dcfce7", color: "#166534" },
  reject_unit_request:      { label: "رفض طلب الوحدة", icon: "👎", bg: "#fee2e2", color: "#991b1b" },
  auto_hold_unit:           { label: "حجز وحدة مؤقت تلقائي", icon: "⏳", bg: "#fef3c7", color: "#92400e" },
  auto_status_sync:         { label: "مزامنة حالة الوحدة", icon: "🔄", bg: "#eff6ff", color: "#1d4ed8" },
};
const RES_LOG_FIELDS = {
  date: "التاريخ", operation_type: "نوع العملية", operation_status: "حالة العملية",
  client_name: "العميل", client_type: "مصدر العميل", developer: "المطور", marketer: "المسوق",
  unit_type: "نوع الوحدة", readiness: "الجاهزية", purchase_purpose: "هدف الشراء",
  value: "سعر البيع تنفيذ", official_price: "السعر الرسمي", discount: "الخصم", quotation_id: "عرض السعر", /* v3.4.601 */
  deposit_amount: "العربون", deposit_status: "حالة العربون", bank_account: "الحساب",
  dalala_amount: "الدلالة", commission_status_res: "حالة الدلالة (إدارة)", commission_status_acc: "حالة الدلالة (محاسبة)",
  ext_marketer_share: "حصة المسوق الخارجي", int_marketer_share: "حصة المسوق الداخلي",
  marketer1_share: "حصة المسوق 1", marketer2_share: "حصة المسوق 2", dalilak_share: "حصة دليلك",
  waha_share: "حصة الإدارة", sales_mgr_share: "حصة مدير المبيعات", mkt_mgr_share: "حصة مدير التسويق", company_share: "حصة الشركة",
  ext_pct: "نسبة المسوق الخارجي", int_pct: "نسبة المسوق الداخلي", marketer1_pct: "نسبة المسوق 1", marketer2_pct: "نسبة المسوق 2",
  dalilak_pct: "نسبة دليلك", waha_pct: "نسبة الإدارة", sales_mgr_pct: "نسبة مدير المبيعات", mkt_mgr_pct: "نسبة مدير التسويق", company_pct: "نسبة الشركة",
  notes: "ملاحظات", notes_extra: "ملاحظات إضافية", confirmed: "مؤكد", payment_agreement: "اتفاقية السداد",
  selected_project_id: "المشروع", selected_building_id: "المبنى", selected_floor: "الدور", selected_unit_code: "الوحدة المختارة",
  serial_number: "رقم التسلسل", status: "حالة الوحدة",
};
function ReservationAuditLog({ reservationId }) {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    let alive = true;
    setLoading(true);
    resApi.getAuditLog(reservationId)
      .then(r => { if (alive) setEntries(r.data?.entries || []); })
      .catch(() => {})
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [reservationId]);

  const fmtVal = (v) => (v === null || v === undefined || v === "" || v === "-") ? "—" : String(v);

  return (
    <div style={{ marginTop: 8, marginBottom: 8 }}>
      <button onClick={() => setOpen(o => !o)}
        style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center",
          padding: "10px 14px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 10,
          cursor: "pointer", fontFamily: "inherit" }}>
        <span style={{ fontSize: 13, fontWeight: 700, color: "#1e293b" }}>🕐 سجل التغييرات {loading ? "..." : `(${entries.length})`}</span>
        <span style={{ color: "#64748b", fontSize: 12 }}>{open ? "▲ إخفاء" : "▼ عرض"}</span>
      </button>
      {open && (
        <div style={{ marginTop: 8, display: "flex", flexDirection: "column", gap: 8, maxHeight: 380, overflowY: "auto" }}>
          {loading ? (
            <div style={{ textAlign: "center", padding: 20, color: "#94a3b8", fontSize: 12 }}>⏳ جاري التحميل...</div>
          ) : entries.length === 0 ? (
            <div style={{ textAlign: "center", padding: 20, color: "#94a3b8", fontSize: 12 }}>لا توجد تغييرات مسجلة</div>
          ) : entries.map(e => {
            const cfg = RES_LOG_ACTIONS[e.action] || { label: e.action, icon: "📌", bg: "#f1f5f9", color: "#475569" };
            const changes = e.changes && typeof e.changes === "object" ? e.changes : null;
            const d = e.created_at ? new Date(e.created_at) : null;
            return (
              <div key={e.id} style={{ border: "1px solid #e2e8f0", borderRadius: 10, padding: "10px 12px", background: "#fff" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                  <span style={{ background: cfg.bg, color: cfg.color, borderRadius: 12, padding: "2px 10px", fontSize: 11, fontWeight: 700 }}>
                    {cfg.icon} {cfg.label}{e.module === "projects" && e.entity_label ? ` — ${e.entity_label}` : ""}
                  </span>
                  <span style={{ fontSize: 10, color: "#64748b", direction: "ltr" }}>
                    {d ? `${d.toLocaleDateString("en-GB")} ${d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}` : "—"}
                  </span>
                </div>
                <div style={{ fontSize: 11, color: "#475569", marginTop: 6, fontWeight: 600 }}>
                  👤 {e.user_display_name || e.user_email || "النظام"}
                </div>
                {changes && Object.keys(changes).length > 0 && (
                  <div style={{ marginTop: 8, background: "#f8fafc", border: "1px solid #f1f5f9", borderRadius: 8, padding: "6px 10px", display: "flex", flexDirection: "column", gap: 3 }}>
                    {Object.entries(changes).map(([f, ch]) => (
                      <div key={f} style={{ fontSize: 10.5, display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center" }}>
                        <span style={{ color: "#64748b", fontWeight: 700, minWidth: 90 }}>{RES_LOG_FIELDS[f] || f}:</span>
                        <span style={{ color: "#991b1b", textDecoration: "line-through", overflowWrap: "anywhere" }}>{fmtVal(ch?.old)}</span>
                        <span style={{ color: "#94a3b8" }}>←</span>
                        <span style={{ color: "#166534", fontWeight: 700, overflowWrap: "anywhere" }}>{fmtVal(ch?.new)}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// =============================================
// SMART FILTER BAR - متطلب 4
// =============================================
function FilterDropdown({ label, value, options, onChange }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const ref = useRef(null);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);
  const filtered = options.filter(o => o.toLowerCase().includes(q.toLowerCase()));
  return (
    <div ref={ref} style={{ position:"relative" }}>
      <button onClick={() => { setOpen(o=>!o); setQ(""); }}
        style={{ display:"flex", alignItems:"center", gap:6, padding:"6px 12px", border:`1px solid ${value?"#2563eb":"#e2e8f0"}`, borderRadius:7, background: value?"#eff6ff":"#fff", color: value?"#2563eb":"#64748b", fontFamily:"inherit", fontSize:12, cursor:"pointer", whiteSpace:"nowrap" }}>
        {label}{value ? `: ${value}` : ""} <span style={{ fontSize:9 }}>{open?"▲":"▼"}</span>
        {value && <span onClick={e => { e.stopPropagation(); onChange(""); }} style={{ marginRight:2, color:"#94a3b8", fontWeight:700, cursor:"pointer" }}>✕</span>}
      </button>
      {open && (
        <div style={{ position:"absolute", top:"calc(100% + 2px)", right:0, minWidth:160, background:"#fff", border:"1px solid #e2e8f0", borderRadius:8, zIndex:200, boxShadow:"0 4px 16px rgba(0,0,0,0.12)", maxHeight:220, display:"flex", flexDirection:"column" }}>
          <div style={{ padding:"5px 7px", borderBottom:"1px solid #f1f5f9" }}>
            <input autoFocus value={q} onChange={e => setQ(e.target.value)} placeholder="بحث..." onClick={e=>e.stopPropagation()}
              style={{ width:"100%", padding:"4px 7px", border:"1px solid #e2e8f0", borderRadius:5, fontFamily:"inherit", fontSize:11, outline:"none" }} />
          </div>
          <div style={{ overflowY:"auto" }}>
            <div onClick={() => { onChange(""); setOpen(false); }} style={{ padding:"6px 10px", cursor:"pointer", color:"#94a3b8", fontSize:11 }}>الكل</div>
            {filtered.map(o => (
              <div key={o} onClick={() => { onChange(o); setOpen(false); }}
                style={{ padding:"6px 10px", cursor:"pointer", fontSize:12, background: value===o?"#eff6ff":"transparent", color: value===o?"#2563eb":"#1e293b", fontWeight: value===o?600:400 }}>
                {o}
              </div>
            ))}
            {filtered.length===0 && <div style={{ padding:"8px 10px", color:"#94a3b8", fontSize:11 }}>لا توجد نتائج</div>}
          </div>
        </div>
      )}
    </div>
  );
}

function SmartFilterBar({ options, filters, onFilter, onClear }) {
  const af = Object.values(filters).filter(Boolean).length;
  return (
    <div style={{ display:"flex", gap:8, padding:"8px 20px", borderBottom:"1px solid var(--border)", background:"#f8fafc", flexWrap:"wrap", alignItems:"center" }}>
      <span style={{ fontSize:11, color:"#64748b", fontWeight:600, marginLeft:4 }}>فلترة:</span>
      <FilterDropdown label="نوع العملية"  value={filters.operation_type}  options={options.operation_type||[]}  onChange={v => onFilter("operation_type",v)} />
      <FilterDropdown label="حالة العملية" value={filters.operation_status} options={options.operation_status||[]} onChange={v => onFilter("operation_status",v)} />
      <FilterDropdown label="المطور"       value={filters.developer}       options={options.developer||[]}       onChange={v => onFilter("developer",v)} />
      <FilterDropdown label="نوع العميل"   value={filters.client_type}     options={options.client_type||[]}    onChange={v => onFilter("client_type",v)} />
      {af > 0 && <button onClick={onClear} style={{ padding:"5px 12px", background:"none", border:"1px solid #fca5a5", color:"#ef4444", borderRadius:6, fontFamily:"inherit", fontSize:11, cursor:"pointer" }}>مسح الكل ({af})</button>}
    </div>
  );
}

// =============================================
// RESERVATIONS PAGE
// =============================================
// v3.3.866 — بوابة الصفحة الرئيسية: من لا يملك صلاحية الحجوزات يُحوَّل تلقائيًا لأول صفحة مخولة له
function HomeGate({ user, isAdmin }) {
  if (isAdmin || user?.can_view_reservations !== false) return <ReservationsPage />;
  const targets = [
    [user?.can_view_projects, "/projects"],
    [user?.can_view_construction, "/construction"],
    [user?.cp_can_view_dalilak_reservations || user?.cp_can_add_dalilak_reservations, "/dalilak-reservations"], // v3.4.250
    [user?.can_view_client_prospects, "/client-prospects"], // v3.4.186
    [user?.can_view_prospects, "/prospects"],
    [user?.can_view_clients, "/clients"],
    [user?.can_view_developers, "/developers"],
    [user?.can_view_marketers, "/marketers"],
    [user?.can_view_reservations_scheduler, "/reservations-scheduler"],
    [user?.can_view_sales, "/sales"], // v3.4.538
    [user?.can_view_payments, "/payments"],
    [user?.can_view_collections, "/collections"],
    [user?.can_view_contracts, "/contracts"],
    [user?.can_view_capex, "/capex"],
    [user?.can_view_sukuk, "/sukuk"],
    [user?.can_view_accounting, "/accounting"],
    [user?.can_view_analytics, "/analytics"],
    [user?.can_view_treasury, "/treasury"],
    [user?.can_view_payroll, "/payroll"], // v3.4.837
    [user?.can_view_admin_fees, "/admin-fees"],
    [user?.can_view_marketing_analytics, "/marketing-analytics"],
    [user?.can_view_office_visitors, "/office-visitors"],
    [user?.can_view_hr, "/hr"], // v3.4.192
    [user?.can_view_company_whatsapp, "/company-whatsapp"], // v3.4.180
    [user?.can_view_daleelak_whatsapp, "/daleelak-whatsapp"], // v3.4.587
    [user?.can_view_business_comm, "/business-comm"],
    [user?.can_view_settings, "/settings"],
  ];
  const hit = targets.find(([ok]) => ok);
  if (hit) return <Navigate to={hit[1]} replace />;
  return (
    <div dir="rtl" style={{ padding: 60, textAlign: "center", color: "#64748b", fontFamily: "inherit" }}>
      <div style={{ fontSize: 40, marginBottom: 12 }}>👋</div>
      <div style={{ fontSize: 16, fontWeight: 800, color: "#334155" }}>مرحبًا {user?.display_name || ""}</div>
      <div style={{ fontSize: 13, marginTop: 6 }}>لا توجد صفحات مفعّلة لحسابك بعد — تواصل مع مدير النظام لتفعيل الصلاحيات</div>
    </div>
  );
}

function ReservationsPage() {
  const { user } = useAuth();
  const perms = user?.permissions || {};
  const location = useLocation();
  const [data, setData] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [filters, setFilters] = useState({ operation_type: "", operation_status: "", developer: "", marketer: "", client_type: "" });
  const [showFilters, setShowFilters] = useState(false);
  const [quickFilter, setQuickFilter] = useState("all"); // all, daleel, company
  // v3.3.581 — Sub-filter inside "حجوزات دليلك": all / internal / external
  // Maps to operation_type:
  //   internal = "حجز مسوق داخلي" (مشاريع داخلية — مسوق دليلك على مشروع شركة Rael)
  //   external = "حجز داخلي خارجي" (مشاريع خارجية — تعاون داخلي/خارجي على مشروع غير-Rael)
  const [daleelSub, setDaleelSub] = useState("all"); // all, internal, external
  // v3.3.339 — Default: current year + current month
  const [filterYear, setFilterYear] = useState(String(new Date().getFullYear()));
  const [filterMonth, setFilterMonth] = useState(String(new Date().getMonth() + 1));
  const [filterStatus, setFilterStatus] = useState(""); // حالة العملية
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [pagination, setPagination] = useState({});
  const [sortBy, setSortBy] = useState("id");
  const [sortDir, setSortDir] = useState("DESC");
  const [selectedId, setSelectedId] = useState(null);
  const [showHealth, setShowHealth] = useState(false); // v3.4.143 — لوحة صحة الحجوزات
  const [showStats, setShowStats] = useState(false); // v3.4.690 — إحصائيات الحجوزات
  const [showNew, setShowNew] = useState(false);
  const [newFromQuote, setNewFromQuote] = useState(null); // v3.4.607 — حجز جديد من عرض سعر (من قائمة العروض)
  const [newFromUnit, setNewFromUnit] = useState(null); // v3.4.608 — حجز جديد من لوحة وحدة في خريطة الوحدات
  const [selectedRows, setSelectedRows] = useState(new Set()); // For bulk selection
  const searchTimer = useRef(null);
  const [entityPanel, setEntityPanel] = useState(null); // { type: 'client'|'marketer'|'developer', name, id }
  const { options, optionsRaw } = useRef2();
  const [hiddenCols, setHiddenCols] = useState(() => {
    try { const s = window.localStorage?.getItem("hiddenCols"); return s ? JSON.parse(s) : []; } catch { return []; }
  });
  const [colOrder, setColOrder] = useState(() => {
    try {
      const s = window.localStorage?.getItem("colOrder"); const saved = s ? JSON.parse(s) : null;
      // v3.4.115 — ترتيب محفوظ من قبل: انقل «حالة العملية» إلى المقدمة مرة واحدة (بعد التاريخ) حتى يسري الترتيب الجديد للجميع
      if (Array.isArray(saved) && window.localStorage?.getItem("colOrderV") !== "115") {
        const arr = saved.filter(k => k !== "operation_status");
        const at = arr.indexOf("date") >= 0 ? arr.indexOf("date") + 1 : (arr.indexOf("id") >= 0 ? arr.indexOf("id") + 1 : 0);
        arr.splice(at, 0, "operation_status");
        window.localStorage?.setItem("colOrder", JSON.stringify(arr)); window.localStorage?.setItem("colOrderV", "115");
        return arr;
      }
      return saved;
    } catch { return null; }
  });
  const [colFilters, setColFilters] = useState({});
  const fileRef = useRef();
  const isAdmin = user?.role === "admin" && !user?.impersonating;
  const resModPerms = user?.module_perms?.reservations || {};
  // v3.3.339 — حصر نطاق رؤية الحجوزات (المدير غير محصور)
  const forcedScope = (!isAdmin && resModPerms.scope_filter && resModPerms.scope_filter !== 'all') ? resModPerms.scope_filter : null;
  const handledNavState = useRef(false);

  // v3.3.339 — فرض الـ quickFilter على المستخدم المحصور
  useEffect(() => {
    if (forcedScope && quickFilter !== forcedScope) {
      setQuickFilter(forcedScope);
    }
  }, [forcedScope, quickFilter]);

  // Toggle row selection
  const toggleRowSelect = (id) => {
    setSelectedRows(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  // Select/Deselect all visible rows
  const toggleSelectAll = () => {
    if (selectedRows.size === data.length) {
      setSelectedRows(new Set());
    } else {
      setSelectedRows(new Set(data.map(r => r.id)));
    }
  };

  // Delete selected rows with delay to avoid rate limiting
  const [deleteRefresh, setDeleteRefresh] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const handleDeleteSelected = async () => {
    if (selectedRows.size === 0) return;
    if (!window.confirm(`هل أنت متأكد من حذف ${selectedRows.size} حجز؟`)) return;
    
    setIsDeleting(true);
    try {
      let deleted = 0;
      let failed = 0;
      const ids = Array.from(selectedRows);
      
      // Delete one by one with delay after each
      for (let i = 0; i < ids.length; i++) {
        try {
          await resApi.delete(ids[i]);
          deleted++;
        } catch (e) {
          failed++;
          console.error(`Failed to delete ${ids[i]}:`, e);
          // If rate limited, wait longer before retrying
          if (e.response?.status === 429 || e.message?.includes('Too many')) {
            await new Promise(r => setTimeout(r, 2000));
          }
        }
        // Delay after EVERY deletion to avoid rate limiting
        if (i < ids.length - 1) {
          await new Promise(r => setTimeout(r, 300));
        }
      }
      
      if (deleted > 0) {
        toast.success(`✅ تم حذف ${deleted} حجز${failed > 0 ? ` (فشل ${failed})` : ""}`);
      } else {
        toast.error("فشل حذف جميع الحجوزات");
      }
      setSelectedRows(new Set());
      setDeleteRefresh(r => r + 1); // Trigger refresh
    } catch (e) {
      toast.error(e.response?.data?.error || "فشل الحذف");
    } finally {
      setIsDeleting(false);
    }
  };

  // Spec §5.5 — open a specific reservation when navigated from Projects page
  useEffect(() => {
    const navResId = location.state?.openReservationId;
    const navNewRes = location.state?.openNewReservation;
    // v3.3.562 — Also support ?reservation=ID query param from other pages (Disbursements etc.)
    const urlParams = new URLSearchParams(window.location.search);
    const urlResId = urlParams.get("reservation");
    if (!handledNavState.current) {
      if (navResId) {
        handledNavState.current = true;
        setSelectedId(navResId);
        window.history.replaceState({}, document.title);
      } else if (urlResId) {
        handledNavState.current = true;
        setSelectedId(parseInt(urlResId));
        // Clear the query param so refresh doesn't keep reopening
        window.history.replaceState({}, document.title, window.location.pathname);
      } else if (navNewRes) {
        handledNavState.current = true;
        setNewFromQuote(location.state?.fromQuotation || null); // v3.4.607
        setNewFromUnit(location.state?.fromUnit || null); // v3.4.608
        setShowNew(true);
        window.history.replaceState({}, document.title);
      }
    }
  }, [location.state]);

  useEffect(() => { try { window.localStorage?.setItem("hiddenCols", JSON.stringify(hiddenCols)); } catch {} }, [hiddenCols]);
  useEffect(() => { try { if (colOrder) window.localStorage?.setItem("colOrder", JSON.stringify(colOrder)); } catch {} }, [colOrder]);

  const getColor = (cat, val) => {
    if (!optionsRaw?.[cat]) return null;
    const o = optionsRaw[cat].find(x => x.label === val);
    return o?.color || null;
  };

  // Column visibility: module_perms.visible_columns is the sole authority
  // Empty string = all columns visible, otherwise only listed keys are shown
  const resVisibleCols = user?.module_perms?.reservations?.visible_columns || '';
  const profileAllowedKeys = resVisibleCols ? resVisibleCols.split(',').map(s => s.trim()).filter(Boolean) : [];
  const hasProfileColFilter = profileAllowedKeys.length > 0;

  // Profile-allowed columns (empty = all allowed)
  const profileColumns = hasProfileColFilter
    ? ALL_COLUMNS.filter(c => profileAllowedKeys.includes(c.key))
    : ALL_COLUMNS;

  const visibleColumns = (() => {
    const cols = profileColumns.filter(c => !hiddenCols.includes(c.key));
    if (!colOrder) return cols;
    const ordered = [];
    colOrder.forEach(key => { const c = cols.find(x => x.key === key); if (c) ordered.push(c); });
    cols.forEach(c => { if (!ordered.includes(c)) ordered.push(c); });
    return ordered;
  })();
  const permColumns = profileColumns; // for toggle panel — only show columns the profile allows

  const toggleCol = (key) => setHiddenCols(h => h.includes(key) ? h.filter(k => k !== key) : [...h, key]);
  const moveCol = (key, dir) => {
    const keys = visibleColumns.map(c => c.key);
    const idx = keys.indexOf(key);
    if (idx < 0) return;
    const newIdx = dir === "left" ? idx + 1 : idx - 1; // RTL: left = +1, right = -1
    if (newIdx < 0 || newIdx >= keys.length) return;
    [keys[idx], keys[newIdx]] = [keys[newIdx], keys[idx]];
    setColOrder(keys);
  };
  const setColFilter = (key, val) => {
    setColFilters(f => ({ ...f, [key]: val }));
    setPage(1);
  };

  const fetchData = useCallback(async () => {
    try {
      const params = { page, limit, sort_by: sortBy, sort_dir: sortDir };
      if (search) params.search = search;
      if (filters.operation_type) params.operation_type = filters.operation_type;
      if (filters.operation_status) params.operation_status = filters.operation_status;
      if (filters.developer) params.developer = filters.developer;
      if (filters.marketer) params.marketer = filters.marketer;
      if (filters.client_type) params.client_type = filters.client_type;
      if (filters.unit_type) params.unit_type = filters.unit_type;
      if (filters.readiness) params.readiness = filters.readiness;
      if (filters.deposit_status) params.deposit_status = filters.deposit_status;
      if (filters.bank_account) params.bank_account = filters.bank_account;
      if (filters.commission_status_res) params.commission_status_res = filters.commission_status_res;
      if (filters.commission_status_acc) params.commission_status_acc = filters.commission_status_acc;
      // Quick filter: daleel = مسوق داخلي + داخلي/خارجي فقط
      // v3.3.581 — Sub-split داخلي/خارجي within دليلك
      if (quickFilter === "daleel") {
        if (daleelSub === "internal")      params.operation_type = "حجز مسوق داخلي";
        else if (daleelSub === "external") params.operation_type = "حجز داخلي خارجي";
        else                                params.operation_type = "حجز مسوق داخلي|||حجز داخلي خارجي";
      } else if (quickFilter === "company") {
        // حجوزات مشاريع الشركة — المرتبطة بمطورين عندهم مشاريع
        params.has_project_developer = "true";
      }
      // Status filter
      if (filterStatus) {
        params.operation_status = filterStatus;
      }
      // Year & Month filter
      if (filterYear) {
        const y = filterYear;
        if (filterMonth) {
          const m = String(filterMonth).padStart(2, "0");
          const daysInMonth = new Date(y, filterMonth, 0).getDate();
          params.date_from = `${y}-${m}-01`;
          params.date_to = `${y}-${m}-${daysInMonth}`;
        } else {
          params.date_from = `${y}-01-01`;
          params.date_to = `${y}-12-31`;
        }
      } else if (filterMonth) {
        const now = new Date();
        const y = now.getFullYear();
        const m = String(filterMonth).padStart(2, "0");
        const daysInMonth = new Date(y, filterMonth, 0).getDate();
        params.date_from = `${y}-${m}-01`;
        params.date_to = `${y}-${m}-${daysInMonth}`;
      }
      // Apply column filters server-side
      Object.entries(colFilters).forEach(([k, v]) => { if (v) params[k] = v; });
      const r = await resApi.list(params);
      setData(r.data.reservations); setPagination(r.data.pagination);
    } catch (e) { toast.error("فشل"); }
    setLoading(false);
  }, [page, limit, sortBy, sortDir, search, filters, colFilters, deleteRefresh, quickFilter, daleelSub, filterYear, filterMonth, filterStatus]);

  // v3.3.324: stats تتفاعل مع نفس الفلاتر المُطبّقة على القائمة
  const buildStatsParams = useCallback(() => {
    const params = {};
    if (search) params.search = search;
    if (filters.operation_type) params.operation_type = filters.operation_type;
    if (filters.operation_status) params.operation_status = filters.operation_status;
    if (filters.developer) params.developer = filters.developer;
    if (filters.marketer) params.marketer = filters.marketer;
    if (filters.client_type) params.client_type = filters.client_type;
    if (filters.unit_type) params.unit_type = filters.unit_type;
    if (filters.readiness) params.readiness = filters.readiness;
    if (filters.deposit_status) params.deposit_status = filters.deposit_status;
    if (filters.bank_account) params.bank_account = filters.bank_account;
    if (filters.commission_status_res) params.commission_status_res = filters.commission_status_res;
    if (filters.commission_status_acc) params.commission_status_acc = filters.commission_status_acc;
    // v3.3.581 — Same sub-filter logic as list query (داخلي/خارجي within دليلك)
    if (quickFilter === "daleel") {
      if (daleelSub === "internal")      params.operation_type = "حجز مسوق داخلي";
      else if (daleelSub === "external") params.operation_type = "حجز داخلي خارجي";
      else                                params.operation_type = "حجز مسوق داخلي|||حجز داخلي خارجي";
    } else if (quickFilter === "company") params.has_project_developer = "true";
    if (filterStatus) params.operation_status = filterStatus;
    if (filterYear) {
      const y = filterYear;
      if (filterMonth) {
        const m = String(filterMonth).padStart(2, "0");
        const daysInMonth = new Date(y, filterMonth, 0).getDate();
        params.date_from = `${y}-${m}-01`;
        params.date_to = `${y}-${m}-${daysInMonth}`;
      } else {
        params.date_from = `${y}-01-01`;
        params.date_to = `${y}-12-31`;
      }
    } else if (filterMonth) {
      const now = new Date();
      const y = now.getFullYear();
      const m = String(filterMonth).padStart(2, "0");
      const daysInMonth = new Date(y, filterMonth, 0).getDate();
      params.date_from = `${y}-${m}-01`;
      params.date_to = `${y}-${m}-${daysInMonth}`;
    }
    Object.entries(colFilters).forEach(([k, v]) => { if (v) params[k] = v; });
    return params;
  }, [search, filters, quickFilter, daleelSub, filterStatus, filterYear, filterMonth, colFilters]);

  const fetchStats = useCallback(async () => {
    try { const r = await resApi.stats(buildStatsParams()); setStats(r.data); } catch (e) {}
  }, [buildStatsParams]);

  useEffect(() => { fetchData(); }, [fetchData]);
  useEffect(() => { fetchStats(); }, [fetchStats]);

  const handleSearchInput = (v) => { setSearchInput(v); clearTimeout(searchTimer.current); searchTimer.current = setTimeout(() => { setSearch(v); setPage(1); }, 400); };
  const handleSort = (c) => { if (sortBy === c) setSortDir(d => d === "ASC" ? "DESC" : "ASC"); else { setSortBy(c); setSortDir("DESC"); } };

  const savingRef = useRef(false); // v3.4.146 — حارس ضد الحفظ المزدوج (سبب تكرار الحجوزات #5660/#5661 وأمثالها)
  const handleSave = async (form) => {
    if (savingRef.current) { toast("جارٍ الحفظ…", { icon: "⏳" }); return; }
    savingRef.current = true;
    try {
      // Validation: require at least one of each
      if (!form.client_ids?.length) { toast.error("يجب اختيار عميل واحد على الأقل"); return; }
      if (!form.developer_ids?.length) { toast.error("يجب اختيار مطور واحد على الأقل"); return; }
      if (!form.marketer_ids?.length) { toast.error("يجب اختيار مسوق واحد على الأقل"); return; }

      // v3.3.557 — Compute amounts from percentages so the backend has both.
      // Keep the legacy *_share columns in sync so old code (reports, exports) still works.
      const dalalaVal = Number(form.dalala_amount) || 0;
      // v3.4.819 — نفس قاعدة النموذج (v3.4.129): نوع البيعة يحدد الجدول — خارجي فقط = 100/0 وتُصفَّر نسب الداخلي والإدارة المخفية،
      // داخلي فقط = 0/100 وتُصفَّر نسب الخارجي المخفية؛ وإلا بقيت القيم القديمة من نوع سابق تُرسل وتُحفظ (#6187)
      const __sot = form.operation_type || "";
      const __sExt = __sot.includes("خارجي") && !__sot.includes("داخلي خارجي") && !__sot.includes("داخلي");
      const __sInt = (__sot.includes("داخلي") && !__sot.includes("داخلي خارجي")) || __sot.includes("مسوق داخلي");
      const extP = __sExt ? 100 : __sInt ? 0 : (Number(form.ext_pct) || 0);
      const intP = __sExt ? 0 : __sInt ? 100 : (Number(form.int_pct) || 0);
      const m1P = __sExt ? 0 : (Number(form.marketer1_pct) || 0);
      const m2P = __sExt ? 0 : (Number(form.marketer2_pct) || 0);
      const dlP = __sExt ? 0 : (Number(form.dalilak_pct) || 0);
      const whP = __sExt ? 0 : (Number(form.waha_pct) || 0);
      const smP = __sExt ? 0 : (Number(form.sales_mgr_pct) || 0);
      const mmP = __sExt ? 0 : (Number(form.mkt_mgr_pct) || 0);
      const coP = __sExt ? 0 : (Number(form.company_pct) || 0);
      const r2 = (n) => Math.round((Number(n) || 0) * 100) / 100;
      // Top-level
      const extA  = r2(dalalaVal * extP / 100);
      const intA  = r2(dalalaVal * intP / 100);
      const e1P = __sInt ? 0 : (Number(form.ext1_pct) || 0), e2P = __sInt ? 0 : (Number(form.ext2_pct) || 0); // v3.4.129 — v3.4.819 داخلي فقط = 0
      const e1A = r2(dalalaVal * e1P / 100), e2A = r2(dalalaVal * e2P / 100);
      // Marketers
      const m1A   = r2(dalalaVal * m1P / 100);
      const m2A   = r2(dalalaVal * m2P / 100);
      const dlA   = r2(dalalaVal * dlP / 100);
      // Company residual
      const compResidualPct = r2(intP - (m1P + m2P + dlP));
      const compResidualAmt = r2(dalalaVal * compResidualPct / 100);
      const whA = r2(compResidualAmt * whP / 100);
      const smA = r2(compResidualAmt * smP / 100);
      const mmA = r2(compResidualAmt * mmP / 100);
      const coA = r2(compResidualAmt * coP / 100);

      const payload = {
        ...form,
        client_ids: form.client_ids.map(x => x.id).filter(id => !String(id).startsWith("_new_")),
        developer_ids: form.developer_ids.map(x => x.id).filter(id => !String(id).startsWith("_new_")),
        marketer_ids: form.marketer_ids.map(x => x.id).filter(id => !String(id).startsWith("_new_")),
        // v3.3.559 — Per-marketer type map (sent to backend so junction can store it)
        marketer_types: form.marketer_types || {},
        // v3.3.557 — Computed amounts (kept in sync with percentages for legacy compatibility)
        ext_marketer_share: extA,
        int_marketer_share: intA,
        waha_share: whA,
        sales_mgr_share: smA,
        mkt_mgr_share: mmA,
        company_share: coA,
        marketer1_share: m1A,
        marketer2_share: m2A,
        dalilak_share: dlA,
        ext1_pct: e1P, ext2_pct: e2P, ext1_share: e1A, ext2_share: e2A, // v3.4.129
        // v3.4.819 — خارجي فقط / داخلي فقط: تُرسل النسب المطبَّعة (لا القيم المخفية القديمة في النموذج)
        ...((__sExt || __sInt) ? { ext_pct: extP, int_pct: intP, marketer1_pct: m1P, marketer2_pct: m2P, dalilak_pct: dlP, waha_pct: whP, sales_mgr_pct: smP, mkt_mgr_pct: mmP, company_pct: coP } : {}),
      };
      // v3.3.565 — Strip ALL helper/UI-only fields that shouldn't go to the backend.
      // Anything prefixed with underscore is helper state.
      Object.keys(payload).forEach(k => {
        if (k.startsWith("_")) delete payload[k];
      });

      if (form.id && !showNew) { await resApi.update(form.id, payload); toast.success("تم"); }
      else { await resApi.create(payload); toast.success("تم"); }
      setSelectedId(null); setShowNew(false); fetchData(); fetchStats();
    } catch (e) { toast.error(e.response?.data?.error || "فشل"); }
    finally { savingRef.current = false; }
  };

  const handleDelete = async (id) => {
    try { await resApi.delete(id); toast.success("تم"); setSelectedId(null); fetchData(); fetchStats(); }
    catch (e) { toast.error(e.response?.data?.error || "فشل"); }
  };

  const selectedRecord = data.find(r => r.id === selectedId);
  const af = Object.values(filters).filter(Boolean).length;
  const o = stats?.overview || {};
  const [directRecord, setDirectRecord] = useState(null);

  // Always fetch full record details when a record is selected
  useEffect(() => {
    if (selectedId) {
      // Always fetch full details to get linked_clients, linked_developers, linked_marketers
      resApi.get(selectedId).then(r => {
        const fullRecord = r.data.reservation || r.data;
        setDirectRecord(fullRecord);
      }).catch(() => {
        // Fallback to list data if fetch fails
        setDirectRecord(null);
      });
    } else {
      setDirectRecord(null);
    }
  }, [selectedId]);

  // v3.4.117 — فتح حجز محدد من رابط خارجي: /?edit=<id> (من مراجعة المباع، التحصيلات، ...) — كان الرابط يهبط على القائمة فقط
  useEffect(() => {
    try {
      const sp = new URLSearchParams(window.location.search);
      const id = parseInt(sp.get("edit") || "", 10);
      if (id > 0) {
        setSelectedId(id);
        sp.delete("edit");
        const qs = sp.toString();
        window.history.replaceState({}, "", window.location.pathname + (qs ? "?" + qs : ""));
      }
    } catch {}
  }, []);

  // Use directRecord (full data) if available, otherwise fall back to selectedRecord
  const activeRecord = directRecord || selectedRecord;

  const renderCell = (r, col) => {
    const v = r[col.key];
    // v3.3.562 — The id cell is the primary link to the reservation; styled as a clickable link badge
    if (col.key === "id") return (
      <span className="mono" style={{
        color: "#2563eb",
        fontWeight: 700,
        background: "#eff6ff",
        padding: "2px 8px",
        borderRadius: 4,
        cursor: "pointer",
      }} title={`فتح الحجز #${v}`}>
        #{v}
      </span>
    );
    if (col.key === "date") return <span className="mono">{v?.slice(0, 10)}</span>;
    if (col.key === "reservation_kind") { // v3.4.374
      const m = String(r.resale_method || ""); const isRs = /(إعادة|اعادة)\s*بيع/.test(m); const k2 = isRs && /2/.test(m);
      // v3.4.377 — علامات مختصرة بدل النص (التلميح يشرح)
      // v3.4.382 — علامة هادئة: خلفية فاتحة + رمز داكن واضح
      // v3.4.383 — دائرة فقط: زرقاء = حجز جديد، خضراء داكنة = إعادة بيع (الرقم بداخلها يميّز النوع 1/2)
      const st = !isRs ? { bg: "#2563eb", n: "", t: "حجز جديد" } : { bg: "#166534", n: k2 ? "2" : "1", t: k2 ? "إعادة بيع - 2 (عميل موقّع لم يسدّد كاملًا أعاد الوحدة)" : "إعادة بيع - 1 (عميل سدّد كاملًا وباع بسعر أعلى)" };
      return <span title={st.t} style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 18, height: 18, borderRadius: "50%", background: st.bg, color: "#fff", fontSize: 10.5, fontWeight: 900, lineHeight: 1, cursor: "help", boxShadow: "0 0 0 2px #fff, 0 0 0 3px " + st.bg + "55" }}>{st.n}</span>;
    }
    if (col.key === "operation_type") { // v3.4.378 — علامة ملوّنة: 🌐 خارجي · 🏢 داخلي · 🔀 داخلي خارجي
      const t = String(v || ""); const mixed = /داخلي\s*خارجي|خارجي\s*داخلي/.test(t); const ext = !mixed && /خارجي/.test(t); const int = !mixed && /داخلي/.test(t);
      const bg = OP_COLORS[v] || (mixed ? "#d97706" : ext ? "#059669" : int ? "#2563eb" : "#64748b");
      const g = mixed ? "د+خ" : ext ? "خ" : int ? "د" : "•"; // v3.4.382 — حرف واضح: خ خارجي · د داخلي · د+خ مختلط
      return <span title={t.replace("حجز ", "")} style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", minWidth: 30, height: 22, padding: "0 8px", background: bg + "22", color: bg, border: `1px solid ${bg}66`, borderRadius: 999, fontSize: 12, fontWeight: 900, cursor: "help", whiteSpace: "nowrap" }}>{g}</span>;
    }
    if (col.key === "client_name") {
      // تعامل مع linked_clients لاحقاً في الـ block الأسفل
    }
    if (col.key === "operation_status") { // v3.4.378 — علامة ملوّنة: ✅ تمت · ⏳ بانتظار الإجراءات · ❌ لم تتم · 💰 تمت بانتظار الدلالة · ✅⃝ تمت بلا دلالة
      const c = getColor("operation_status", v) || STATUS_COLORS[v] || "#64748b";
      const t = String(v || "");
      const g = /لم تتم/.test(t) ? "✗" : /لايوجد دلاله|لا يوجد دلاله/.test(t) ? "✓ ø" : /بإنتظار الدلاله|بانتظار الدلاله/.test(t) ? "✓ $" : /تمت/.test(t) ? "✓" : /إكمال|اكمال|بإنتظار|بانتظار/.test(t) ? "◐" : "•"; // v3.4.382 — رموز واضحة: ✓ تمت · ◐ بانتظار الإجراءات · ✗ لم تتم · ✓$ بانتظار الدلالة · ✓ø بلا دلالة
      return <span title={t} style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", minWidth: 30, height: 22, padding: "0 8px", background: c + "22", color: c, border: `1px solid ${c}66`, borderRadius: 999, fontSize: 13, fontWeight: 900, cursor: "help", whiteSpace: "nowrap" }}>{g}</span>;
    }
    if (col.key === "unit_type") { // v3.4.405 — رمز نوع الوحدة: حرف مميّز داخل حبّة فاتحة (شقة ش · فيلا ف · دور د · أرض أ · عمارة ع · محل م · مكتب ك · استراحة س · شاليه ش)
      if (!v) return <span style={{ color: "#94a3b8" }}>—</span>;
      const t = String(v).trim();
      const map = [[/شق/, "ش", "#2563eb"], [/فيل|فلل/, "ف", "#7c3aed"], [/دور|أدوار|ادوار/, "د", "#0f766e"], [/أرض|ارض|قطع/, "أ", "#b45309"], [/عمار|عمائر|بناي/, "ع", "#be185d"], [/محل|معرض/, "م", "#0e7490"], [/مكتب/, "ك", "#4f46e5"], [/استراح/, "س", "#65a30d"], [/شاليه/, "شا", "#0891b2"], [/مستودع/, "و", "#78716c"]];
      const hit = map.find(([re]) => re.test(t)); const c = getColor("unit_type", v) || (hit ? hit[2] : "#64748b"); const g = hit ? hit[1] : t.slice(0, 2);
      return <span title={t} style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", minWidth: 28, height: 22, padding: "0 8px", background: c + "22", color: c, border: `1px solid ${c}66`, borderRadius: 999, fontSize: 12.5, fontWeight: 900, cursor: "help", whiteSpace: "nowrap" }}>{g}</span>;
    }
    if (col.key === "readiness") { // v3.4.405 — رمز الجاهزية: ✓ جاهز · ◐ تحت الإنشاء · ⏱ قريبًا/مؤجّل · • غير ذلك
      if (!v) return <span style={{ color: "#94a3b8" }}>—</span>;
      const t = String(v).trim(); const ready = /جاهز|مكتمل|تم التسليم|منتهي/.test(t) && !/غير/.test(t); const wip = /إنشاء|انشاء|تنفيذ|قيد|تشطيب/.test(t); const soon = /قريب|مؤجل|لاحق/.test(t);
      const c = getColor("readiness", v) || (ready ? "#16a34a" : wip ? "#d97706" : soon ? "#2563eb" : "#64748b"); const g = ready ? "✓" : wip ? "◐" : soon ? "⏱" : "•";
      return <span title={t} style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", minWidth: 28, height: 22, padding: "0 8px", background: c + "22", color: c, border: `1px solid ${c}66`, borderRadius: 999, fontSize: 13, fontWeight: 900, cursor: "help", whiteSpace: "nowrap" }}>{g}</span>;
    }
    if (col.key === "deposit_status") { // v3.4.389 — رمز: ✓ مدفوع · ◐ بانتظار إكمال الإجراءات · ↩ مسترد/مرتجع · ✗ ملغي/غير مدفوع
      if (!v) return <span style={{ color: "#94a3b8" }}>—</span>;
      const t = String(v); const paid = /مدفوع|تم/.test(t) && !/غير|لم/.test(t); const ret = /إرجاع|ارجاع|استرد|مرتجع|مسترد/.test(t); const wait = /إنتظار|انتظار|إكمال|اكمال/.test(t);
      const c = getColor("deposit_status", v) || (ret ? "#7c3aed" : paid ? "#16a34a" : wait ? "#d97706" : "#dc2626");
      const g = ret ? "↩" : paid ? "✓" : wait ? "◐" : "✗";
      return <span title={t} style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", minWidth: 30, height: 22, padding: "0 8px", background: c + "22", color: c, border: `1px solid ${c}66`, borderRadius: 999, fontSize: 13, fontWeight: 900, cursor: "help", whiteSpace: "nowrap" }}>{g}</span>;
    }
    if (col.key === "bank_account") { // v3.4.389 — رمز: الحرفان الأولان من كلمتي اسم الحساب داخل حبّة ملوّنة (اللون ثابت لكل حساب)، والاسم الكامل في التلميح
      if (!v) return <span style={{ color: "#94a3b8" }}>—</span>;
      const t = String(v).trim(); const words = t.replace(/^(بنك|مصرف)\s+/, "").split(/\s+/).filter(Boolean);
      const g = words.length >= 2 ? words[0].slice(0, 2) + " " + words[1].slice(0, 1) : words[0] ? words[0].slice(0, 3) : "•";
      let h = 0; for (let i = 0; i < t.length; i++) h = (h * 31 + t.charCodeAt(i)) >>> 0;
      const c = getColor("bank_account", v) || ["#2563eb", "#7c3aed", "#0f766e", "#b45309", "#be185d", "#4f46e5", "#0e7490", "#65a30d"][h % 8];
      return <span title={t} style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", minWidth: 34, height: 22, padding: "0 8px", background: c + "22", color: c, border: `1px solid ${c}66`, borderRadius: 999, fontSize: 11.5, fontWeight: 900, cursor: "help", whiteSpace: "nowrap", letterSpacing: .3 }}>{g}</span>;
    }
    // حالة الدلالة (للعرض فقط - من موديول الصرف)
    if (col.key === "dalala_status") {
      if (!v) return <span style={{ color: "#94a3b8" }}>—</span>;
      const statusColors = {
        "بانتظار الاعتماد": { bg: "#fef3c7", color: "#92400e" },
        "بانتظار الصرف": { bg: "#dbeafe", color: "#1e40af" },
        "تم الصرف": { bg: "#dcfce7", color: "#166534" },
        "مرفوض": { bg: "#fee2e2", color: "#991b1b" },
      };
      const style = statusColors[v] || { bg: "#f1f5f9", color: "#64748b" };
      return <span style={{ background: style.bg, color: style.color, padding: "2px 8px", borderRadius: 10, fontSize: 11, fontWeight: 600 }}>{v}</span>;
    }
    // حالة العربون (للعرض فقط - من موديول الصرف)
    if (col.key === "arboun_status") {
      if (!v) return <span style={{ color: "#94a3b8" }}>—</span>;
      const statusColors = {
        "بانتظار الاعتماد": { bg: "#fef3c7", color: "#92400e" },
        "بانتظار الإرجاع": { bg: "#dbeafe", color: "#1e40af" },
        "تم الإرجاع": { bg: "#dcfce7", color: "#166534" },
        "مرفوض": { bg: "#fee2e2", color: "#991b1b" },
      };
      const style = statusColors[v] || { bg: "#f1f5f9", color: "#64748b" };
      return <span style={{ background: style.bg, color: style.color, padding: "2px 8px", borderRadius: 10, fontSize: 11, fontWeight: 600 }}>{v}</span>;
    }
    if (col.key === "value") { // v3.4.405 — القيمة داخل الصندوق الملوّن (كان للعربون) — لونه من حالة العربون: أزرق مدفوع
      const boxColor = getColor("deposit_status", r.deposit_status) || "#2563eb";
      return <span className="mono" style={{ background: boxColor, color: "#fff", padding: "2px 8px", borderRadius: 4, fontWeight: 700 }}>{fmt(v)}</span>;
    }
    if (col.key === "dalala_amount") {
      const dc = getColor("commission_status_res", r.commission_status_res);
      return <DalalaTooltip record={r}><span className="mono dalala" style={dc ? { background: dc, color: "#fff", padding: "2px 8px", borderRadius: 4 } : {}}>{fmt(v)}</span></DalalaTooltip>;
    }
    if (col.key === "deposit_amount") return <span className="mono money">{fmt(v)}</span>; // v3.4.405 — العربون رقم عادي (الصندوق انتقل إلى القيمة)
    if (["ext_marketer_share", "int_marketer_share", "waha_share", "sales_mgr_share", "mkt_mgr_share", "company_share"].includes(col.key)) return <span className="mono">{fmt(v)}</span>;
    if (col.key === "marketer") {
      const linked = r.linked_marketers;
      const hasLinked = linked && linked.length > 0;
      const names = hasLinked ? linked : (v ? [{ id: null, name: v }] : []);
      const isUnlinked = !hasLinked && v;
      return <span style={{display:"flex",flexWrap:"wrap",gap:3, background: isUnlinked ? "#fef2f2" : "transparent", padding: isUnlinked ? "2px 4px" : 0, borderRadius: 4}}>
        {names.map((m,i) => (
          <span key={i} className="purple" onClick={e => { e.stopPropagation(); setEntityPanel({ type:"marketer", name: m.name, id: m.id }); }}
            style={{ 
              cursor:"pointer", 
              textDecoration:"underline dotted", 
              textUnderlineOffset:2,
              color: m.id ? "inherit" : "#dc2626",
              display:"inline-flex",
              alignItems:"center",
              gap:3
            }}
            title={m.id ? "" : "⚠️ غير مربوط - اضغط لفتح الحجز وربط المسوق"}>
            {m.id && <span style={{ background:"#fae8ff", color:"#a21caf", padding:"0 4px", borderRadius:3, fontSize:9, fontWeight:700, fontFamily:"monospace" }}>#{m.id}</span>}
            {m.name}{!m.id && " ⚠️"}{i < names.length-1 ? "،" : ""}
          </span>
        ))}
      </span>;
    }
    if (col.key === "developer") {
      const linked = r.linked_developers;
      const hasLinked = linked && linked.length > 0;
      const names = hasLinked ? linked : (v ? [{ id: null, name: v }] : []);
      const isUnlinked = !hasLinked && v;
      return <span style={{display:"flex",flexWrap:"wrap",gap:3, background: isUnlinked ? "#fef2f2" : "transparent", padding: isUnlinked ? "2px 4px" : 0, borderRadius: 4}}>
        {names.map((d,i) => (
          <span key={i} onClick={e => { e.stopPropagation(); setEntityPanel({ type:"developer", name: d.name, id: d.id }); }}
            style={{ 
              cursor:"pointer", 
              textDecoration:"underline dotted", 
              textUnderlineOffset:2,
              color: d.id ? "inherit" : "#dc2626",
              display:"inline-flex",
              alignItems:"center",
              gap:3
            }}
            title={d.id ? "" : "⚠️ غير مربوط - اضغط لفتح الحجز وربط المطور"}>
            {d.id && <span style={{ background:"#dcfce7", color:"#166534", padding:"0 4px", borderRadius:3, fontSize:9, fontWeight:700, fontFamily:"monospace" }}>#{d.id}</span>}
            {d.name}{!d.id && " ⚠️"}{i < names.length-1 ? "،" : ""}
          </span>
        ))}
      </span>;
    }
    if (col.key === "client_name") {
      const linked = r.linked_clients;
      const hasLinked = linked && linked.length > 0;
      const names = hasLinked ? linked : (v ? [{ id: null, name: v }] : []);
      const isUnlinked = !hasLinked && v;
      return <span style={{display:"flex",flexWrap:"wrap",gap:3, background: isUnlinked ? "#fef2f2" : "transparent", padding: isUnlinked ? "2px 4px" : 0, borderRadius: 4}}>
        {names.map((c,i) => (
          <span key={i} className="bold" onClick={e => { e.stopPropagation(); setEntityPanel({ type:"client", name: c.name, id: c.id }); }}
            style={{ 
              cursor:"pointer", 
              textDecoration:"underline dotted", 
              textUnderlineOffset:2,
              color: c.id ? "inherit" : "#dc2626",
              display:"inline-flex",
              alignItems:"center",
              gap:3
            }}
            title={c.id ? "" : "⚠️ غير مربوط - اضغط لفتح الحجز وربط العميل"}>
            {c.id && <span style={{ background:"#e0e7ff", color:"#4338ca", padding:"0 4px", borderRadius:3, fontSize:9, fontWeight:700, fontFamily:"monospace" }}>#{c.id}</span>}
            {c.name}{!c.id && " ⚠️"}{i < names.length-1 ? "،" : ""}
          </span>
        ))}
      </span>;
    }
    // v3.3.374 — عمود الملاحظات التراكمي
    if (col.key === "notes") {
      return <ReservationNotesCell reservationId={r.id} notesLog={r.notes_log || []} compact={true} onUpdated={fetchData} />;
    }
    return <span className="small">{v}</span>;
  };

  return (
    <div className="main-page" dir="rtl">
      {stats && <div className="stats-row" style={{ alignItems: "center" }}>
        {/* v3.4.147 — زر صحة الحجوزات في الزاوية اليسرى العلوية (آخر عنصر في صف RTL مع marginRight:auto) */}
        {(isAdmin || user?.can_manage_projects || user?.can_view_audit || user?.can_manage_users) && (
          <button className="btn-filter" onClick={() => setShowHealth(true)} style={{ order: 99, marginRight: "auto", background: "#fff7ed", color: "#9a3412", border: "1px solid #fdba74", whiteSpace: "nowrap" }}>🩺 صحة الحجوزات</button>
        )}
        {/* v3.3.689 — قيمة حجوزات كل حالة داخل كرتها؛ حذف كرتي القيمة والدلالة المستقلين */}
        {[{ l: "إجمالي", v: o.total, val: o.total_value, c: "#2563eb" }, { l: "مكتمل", v: o.completed, val: o.completed_value, c: "#22c55e" }, { l: "لم تتم", v: o.failed, val: o.failed_value, c: "#ef4444" }, { l: "انتظار", v: o.pending, val: o.pending_value, c: "#f59e0b" },
        ].map((s, i) => <div key={i} className="stat-card" style={{ borderTopColor: s.c }}>
          <div className="stat-label">{s.l}</div>
          <div className="stat-val" style={{ color: s.c }}>{s.v}</div>
          {user?.can_view_reservations_total_value !== false && <div style={{ fontSize: 10, color: "#64748b", fontWeight: 700, marginTop: 2, direction: "ltr" }}>{fmt(s.val)} ر.س</div>}
        </div>)}
      </div>}

      {/* ═══ فلاتر سريعة ═══ */}
      <div style={{ display:"flex", flexDirection:"column", gap:8, marginBottom:8 }}>
        {/* صف 1: نوع الحجوزات — مخفي إذا المستخدم محصور بنطاق */}
        {!forcedScope && (
        <div style={{ display:"flex", gap:6, flexWrap:"wrap", alignItems:"center" }}>
          <span style={{ fontSize:11, color:"#64748b", fontWeight:600, marginLeft:4 }}>📋</span>
          {[
            { key:"all", label:"الكل" },
            { key:"daleel", label:"حجوزات دليلك" },
            { key:"company", label:"حجوزات مشاريع الشركة" },
          ].map(f => (
            <React.Fragment key={f.key}>
              <button onClick={() => { setQuickFilter(f.key); setPage(1); }}
                style={{ padding:"5px 14px", borderRadius:20, border: quickFilter===f.key ? "2px solid #166534" : "1px solid #e2e8f0",
                  background: quickFilter===f.key ? "#dcfce7" : "#fff", color: quickFilter===f.key ? "#166534" : "#64748b",
                  fontSize:12, fontWeight: quickFilter===f.key ? 700 : 500, cursor:"pointer", fontFamily:"inherit",
                  transition:"all 0.15s" }}>
                {f.label}
              </button>
              {/* v3.3.581 — Sub-filter inline next to "حجوزات دليلك" pill */}
              {f.key === "daleel" && quickFilter === "daleel" && (
                <div style={{ display:"inline-flex", alignItems:"center", gap:3, marginInlineStart:-2 }}>
                  <span style={{ color:"#166534", fontSize:12, fontWeight:600, marginInlineEnd:2 }}>›</span>
                  {[
                    { key:"all",      label:"الكل" },
                    { key:"internal", label:"داخلي" },
                    { key:"external", label:"خارجي" },
                  ].map(s => (
                    <button key={s.key} onClick={() => { setDaleelSub(s.key); setPage(1); }}
                      style={{
                        padding:"3px 10px", borderRadius:14,
                        border: daleelSub===s.key ? "1.5px solid #166534" : "1px solid #cbd5e1",
                        background: daleelSub===s.key ? "#bbf7d0" : "#f8fafc",
                        color: daleelSub===s.key ? "#14532d" : "#64748b",
                        fontSize:11, fontWeight: daleelSub===s.key ? 700 : 500,
                        cursor:"pointer", fontFamily:"inherit", transition:"all 0.15s",
                      }}>
                      {s.label}
                    </button>
                  ))}
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
        )}
        {/* صف 2: حالة العملية (ديناميكي من الإعدادات) */}
        <div style={{ display:"flex", gap:6, flexWrap:"wrap", alignItems:"center" }}>
          <span style={{ fontSize:11, color:"#64748b", fontWeight:600, marginLeft:4 }}>🏷</span>
          <button onClick={() => { setFilterStatus(""); setPage(1); }}
            style={{ padding:"4px 12px", borderRadius:16, border: filterStatus==="" ? "2px solid #374151" : "1px solid #e2e8f0",
              background: filterStatus==="" ? "#f1f5f9" : "#fff", color: filterStatus==="" ? "#374151" : "#64748b",
              fontSize:11, fontWeight: filterStatus==="" ? 700 : 500, cursor:"pointer", fontFamily:"inherit", transition:"all 0.15s" }}>
            الكل
          </button>
          {(options?.operation_status||[]).map(label => {
            const raw = (optionsRaw?.operation_status||[]).find(x => x.label === label);
            const c = raw?.color || "#64748b";
            return (
              <button key={label} onClick={() => { setFilterStatus(label); setPage(1); }}
                style={{ padding:"4px 12px", borderRadius:16, border: filterStatus===label ? `2px solid ${c}` : "1px solid #e2e8f0",
                  background: filterStatus===label ? (c+"20") : "#fff",
                  color: filterStatus===label ? c : "#64748b",
                  fontSize:11, fontWeight: filterStatus===label ? 700 : 500, cursor:"pointer", fontFamily:"inherit",
                  transition:"all 0.15s" }}>
                {label}
              </button>
            );
          })}
        </div>
        {/* صف 3: السنة + الأشهر */}
        <div style={{ display:"flex", gap:6, flexWrap:"wrap", alignItems:"center" }}>
          <span style={{ fontSize:11, color:"#64748b", fontWeight:600, marginLeft:4 }}>📅</span>
          {["", "2026","2025","2024","2023"].map(y => (
            <button key={y||"ally"} onClick={() => { setFilterYear(y); if(!y) setFilterMonth(""); setPage(1); }}
              style={{ padding:"4px 12px", borderRadius:16, border: filterYear===y ? "2px solid #1d4ed8" : "1px solid #e2e8f0",
                background: filterYear===y ? "#dbeafe" : "#fff", color: filterYear===y ? "#1d4ed8" : "#64748b",
                fontSize:11, fontWeight: filterYear===y ? 700 : 500, cursor:"pointer", fontFamily:"inherit",
                transition:"all 0.15s" }}>
              {y || "كل السنوات"}
            </button>
          ))}
          <span style={{ width:1, height:20, background:"#e2e8f0", margin:"0 4px" }}></span>
          {[
            {v:"",l:"الكل"},{v:1,l:"يناير"},{v:2,l:"فبراير"},{v:3,l:"مارس"},{v:4,l:"أبريل"},{v:5,l:"مايو"},{v:6,l:"يونيو"},
            {v:7,l:"يوليو"},{v:8,l:"أغسطس"},{v:9,l:"سبتمبر"},{v:10,l:"أكتوبر"},{v:11,l:"نوفمبر"},{v:12,l:"ديسمبر"}
          ].map(m => (
            <button key={m.v||"allm"} onClick={() => { setFilterMonth(m.v); setPage(1); }}
              style={{ padding:"4px 10px", borderRadius:16, border: filterMonth===m.v ? "2px solid #7c3aed" : "1px solid #e2e8f0",
                background: filterMonth===m.v ? "#ede9fe" : "#fff", color: filterMonth===m.v ? "#7c3aed" : "#64748b",
                fontSize:11, fontWeight: filterMonth===m.v ? 700 : 500, cursor:"pointer", fontFamily:"inherit",
                transition:"all 0.15s", minWidth:m.v ? "auto" : "auto" }}>
              {m.l}
            </button>
          ))}
        </div>
      </div>

      <div className="toolbar">
        <div className="search-wrap"><FiSearch />
          <input placeholder="بحث..." value={searchInput} onChange={e => handleSearchInput(e.target.value)} />
          {searchInput && <button onClick={() => { setSearchInput(""); setSearch(""); }}><FiXCircle size={14} /></button>}
        </div>
        <button className={`btn-filter ${af ? "on" : ""}`} onClick={() => setShowFilters(!showFilters)}>
          <FiFilter size={14} /> فلترة {af > 0 && <span className="badge">{af}</span>}
        </button>
        <ColumnToggle columns={permColumns} hiddenCols={hiddenCols} onToggle={toggleCol} />
        {colOrder && <button className="btn-filter" onClick={() => { setColOrder(null); try { window.localStorage?.removeItem("colOrder"); } catch {} }} title="إعادة ترتيب الأعمدة للوضع الافتراضي" style={{ fontSize: 11, padding: "4px 8px" }}>↺ ترتيب</button>}
        {showHealth && <ReservationsHealthPanel onClose={() => setShowHealth(false)} onOpenReservation={(id) => { setShowHealth(false); setSelectedId(id); }} />}
        {perms.can_create && <button className="btn-new" onClick={() => setShowNew(true)}><FiPlus size={16} /> حجز جديد</button>}
        {(isAdmin || resModPerms.can_export) && <button className="btn-filter" onClick={async () => {
          try {
            const r = await resApi.exportAll();
            const BOM = "\uFEFF";
            const DB_FIELDS = ["id","serial_number","date","operation_type","client_name","client_type","developer","unit_type","readiness","value","deposit_amount","deposit_status","bank_account","dalala_amount","operation_status","marketer","notes","ext_marketer_share","int_marketer_share","waha_share","sales_mgr_share","mkt_mgr_share","company_share","commission_status_res","commission_status_acc","notes_extra","purchase_purpose","confirmed"];
            const AR_HEADERS = ["#","التاريخ","نوع العمليه","اسم العميل","نوع العميل","المطور","نوع الوحده","الجاهزيه","القيمه","مبلغ العربون المدفوع","حالة العربون","الحساب المحول له","قيمة الدلالة","حالة العمليه","المسوق","ملاحظات","المسوق الخارجي (وحدات رئال) (100%)","المسوق الداخلي (50%)","الواحة (25%)","مدير المبيعات (10%)","مديرة المسوقات (10%)","الشركه (55%, 75%, 65%)","حالة الدلالة (إدارة الحجوزات)","حالة الدلاله (المحاسبه)","ملاحضات","#"];
            const escCSV = v => `"${String(v||"").replace(/"/g,'""')}"`; 
            const header = AR_HEADERS.map(escCSV).join(",") + "\n";
            const rows = r.data.reservations.map(row => DB_FIELDS.map(f => escCSV(row[f]||"")).join(",")).join("\n");
            const blob = new Blob([BOM + header + rows], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob); const a = document.createElement("a"); a.href = url; a.download = "reservations_export.csv"; a.click(); URL.revokeObjectURL(url);
            toast.success(`تم تصدير ${r.data.reservations.length} حجز`);
          } catch (e) { toast.error("فشل التصدير"); }
        }}>تصدير حجوزات</button>}
        {(isAdmin || resModPerms.can_import) && <>
          <button className="btn-filter" onClick={() => fileRef.current?.click()}>رفع حجوزات</button>
          <input ref={fileRef} type="file" accept=".csv" style={{ display: "none" }} onChange={async (e) => {
            const file = e.target.files[0]; if (!file) return;
            const reader = new FileReader();
            reader.onload = async (evt) => {
              const AR_TO_DB = {
                "#":"id","التاريخ":"date","نوع العمليه":"operation_type","اسم العميل":"client_name",
                "نوع العميل":"client_type","المطور":"developer","نوع الوحده":"unit_type",
                "الجاهزيه":"readiness","القيمه":"value","مبلغ العربون المدفوع":"deposit_amount",
                "حالة العربون":"deposit_status","الحساب المحول له":"bank_account",
                "قيمة الدلالة":"dalala_amount","حالة العمليه":"operation_status","المسوق":"marketer",
                "ملاحظات":"notes","المسوق الخارجي (وحدات رئال) (100%)":"ext_marketer_share",
                "المسوق الداخلي (50%)":"int_marketer_share","الواحة (25%)":"waha_share",
                "مدير المبيعات (10%)":"sales_mgr_share","مديرة المسوقات (10%)":"mkt_mgr_share",
                "الشركه (55%, 75%, 65%)":"company_share",
                "حالة الدلالة (إدارة الحجوزات)":"commission_status_res",
                "حالة الدلاله (المحاسبه)":"commission_status_acc","ملاحضات":"notes_extra",
                "id":"id","date":"date","operation_type":"operation_type","client_name":"client_name",
                "developer":"developer","value":"value","marketer":"marketer","unit_type":"unit_type",
                "readiness":"readiness","deposit_amount":"deposit_amount","deposit_status":"deposit_status",
                "bank_account":"bank_account","dalala_amount":"dalala_amount","operation_status":"operation_status",
                "client_type":"client_type","notes":"notes","ext_marketer_share":"ext_marketer_share",
                "int_marketer_share":"int_marketer_share","waha_share":"waha_share",
                "sales_mgr_share":"sales_mgr_share","mkt_mgr_share":"mkt_mgr_share",
                "company_share":"company_share","commission_status_res":"commission_status_res",
                "commission_status_acc":"commission_status_acc","notes_extra":"notes_extra","purchase_purpose":"purchase_purpose","confirmed":"confirmed"
              };
              // استخدام CSV parser صحيح يتعامل مع الفواصل داخل quotes والـ BOM
              const parseCSV = (text) => {
                const rows = []; let row = []; let field = ""; let inQ = false;
                // إزالة BOM إذا وجد
                const t = text.replace(/^\uFEFF/, "");
                for (let i = 0; i < t.length; i++) {
                  const ch = t[i], nx = t[i+1];
                  if (inQ) {
                    if (ch === '"' && nx === '"') { field += '"'; i++; }
                    else if (ch === '"') { inQ = false; }
                    else { field += ch; }
                  } else {
                    if (ch === '"') { inQ = true; }
                    else if (ch === ',') { row.push(field.trim()); field = ""; }
                    else if (ch === '\n' || (ch === '\r' && nx === '\n')) {
                      if (ch === '\r') i++;
                      row.push(field.trim()); rows.push(row); row = []; field = "";
                    } else { field += ch; }
                  }
                }
                if (field || row.length) { row.push(field.trim()); if(row.some(Boolean)) rows.push(row); }
                return rows;
              };
              const parsed = parseCSV(evt.target.result);
              if (parsed.length < 2) { toast.error("الملف فارغ"); return; }
              const rawHeaders = parsed[0].map(h => h.replace(/^"|"$/g,"").trim());
              const dbHeaders = rawHeaders.map(h => AR_TO_DB[h] || h);
              const rows = [];
              for (let i = 1; i < parsed.length; i++) {
                const vals2 = parsed[i];
                const row = {};
                dbHeaders.forEach((h, idx) => { if(h && h !== "id") row[h] = vals2[idx] || ""; });
                if (row.client_name || row.developer) rows.push(row);
              }
              try {
                const r = await resApi.importBulk(rows);
                toast.success(`تم رفع ${r.data.count} حجز`);
                fetchData(); fetchStats();
              } catch (err) { toast.error("فشل الرفع"); }
            };
            reader.readAsText(file, "UTF-8");
            e.target.value = "";
          }} />
        </>}
        <button className="btn-filter" onClick={() => setShowStats(true)} title="عدد الحجوزات الشهري حسب الحالة ومدة الإكمال — مشاريع الشركة / خارجية">📊 إحصائيات الحجوزات</button>{/* v3.4.690 */}
        {showStats && <ReservationStatsPanel onClose={() => setShowStats(false)} />}
        {/* Delete Selected Button */}
        {selectedRows.size > 0 && ((user?.role === "admin" && !user?.impersonating) || perms.can_delete) && (
          <button onClick={handleDeleteSelected} disabled={isDeleting} className="btn delete-btn"
            style={{ background: "#dc2626", color: "#fff", display: "flex", alignItems: "center", gap: 6, opacity: isDeleting ? 0.6 : 1, cursor: isDeleting ? "wait" : "pointer" }}>
            <FiTrash2 size={14} /> {isDeleting ? "جاري الحذف..." : `حذف المحدد (${selectedRows.size})`}
          </button>
        )}
                <span className="count">{selectedRows.size > 0 ? `${selectedRows.size} محدد من ` : ""}{pagination.total || 0} حجز</span>
      </div>

      {showFilters && <SmartFilterBar options={options} filters={filters} onFilter={(k,v) => { setFilters(f => ({...f,[k]:v})); setPage(1); }} onClear={() => setFilters({ operation_type:"", operation_status:"", developer:"", marketer:"", client_type:"" })} />}

      <div className="table-wrap">
        <table><thead><tr>
          {/* Select All Checkbox */}
          {((user?.role === "admin" && !user?.impersonating) || perms.can_delete) && (
            <th style={{ padding: "8px 6px", width: 36 }}>
              <input type="checkbox"
                checked={data.length > 0 && selectedRows.size === data.length}
                onChange={toggleSelectAll}
                style={{ cursor: "pointer", width: 15, height: 15 }}
                title={selectedRows.size === data.length ? "إلغاء تحديد الكل" : "تحديد الكل"} />
            </th>
          )}
          {visibleColumns.map((c, ci) => {
            return <ColumnHeaderMenu key={c.key} label={c.label} colKey={c.key}
              sortBy={sortBy} sortDir={sortDir}
              onSort={(col, dir) => { setSortBy(col); setSortDir(dir); setPage(1); }}
              onFilter={(col, val) => setColFilter(col, val)}
              onHide={(col) => toggleCol(col)}
              activeFilter={colFilters[c.key] || ""}
              onMoveLeft={ci < visibleColumns.length - 1 ? (key) => moveCol(key, "left") : null}
              onMoveRight={ci > 0 ? (key) => moveCol(key, "right") : null}
              getFilterParams={buildStatsParams} /* v3.3.999 — تسلسل إكسل: قيم القائمة = المتبقي بعد بقية الفلاتر */
            />;
          })}
        </tr></thead>
        <tbody>
          {loading ? <tr><td colSpan={visibleColumns.length + (((user?.role === "admin" && !user?.impersonating) || perms.can_delete) ? 1 : 0)} className="empty">جاري التحميل...</td></tr>
          : data.length === 0 ? <tr><td colSpan={visibleColumns.length + (((user?.role === "admin" && !user?.impersonating) || perms.can_delete) ? 1 : 0)} className="empty">لا توجد حجوزات</td></tr>
          : data.map(r => <tr key={r.id} 
              className={`${selectedId === r.id ? "selected" : ""} ${selectedRows.has(r.id) ? "bulk-selected" : ""}`}
              style={{ background: selectedRows.has(r.id) ? "#fef2f2" : undefined }}
              onClick={() => setSelectedId(r.id)}>
            {/* Row Checkbox */}
            {((user?.role === "admin" && !user?.impersonating) || perms.can_delete) && (
              <td style={{ padding: "4px 6px", textAlign: "center" }} onClick={e => e.stopPropagation()}>
                <input type="checkbox"
                  checked={selectedRows.has(r.id)}
                  onChange={() => toggleRowSelect(r.id)}
                  style={{ cursor: "pointer", width: 15, height: 15 }} />
              </td>
            )}
            {visibleColumns.map(c => <td key={c.key}>{renderCell(r, c)}</td>)}
          </tr>)}
        </tbody></table>
      </div>

      <div className="paging" style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"10px 16px", borderTop:"1px solid #e2e8f0", background:"#f8fafc", flexWrap:"wrap", gap:8 }}>
        {/* Left: limit selector */}
        <div style={{ display:"flex", alignItems:"center", gap:8, fontSize:13, color:"#64748b" }}>
          <span>عرض</span>
          {[25,50,100,200,"الكل"].map(n => (
            <button key={n} onClick={() => { setLimit(n === "الكل" ? 99999 : n); setPage(1); }}
              style={{ padding:"3px 10px", borderRadius:20, border:"1px solid", fontSize:12, cursor:"pointer",
                background: (n === "الكل" ? limit >= 99999 : limit === n) ? "#2563eb" : "#fff",
                color: (n === "الكل" ? limit >= 99999 : limit === n) ? "#fff" : "#64748b",
                borderColor: (n === "الكل" ? limit >= 99999 : limit === n) ? "#2563eb" : "#e2e8f0" }}>
              {n}
            </button>
          ))}
          <span style={{ marginRight:8 }}>من {pagination.total || 0} حجز</span>
        </div>
        {/* Right: page navigation */}
        {pagination.total_pages > 1 && (
          <div style={{ display:"flex", alignItems:"center", gap:4 }}>
            <button disabled={page <= 1} onClick={() => setPage(1)}
              style={{ padding:"4px 10px", borderRadius:6, border:"1px solid #e2e8f0", background:"#fff", cursor:page<=1?"not-allowed":"pointer", color:page<=1?"#cbd5e1":"#1e293b", fontSize:12 }}>«</button>
            <button disabled={page <= 1} onClick={() => setPage(p => p - 1)}
              style={{ padding:"4px 12px", borderRadius:6, border:"1px solid #e2e8f0", background:"#fff", cursor:page<=1?"not-allowed":"pointer", color:page<=1?"#cbd5e1":"#1e293b", fontSize:12, display:"flex", alignItems:"center", gap:4 }}>
              <FiChevronRight size={14}/> السابق
            </button>
            {Array.from({length: Math.min(7, pagination.total_pages || 1)}, (_, i) => {
              const tp = pagination.total_pages || 1;
              let pg;
              if (tp <= 7) pg = i + 1;
              else if (page <= 4) pg = i + 1;
              else if (page >= tp - 3) pg = tp - 6 + i;
              else pg = page - 3 + i;
              if (pg < 1 || pg > tp) return null;
              return (
                <button key={pg} onClick={() => setPage(pg)}
                  style={{ width:32, height:32, borderRadius:6, border:"1px solid", fontSize:13, cursor:"pointer",
                    background: pg === page ? "#2563eb" : "#fff",
                    color: pg === page ? "#fff" : "#64748b",
                    borderColor: pg === page ? "#2563eb" : "#e2e8f0", fontWeight: pg === page ? 700 : 400 }}>
                  {pg}
                </button>
              );
            })}
            <button disabled={page >= pagination.total_pages} onClick={() => setPage(p => p + 1)}
              style={{ padding:"4px 12px", borderRadius:6, border:"1px solid #e2e8f0", background:"#fff", cursor:page>=pagination.total_pages?"not-allowed":"pointer", color:page>=pagination.total_pages?"#cbd5e1":"#1e293b", fontSize:12, display:"flex", alignItems:"center", gap:4 }}>
              التالي <FiChevronLeft size={14}/>
            </button>
            <button disabled={page >= pagination.total_pages} onClick={() => setPage(pagination.total_pages)}
              style={{ padding:"4px 10px", borderRadius:6, border:"1px solid #e2e8f0", background:"#fff", cursor:page>=pagination.total_pages?"not-allowed":"pointer", color:page>=pagination.total_pages?"#cbd5e1":"#1e293b", fontSize:12 }}>»</button>
          </div>
        )}
      </div>

      {activeRecord && !showNew && !entityPanel && <WizardSidePanel record={activeRecord} isNew={false} onClose={() => { setSelectedId(null); setDirectRecord(null); }} onSave={handleSave} onDelete={handleDelete} permissions={perms} allowedColumnKeys={hasProfileColFilter ? profileAllowedKeys : null} />}
      {showNew && perms.can_create && !entityPanel && <WizardSidePanel isNew={true} prefillQuoteId={newFromQuote} prefillUnit={newFromUnit} onClose={() => { setShowNew(false); setNewFromQuote(null); setNewFromUnit(null); }} onSave={handleSave} onDelete={() => { setShowNew(false); setNewFromQuote(null); setNewFromUnit(null); }} permissions={perms} allowedColumnKeys={hasProfileColFilter ? profileAllowedKeys : null} />}
      {entityPanel && <EntityReservationsPanel entity={entityPanel} onClose={() => setEntityPanel(null)}
        onOpenReservation={(id) => { setEntityPanel(null); setSelectedId(id); }} />}
    </div>
  );
}


// v3.3.970 — أُزيلت CombinedSettingsPage: إدارة المستخدمين صارت رابطًا مستقلًا
// بالقائمة الجانبية (/users) والإعدادات تفتح صفحة القوائم مباشرة

// =============================================
// LAYOUT
// =============================================
// v3.4.191 — قسم قابل للطي في القائمة الجانبية: العنوان زر؛ يُفتح تلقائيًا إن كان يحوي الصفحة الحالية؛ وفي وضع الأيقونات فقط تظهر كل العناصر
function navContainsPath(node, path) {
  if (!node || typeof node !== "object") return false;
  if (Array.isArray(node)) return node.some((n) => navContainsPath(n, path));
  const p = node.props || {};
  if (typeof p.to === "string" && (path === p.to || path.startsWith(p.to + "/"))) return true;
  return navContainsPath(p.children, path);
}
// v3.4.257 — أيقونة لكل قسم + تغليف البنود بخط دليل جانبي
const NAV_GROUP_ICONS = { "سوشل ميديا وجرافيك": "🎨", /* v3.4.387 */ /* v3.4.361 */ "Chairman Office": "👔", "إدارة المكتب": "🏢", "الحجوزات": "📋", "المشاريع": "🏘️", "العمليات التشغيلية": "⚙️", "سندات القبض والصرف": "🧾", /* v3.4.611 */ "الموارد البشرية": "👥", "الإدارة القانونية": "⚖️", /* v3.4.420 */ "التواصل الخارجي": "📡", "قواعد البيانات": "🗂️", "نظام التسويق": "📣", "إدارة المشاريع": "🏗️", "المواقع الإلكترونية": "🌐", /* v3.4.489 */ "التحليل المالي": "📊", "النظام": "🛠️" };
function NavGroup({ id, label, show, collapsed, open, onToggle, children }) {
  const loc = useLocation();
  if (!show) return null;
  const hasActive = navContainsPath(children, loc.pathname);
  const isOpen = open || hasActive || collapsed;
  return (
    <>
      {!collapsed && (
        <div className={"nav-group-label nav-group-toggle" + (isOpen ? " open" : "")} onClick={() => onToggle(id)} role="button" title={isOpen ? "طيّ القسم" : "فتح القسم"}>
          <span><span className="nav-group-icon">{NAV_GROUP_ICONS[label] || "▪"}</span>{label}</span><span className="nav-group-chev">{isOpen ? "▾" : "◂"}</span>
        </div>
      )}
      {isOpen && (collapsed ? children : <div className="nav-group-items">{children}</div>)}
    </>
  );
}

function Layout() {
  const { user, logout, refreshUser } = useAuth();
  const [collapsed, setCollapsed] = useState(false);
  const isAdmin = user?.role === "admin" && !user?.impersonating;
  const canManage = user?.permissions?.can_manage_users || isAdmin;

  // v3.3.547 — Track every page navigation for the audit timeline.
  // Fire-and-forget POST to /api/login-history/track-page on each location change.
  usePageTracking();

  // ── كشف الجوال — عرض أقل من 768px ──
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  // ── حالة إظهار/إخفاء قنوات الواتساب في السايدبار ──
  const [waChannelVis, setWaChannelVis] = useState({ corporate: true, marketers: true, abubader2: true, abubader_biz: true });
  useEffect(() => {
    appSettings.getWaChannels().then(r => setWaChannelVis(v => ({ ...v, ...r.data }))).catch(() => {});
  }, []);

  // لو جوال — عرض واجهة الجوال
  if (isMobile) {
    return (
      <RefProvider>
        <MobilePage />
      </RefProvider>
    );
  }
  
  // Projects tree state
  const [projectsExpanded, setProjectsExpanded] = useState(false);
  const [projectsList, setProjectsList] = useState([]);
  const [loadingProjects, setLoadingProjects] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  // v3.3.363 — قسم تواصل واتس مباشر قابل للطي
  const [directCommExpanded, setDirectCommExpanded] = useState(false);
  // v3.4.445 — مجموعات فرعية داخل «إدارة المشاريع» (مفتوحة افتراضيًا، وحالة الطي تُحفظ في المتصفح)
  // v3.4.609 — المجموعات الفرعية (نظام التسويق / إدارة المشاريع / الشاشة) مطويّة افتراضيًا عند كل دخول؛ الفتح يُتذكَّر داخل الجلسة فقط
  // (المجموعة التي فيها الصفحة الحالية تُفتح تلقائيًا)
  const [pmSubs, setPmSubs] = useState(() => { try { localStorage.removeItem("pm_nav_subs"); return JSON.parse(sessionStorage.getItem("pm_nav_subs") || "{}") || {}; } catch { return {}; } });
  const togglePmSub = (k, cur) => setPmSubs(o => { const n = { ...o, [k]: !cur }; try { sessionStorage.setItem("pm_nav_subs", JSON.stringify(n)); } catch {} return n; });
  // فتح تلقائي إذا المستخدم في إحدى صفحات القنوات
  useEffect(() => {
    if (location.pathname.startsWith("/communication/")) setDirectCommExpanded(true);
  }, [location.pathname]);
  
  // Load projects when expanded (once only)
  const projectsLoadedRef = React.useRef(false);
  React.useEffect(() => {
    if ((projectsExpanded || isAdmin || user?.can_view_projects) && !projectsLoadedRef.current && projectsList.length === 0) { // v3.4.263 — the list loads for anyone who can see the projects group (it used to wait for the old inner toggle)
      projectsLoadedRef.current = true;
      setLoadingProjects(true);
      projects.list().then(r => {
        setProjectsList(r.data.projects || []);
      }).catch(() => {
        // Don't retry — prevent 429 loops
      }).finally(() => setLoadingProjects(false));
    }
  }, [projectsExpanded, user]); // eslint-disable-line

  const handleStopImpersonate = async () => {
    try {
      await auth.stopImpersonate();
      toast.success("تم إيقاف وضع المعاينة");
      refreshUser();
    } catch (e) { toast.error("فشل"); }
  };

  /* v3.4.492 — مشاريع الشاشة التفاعلية الظاهرة (تاب لكل مشروع تحت «الشاشة التفاعلية») — تُحدَّث عند تغييرها من الصفحة */
  const [screenProjects, setScreenProjects] = useState([]);
  const canScreen = isAdmin || !!user?.can_view_screen || !!user?.screen_can_manage;
  useEffect(() => {
    if (!canScreen) { setScreenProjects([]); return; }
    const f = () => screenMediaApi.overview().then(r => setScreenProjects((r.data?.projects || []).filter(x => x.enabled))).catch(() => {});
    f(); window.addEventListener("screen-projects-changed", f);
    return () => window.removeEventListener("screen-projects-changed", f);
  }, [canScreen]);

  // v3.3.312: حساب ظهور headers — يخفي الهيدر إذا كل العناصر تحته معطلة
  // v3.4.191 — أقسام القائمة المفتوحة: الافتراضي أول ثلاثة (g0..g2)؛ يُحفظ في المتصفح
  const [openGroups, setOpenGroups] = useState(() => {
    try { const s = JSON.parse(localStorage.getItem("rael:navGroups") || "null"); if (s && typeof s === "object") return s; } catch {}
    return { g0: true, g1: true, g2: true };
  });
  const toggleGroup = (id) => setOpenGroups((o) => { const n = o[id] ? { ...o, [id]: false } : { [id]: true }; /* v3.4.257 — أكورديون: فتح قسم يطوي البقية */ try { localStorage.setItem("rael:navGroups", JSON.stringify(n)); } catch {} return n; });
  // v3.4.187 — شارة غير المقروء لواتس الرقم الرئيسي (كل دقيقة، لمن يملك الصلاحية)
  const [companyWaUnread, setCompanyWaUnread] = useState(0);
  const canCompanyWa = isAdmin || !!user?.can_view_company_whatsapp;
  useEffect(() => {
    if (!canCompanyWa) { setCompanyWaUnread(0); return; }
    let alive = true;
    const tick = () => waBiz.numbers({ scope: "company" }).then(r => { if (!alive) return; const n = (r.data?.numbers || []).filter(x => x.is_company_main).reduce((s, x) => s + (Number(x.unread) || 0), 0); setCompanyWaUnread(n); }).catch(() => {});
    tick(); const t = setInterval(tick, 60000);
    const onFocus = () => tick(); window.addEventListener("focus", onFocus);
    return () => { alive = false; clearInterval(t); window.removeEventListener("focus", onFocus); };
  }, [canCompanyWa]);
  // v3.4.587 — شارة غير المقروء لرقم دليلك الرسمي
  const [daleelakUnread, setDaleelakUnread] = useState(0);
  const canDaleelakWa = isAdmin || !!user?.can_view_daleelak_whatsapp;
  useEffect(() => {
    if (!canDaleelakWa) { setDaleelakUnread(0); return; }
    let alive = true;
    const tick = () => waBiz.numbers({ scope: "daleelak" }).then(r => { if (!alive) return; setDaleelakUnread((r.data?.numbers || []).filter(x => x.is_daleelak).reduce((s, x) => s + (Number(x.unread) || 0), 0)); }).catch(() => {});
    tick(); const t = setInterval(tick, 60000);
    const onFocus = () => tick(); window.addEventListener("focus", onFocus);
    return () => { alive = false; clearInterval(t); window.removeEventListener("focus", onFocus); };
  }, [canDaleelakWa]);
  // v3.4.207 — شارة مهامي المفتوحة (كل دقيقة)
  const [myTasksOpen, setMyTasksOpen] = useState(0);
  const canTasks = isAdmin || !!user?.can_view_tasks || !!user?.tasks_can_assign;
  useEffect(() => {
    if (!canTasks) { setMyTasksOpen(0); return; }
    let alive = true;
    const tick = () => staffTasks.summary().then(r => { if (alive) setMyTasksOpen(Number(r.data?.open) || 0); }).catch(() => {});
    tick(); const t = setInterval(tick, 60000);
    const onFocus = () => tick(); window.addEventListener("focus", onFocus);
    return () => { alive = false; clearInterval(t); window.removeEventListener("focus", onFocus); };
  }, [canTasks]);
  // v3.4.835 — Alma Capital: الوصول للقسم أو أي علم تبويب (alma_can_view_*) يُظهر المجموعة والمسار
  const almaAccess = isAdmin || !!user?.can_view_alma || !!user?.alma_can_manage || ["content", "messages", "compliance", "people", "startup", "settings"].some((t) => user?.[`alma_can_view_${t}`]);
  const showDataGroup = isAdmin || user?.can_view_clients || user?.can_view_client_groups
    || user?.can_view_developers || user?.can_view_marketers || user?.can_view_marketer_groups
    || user?.can_view_prospects || user?.can_view_prospect_groups; // v3.4.186 — مسوقين محتملين ومجموعاتهم تحت البيانات
  const showActionsGroup = isAdmin
    || user?.module_perms?.disbursements?.can_view
    || user?.module_perms?.disbursements?.can_request
    || user?.module_perms?.disbursements?.can_approve
    || user?.module_perms?.disbursements?.can_execute
    || user?.can_view_contracts
    || (user?.can_view_client_comm && waChannelVis.corporate !== false)
    || (user?.can_view_marketer_comm && waChannelVis.marketers !== false)
    || (user?.can_view_wa_abubader2 && waChannelVis.abubader2 !== false)
    || (user?.can_view_wa_abubader_biz && waChannelVis.abubader_biz !== false)
    || user?.can_view_business_comm
    || user?.can_view_wa_updates_group // v3.4.271
    || user?.can_view_invitations; // v3.4.410

  return (
    <div className="layout" dir="rtl">
      <aside className={`sidebar ${collapsed ? "collapsed" : ""}`}>
        <div className="sb-head"><h2 style={{ fontSize: collapsed ? 13 : undefined }}>{collapsed ? "ERP" : "نظام ERP لإدارة الشركة"}</h2>{/* v3.4.193 */}
          <button onClick={() => setCollapsed(!collapsed)}>{collapsed ? <FiMenu /> : <FiX />}</button></div>
        <nav>
          {/* v3.3.969 — مجموعة إدارة المكتب أعلى القائمة، وسجل زوار المكتب انتقل إليها (كان بمجموعة الحجوزات) */}
          {/* v3.4.328 — Chairman Office: مجموعة أولى في القائمة */}
          <NavGroup id="gchair" label="Chairman Office" show={(isAdmin || user?.can_view_chairman_office)} collapsed={collapsed} open={!!openGroups["gchair"]} onToggle={toggleGroup}>{/* v3.4.835 — Alma Capital عاد مجموعة مستقلة أدناه */}
            <NavLink to="/chairman-mail" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiMail />{!collapsed && <span>الإيميلات</span>}</NavLink>
            <NavLink to="/chairman-calendar" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiCalendar />{!collapsed && <span>التقويم</span>}</NavLink>{/* v3.4.339 */}
            <NavLink to="/chairman-comm" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiMessageCircle />{!collapsed && <span>التواصل الخارجي</span>}</NavLink>{/* v3.4.342 — واتساب ابوبدر 2 / بزنس */}
            <NavLink to="/chairman-contacts" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiUsers />{!collapsed && <span>Chairman Contacts</span>}</NavLink>{/* v3.4.345 */}
          </NavGroup>
          {/* v3.4.835 — Alma Capital مجموعة رئيسية مستقلة (طلب المالك)؛ تظهر لمن يملك الوصول للقسم أو أي تبويب منه */}
          <NavGroup id="galma" label="Alma Capital" show={almaAccess} collapsed={collapsed} open={!!openGroups["galma"]} onToggle={toggleGroup}>
            <NavLink to="/alma-website" className={({ isActive }) => isActive ? "nav active" : "nav"}><span style={{ width: 16, textAlign: "center" }}>🏛️</span>{!collapsed && <span>موقع ألما الإلكتروني</span>}</NavLink>
          </NavGroup>
          <NavGroup id="g0" label="إدارة المكتب" show={(isAdmin || user?.can_view_letters || user?.can_view_office_visitors || user?.can_view_company_whatsapp || user?.can_view_daleelak_whatsapp || user?.can_view_tasks || user?.tasks_can_assign)} collapsed={collapsed} open={!!openGroups["g0"]} onToggle={toggleGroup}>
          {(isAdmin || user?.can_view_office_visitors) && (
            <NavLink to="/office-visitors" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiUserCheck />{!collapsed && <span>سجل زوار المكتب</span>}</NavLink>
          )}
          {/* v3.4.180 / v3.4.587 / v3.4.743 — واتساب الأرقام الرسمية: شاشة واحدة للرقم الرئيسي ورقم دليلك (بطاقتان منفصلتان) */}
          {(isAdmin || user?.can_view_company_whatsapp || user?.can_view_daleelak_whatsapp) && (
            <NavLink to="/official-whatsapp" className={({ isActive }) => isActive ? "nav active" : "nav"} title={(companyWaUnread + daleelakUnread) > 0 ? `${companyWaUnread + daleelakUnread} رسالة غير مقروءة` : undefined}><FiMessageCircle />{!collapsed && <span>واتساب الأرقام الرسمية</span>}
              {(companyWaUnread + daleelakUnread) > 0 && <span style={{ marginInlineStart: collapsed ? 0 : "auto", background: "#dc2626", color: "#fff", borderRadius: 999, padding: "0 7px", fontSize: 10.5, fontWeight: 800, lineHeight: "18px", minWidth: 18, textAlign: "center" }}>{(companyWaUnread + daleelakUnread) > 999 ? "999+" : companyWaUnread + daleelakUnread}</span>}
            </NavLink>
          )}
          {/* v3.4.207 — قائمة المهام للموظفين (تحت واتس الرقم الرئيسي) */}
          {(isAdmin || user?.can_view_tasks || user?.tasks_can_assign) && (
            <NavLink to="/staff-tasks" className={({ isActive }) => isActive ? "nav active" : "nav"} title={myTasksOpen > 0 ? `${myTasksOpen} مهمة مفتوحة` : undefined}><FiCheckSquare />{!collapsed && <span>قائمة المهام للموظفين</span>}
              {myTasksOpen > 0 && <span style={{ marginInlineStart: collapsed ? 0 : "auto", background: "#dc2626", color: "#fff", borderRadius: 999, padding: "0 7px", fontSize: 10.5, fontWeight: 800, lineHeight: "18px", minWidth: 18, textAlign: "center" }}>{myTasksOpen}</span>}
            </NavLink>
          )}
          {/* v3.4.815 — الخطابات الرسمية */}
          {(isAdmin || user?.can_view_letters) && (
            <NavLink to="/letters" className={({ isActive }) => isActive ? "nav active" : "nav"}><span style={{ width: 16, textAlign: "center" }}>📄</span>{!collapsed && <span>الخطابات الرسمية</span>}</NavLink>
          )}
          {/* المجموعة الأولى: الحجوزات */}
          </NavGroup>
          {/* v3.4.558 — «الحجوزات» انتقلت إلى أول «العمليات التشغيلية» (كانت مجموعة مستقلة g1) */}
          {/* v3.4.261 — قسم «المشاريع»: كل المشاريع + قائمة المشاريع بعدد وحداتها (تظهر بفتح القسم) */}
          <NavGroup id="g1p" label="المشاريع" show={(isAdmin || user?.can_view_projects)} collapsed={collapsed} open={!!openGroups["g1p"]} onToggle={toggleGroup}>
            <NavLink to="/projects" end className={() => "nav" + (location.pathname === "/projects" && !location.search ? " active" : "")}><FiGrid />{!collapsed && <span>كل المشاريع</span>}</NavLink>
            {!collapsed && (loadingProjects ? (
              <div style={{ padding: "10px 14px", fontSize: 11, color: "rgba(255,255,255,0.5)", textAlign: "center" }}>جاري التحميل...</div>
            ) : projectsList.map(p => {
              const isCur = location.pathname === "/projects" && new URLSearchParams(location.search).get("id") === String(p.id);
              return (
                <div key={p.id} onClick={() => navigate(`/projects?id=${p.id}`)} className={"nav nav-proj" + (isCur ? " active" : "")} title={p.name}>
                  <span style={{ fontSize: 13 }}>🏢</span>
                  <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{p.name}</span>
                  <span className="nav-proj-badge">{p.total_units || 0}</span>
                </div>
              );
            }))}
          </NavGroup>
          {/* v3.4.560 — «العمليات التشغيلية» مباشرة تحت «المشاريع» (كانت بعد سوشل ميديا وجرافيك) */}
          <NavGroup id="g2" label="العمليات التشغيلية" show={(isAdmin || user?.can_view_reservations !== false || user?.can_view_quotations || user?.can_view_reservations_scheduler || user?.can_view_payments || user?.can_view_collections || user?.can_view_marketing_analytics || user?.can_view_contracts || user?.module_perms?.disbursements?.can_view || user?.module_perms?.disbursements?.can_request || user?.module_perms?.disbursements?.can_approve || user?.module_perms?.disbursements?.can_execute)} collapsed={collapsed} open={!!openGroups["g2"]} onToggle={toggleGroup}>
          {(isAdmin || user?.can_view_quotations) && (/* v3.4.561 — v3.4.562: أول عنصر في المجموعة */
            <NavLink to="/quotations" className={({ isActive }) => isActive ? "nav active" : "nav"}>
              <span style={{ width: 16, textAlign: "center" }}>📄</span>{!collapsed && <span>عروض الأسعار</span>}
            </NavLink>
          )}
          {(isAdmin || user?.can_view_reservations !== false) && (/* v3.4.558 — كانت في مجموعة مستقلة */
            <NavLink to="/" end className={({ isActive }) => isActive ? "nav active" : "nav"}><FiHome />{!collapsed && <span>الحجوزات</span>}</NavLink>
          )}
          {(isAdmin || user?.can_view_reservations_scheduler) && (
            <NavLink to="/reservations-scheduler" className={({ isActive }) => isActive ? "nav active" : "nav"}>
              <FiCalendar />{!collapsed && <span>تنسيق الحجوزات</span>}
            </NavLink>
          )}
          {/* v3.4.593 — العقود بين «تنسيق الحجوزات» و«المبيعات» */}
          {(isAdmin || user?.can_view_contracts) && (
            <NavLink to="/contracts" className={({ isActive }) => isActive ? "nav active" : "nav"}>
              <FiFileText />{!collapsed && <span>العقود</span>}
            </NavLink>
          )}
          {(isAdmin || user?.can_view_sales) && (/* v3.4.538 */
            <NavLink to="/sales" className={({ isActive }) => isActive ? "nav active" : "nav"}>
              <FiTag />{!collapsed && <span>المبيعات</span>}
            </NavLink>
          )}
          {(isAdmin || user?.can_view_payments) && (
            <NavLink to="/payments" className={({ isActive }) => isActive ? "nav active" : "nav"}>
              <FiCreditCard />{!collapsed && <span>المدفوعات المحصّلة</span>}
            </NavLink>
          )}
          {(isAdmin || user?.can_view_collections) && (
            <NavLink to="/collections" className={({ isActive }) => isActive ? "nav active" : "nav"}>
              <FiTrendingDown />{!collapsed && <span>إدارة الدفعات والتحصيلات</span>}
            </NavLink>
          )}
          {/* v3.3.759 — تحليل التسويق الداخلي */}
          {(isAdmin || user?.can_view_marketing_analytics) && (
            <NavLink to="/marketing-analytics" className={({ isActive }) => isActive ? "nav active" : "nav"}>
              <FiTrendingUp />{!collapsed && <span>تحليل التسويق</span>}
            </NavLink>
          )}
          {/* v3.4.249 — صرف الدلالات والعقود (كانا في مجموعة «الإجراءات») */}
          {(isAdmin || user?.module_perms?.disbursements?.can_view || user?.module_perms?.disbursements?.can_request || user?.module_perms?.disbursements?.can_approve || user?.module_perms?.disbursements?.can_execute) && (
            <NavLink to="/disbursements" className={({ isActive }) => isActive ? "nav active" : "nav"}>
              <FiDollarSign />{!collapsed && <span>صرف الدلالات</span>}
            </NavLink>
          )}

          {/* المجموعة: الإجراءات — v3.4.040: نُقلت قبل مجموعة البيانات بطلب المشغّل */}
          </NavGroup>
          {/* v3.4.611 — سندات القبض والصرف: مجموعة رئيسية بعد العمليات التشغيلية */}
          <NavGroup id="g_vouchers" label="سندات القبض والصرف" show={(isAdmin || user?.can_view_vouchers)} collapsed={collapsed} open={!!openGroups["g_vouchers"]} onToggle={toggleGroup}>
            <NavLink to="/vouchers" end className={({ isActive }) => isActive && !location.search.includes("tab=") ? "nav active" : "nav"}><span style={{ width: 16, textAlign: "center" }}>🧾</span>{!collapsed && <span>سندات القبض</span>}</NavLink>
            <NavLink to="/vouchers?tab=payment" className={() => location.pathname === "/vouchers" && location.search.includes("tab=payment") ? "nav active" : "nav"}><span style={{ width: 16, textAlign: "center" }}>💸</span>{!collapsed && <span>سندات الصرف</span>}</NavLink>
            {(isAdmin || user?.vouchers_can_manage) && <NavLink to="/vouchers?tab=settings" className={() => location.pathname === "/vouchers" && location.search.includes("tab=settings") ? "nav active" : "nav"}><span style={{ width: 16, textAlign: "center" }}>⚙️</span>{!collapsed && <span>إعدادات السندات</span>}</NavLink>}
            {(isAdmin || user?.vouchers_can_manage) && <NavLink to="/vouchers?tab=history" className={() => location.pathname === "/vouchers" && location.search.includes("tab=history") ? "nav active" : "nav"}><span style={{ width: 16, textAlign: "center" }}>📜</span>{!collapsed && <span>History Log</span>}</NavLink>}{/* v3.4.618 */}
          </NavGroup>
          {/* v3.4.561 — «قواعد البيانات» مباشرة بعد «العمليات التشغيلية» */}
          <NavGroup id="g4" label="قواعد البيانات" show={showDataGroup} collapsed={collapsed} open={!!openGroups["g4"]} onToggle={toggleGroup}>
          {(isAdmin || user?.can_view_clients) && (
            <NavLink to="/clients" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiUsers />{!collapsed && <span>العملاء</span>}</NavLink>
          )}
          {(isAdmin || user?.can_view_client_groups) && (
            <NavLink to="/client-groups" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiGrid />{!collapsed && <span>مجموعات العملاء</span>}</NavLink>
          )}
          {(isAdmin || user?.can_view_developers) && (
            <NavLink to="/developers" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiBriefcase />{!collapsed && <span>المطورين</span>}</NavLink>
          )}
          {(isAdmin || user?.can_view_marketers) && (
            <NavLink to="/marketers" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiTrendingUp />{!collapsed && <span>المسوقين</span>}</NavLink>
          )}
          {(isAdmin || user?.can_view_marketer_groups) && (
            <NavLink to="/marketer-groups" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiGrid />{!collapsed && <span>مجموعات المسوقين</span>}</NavLink>
          )}
          {/* v3.3.679 — «مسوقين محتملين» ومجموعاتهم — v3.4.186: تحت البيانات */}
          {(isAdmin || user?.can_view_prospects) && (
            <NavLink to="/prospects" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiUserCheck />{!collapsed && <span>مسوقين محتملين</span>}</NavLink>
          )}
          {(isAdmin || user?.can_view_prospect_groups) && (
            <NavLink to="/prospect-groups" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiGrid />{!collapsed && <span>مجموعات مسوقين محتملين</span>}</NavLink>
          )}
          {/* v3.3.823 — قسم مستقل "نظام التسويق": عملاء محتملين + مجموعاتهم (كانا تحت البيانات) */}
          {/* v3.4.107 — علم عرض مستقل لكل عنصر؛ عنوان المجموعة يظهر إن كان أي عنصر مخوّلًا */}
          </NavGroup>
          {/* v3.4.192 — الموارد البشرية */}
          <NavGroup id="g_hr" label="الموارد البشرية" show={isAdmin || !!user?.can_view_hr} collapsed={collapsed} open={!!openGroups["g_hr"]} onToggle={toggleGroup}>
            {/* v3.4.266 — بنود الموارد البشرية: الداشبورد / الحضور / الطلبات / الموظفون / التقرير (التاب عبر ?tab=) */}
            {(() => {
              const cur = location.pathname === "/hr" ? (new URLSearchParams(location.search).get("tab") || "dashboard") : "";
              const items = [["dashboard", "🏠", "الداشبورد الرئيسية"], ["attendance", "🕒", "سجل الحضور والانصراف"], ["requests", "📝", "الطلبات"], ...((isAdmin || user?.hr_can_view_applicants) ? [["applicants", "🧑‍💼", "المتقدمون للوظائف"]] : []) /* v3.4.543 */, ["report", "📊", "التقرير الشهري والخصومات"], ["settings", "⚙️", "الإعدادات"]]; // v3.4.268 — الموظفون/المواقع/الدوام داخل الإعدادات
              return items.map(([k, ic, l]) => (
                <NavLink key={k} to={k === "dashboard" ? "/hr" : `/hr?tab=${k}`} className={() => "nav" + (cur === k ? " active" : "")}>
                  <span style={{ width: 16, textAlign: "center" }}>{ic}</span>{!collapsed && <span>{l}</span>}
                </NavLink>
              ));
            })()}
          </NavGroup>
          {/* v3.4.420 — الإدارة القانونية */}
          <NavGroup id="g_legal" label="الإدارة القانونية" show={isAdmin || !!user?.can_view_legal} collapsed={collapsed} open={!!openGroups["g_legal"]} onToggle={toggleGroup}>
            {(() => {
              const cur = location.pathname === "/legal" ? (new URLSearchParams(location.search).get("tab") || "overview") : "";
              const items = [["overview", "📊", "نظرة عامة"], ["contracts", "📑", "مكتبة العقود"], ["cases", "⚖️", "سجل القضايا"], ["violations", "🚧", "سجل المخالفات البلدية"], ["registry", "🏷️", "مكتبة السجلات والعلامات التجارية"]];
              return items.map(([k, ic, l]) => (
                <NavLink key={k} to={k === "overview" ? "/legal" : `/legal?tab=${k}`} className={() => "nav" + (cur === k ? " active" : "")}>
                  <span style={{ width: 16, textAlign: "center" }}>{ic}</span>{!collapsed && <span>{l}</span>}
                </NavLink>
              ));
            })()}
          </NavGroup>
          <NavGroup id="g3" label="التواصل الخارجي" show={showActionsGroup} collapsed={collapsed} open={!!openGroups["g3"]} onToggle={toggleGroup}>
          {/* v3.4.249 — صرف الدلالات والعقود نُقلا إلى مجموعة «العمليات التشغيلية» */}
          {/* v3.3.363 — قسم "تواصل واتس مباشر" قابل للطي يجمع الـ 4 قنوات */}
          {(() => {
            const showClient = (isAdmin || user?.can_view_client_comm) && waChannelVis.corporate !== false;
            const showMarketer = (isAdmin || user?.can_view_marketer_comm) && waChannelVis.marketers !== false;
            const showAB2 = false, showABBiz = false; // v3.4.342 — انتقلتا إلى Chairman Office › التواصل الخارجي
            const anyChannel = showClient || showMarketer || showAB2 || showABBiz;
            if (!anyChannel) return null;
            const isOnAnyChannel = location.pathname.startsWith("/communication/");
            return (
              <>
                <div
                  className={`nav ${isOnAnyChannel ? "active" : ""}`}
                  style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                  onClick={() => {
                    if (collapsed) {
                      // في الوضع المطوي اذهب للأول المتاح
                      if (showClient) navigate("/communication/clients");
                      else if (showMarketer) navigate("/communication/marketers");
                      else if (showAB2) navigate("/communication/abubader2");
                      else if (showABBiz) navigate("/communication/abubader-biz");
                    } else {
                      setDirectCommExpanded(!directCommExpanded);
                    }
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <FiUsers />
                    {!collapsed && <span>تواصل واتس مباشر</span>}
                  </div>
                  {!collapsed && (
                    <span style={{ fontSize: 10, transition: "transform 0.2s", transform: directCommExpanded ? "rotate(90deg)" : "rotate(0)" }}>
                      ◀
                    </span>
                  )}
                </div>
                {!collapsed && directCommExpanded && (
                  <div style={{ background: "rgba(0,0,0,0.2)", borderRadius: 8, margin: "4px 6px 8px 6px", border: "1px solid rgba(255,255,255,0.1)" }}>
                    {showClient && (
                      <NavLink to="/communication/clients" className={({ isActive }) => isActive ? "nav active" : "nav"} style={{ padding: "10px 14px", fontSize: 12, borderRadius: 6 }}>
                        <FiUsers size={14} /><span>تواصل العملاء</span>
                      </NavLink>
                    )}
                    {showMarketer && (
                      <NavLink to="/communication/marketers" className={({ isActive }) => isActive ? "nav active" : "nav"} style={{ padding: "10px 14px", fontSize: 12, borderRadius: 6 }}>
                        <FiUserCheck size={14} /><span>تواصل المسوقين</span>
                      </NavLink>
                    )}
                    {showAB2 && (
                      <NavLink to="/communication/abubader2" className={({ isActive }) => isActive ? "nav active" : "nav"} style={{ padding: "10px 14px", fontSize: 12, borderRadius: 6 }}>
                        <FiUserCheck size={14} /><span>تواصل ابوبدر 2</span>
                      </NavLink>
                    )}
                    {showABBiz && (
                      <NavLink to="/communication/abubader-biz" className={({ isActive }) => isActive ? "nav active" : "nav"} style={{ padding: "10px 14px", fontSize: 12, borderRadius: 6 }}>
                        <FiUserCheck size={14} /><span>تواصل ابوبدر بزنس</span>
                      </NavLink>
                    )}
                  </div>
                )}
              </>
            );
          })()}
          {(isAdmin || user?.can_view_business_comm) && (
            <NavLink to="/business-comm" className={({ isActive }) => isActive ? "nav active" : "nav"}>
              <FiMessageCircle />{!collapsed && <span>التواصل المؤسسي</span>}
            </NavLink>
          )}
          {/* v3.4.271 — إدارة جروب التحديثات (واتس): الاستراتيجية الأسبوعية + الإرسال */}
          {(isAdmin || user?.can_view_wa_updates_group) && (/* v3.4.410 — علم الجروب فقط */
            <NavLink to="/wa-updates-group" className={({ isActive }) => isActive ? "nav active" : "nav"}>
              <span style={{ width: 16, textAlign: "center" }}>📢</span>{!collapsed && <span>إدارة جروب التحديثات (واتس)</span>}
            </NavLink>
          )}
          {/* v3.4.513 — إدارة الواتس: الحد اليومي لكل رقم + إجراءات الحماية (للأدمن أو من يملك إدارة المستخدمين) */}
          {(isAdmin || user?.can_manage_users || user?.can_view_wa_admin || user?.wa_admin_can_manage) && (/* v3.4.744 — علم إدارة الواتس */
            <NavLink to="/wa-admin" className={({ isActive }) => isActive ? "nav active" : "nav"}>
              <span style={{ width: 16, textAlign: "center" }}>🛡️</span>{!collapsed && <span>إدارة الواتس</span>}
            </NavLink>
          )}
          {/* v3.4.062 — الدعوات: كانت تابًا داخل التواصل المؤسسي وصارت بندًا مستقلًا */}
          {(isAdmin || user?.can_view_invitations || user?.invitations_can_send) && (/* v3.4.410 — علم الدعوات */
            <NavLink to="/invitations" className={({ isActive }) => isActive ? "nav active" : "nav"}>
              <FiImage />{!collapsed && <span>الدعوات</span>}
            </NavLink>
          )}

          {/* المجموعة الثانية: البيانات */}
          </NavGroup>
          {/* v3.4.788 — نُقلت المجموعة إلى ما قبل «نظام التسويق» بطلب المالك */}
          {/* v3.4.361 — مكتبة الميديا والجرافيك: المحتوى الدعائي العام + مكتبة لكل مشروع (مسؤولية فريق التصميم) */}
          <NavGroup id="gmedia" label="سوشل ميديا وجرافيك" show={(isAdmin || user?.can_view_media_library || user?.can_view_social_media || user?.can_view_client_prospects || user?.can_view_websites || user?.websites_can_edit || user?.can_view_digital_accounts)} collapsed={collapsed} open={!!openGroups["gmedia"]} onToggle={toggleGroup}>{/* v3.4.389 — عنصران فقط: المكتبة (العام + المكتبات + المشاريع داخل الصفحة) وإدارة السوشل ميديا */}
            {(isAdmin || user?.can_view_media_library) && <NavLink to="/media-library" end className={({ isActive }) => (isActive || (/^\/media-library\/(?!social)/.test(location.pathname))) ? "nav active" : "nav"}><span style={{ width: 16, textAlign: "center" }}>🎨</span>{!collapsed && <span>مكتبة التصاميم والجرافيك</span>}</NavLink>}
            {(isAdmin || user?.can_view_social_media || user?.can_view_client_prospects) && <NavLink to="/media-library/social" className={({ isActive }) => isActive ? "nav active" : "nav"}><span style={{ width: 16, textAlign: "center" }}>📣</span>{!collapsed && <span>إدارة السوشل ميديا</span>}</NavLink>}
            {/* v3.4.547 — المواقع الإلكترونية + مرجع الحسابات الإلكترونية — v3.4.789: بند واحد بمستوى «إدارة السوشل ميديا» (مبدّل الشركة داخل الصفحة) */}
            {(isAdmin || user?.can_view_websites || user?.websites_can_edit) && <NavLink to="/websites/rael" className={() => location.pathname.startsWith("/websites/") ? "nav active" : "nav"}><span style={{ width: 16, textAlign: "center" }}>🌐</span>{!collapsed && <span>المواقع الإلكترونية</span>}</NavLink>}
            {(isAdmin || user?.can_view_digital_accounts) && <NavLink to="/digital-accounts" className={({ isActive }) => isActive ? "nav active" : "nav"}><span style={{ width: 16, textAlign: "center" }}>🗝️</span>{!collapsed && <span>مرجع الحسابات الإلكترونية</span>}</NavLink>}
          </NavGroup>
          <NavGroup id="g5" label="نظام التسويق" show={(isAdmin || user?.can_view_screen || user?.screen_can_manage || user?.can_view_aqar_listings || user?.can_view_client_prospects || user?.can_view_portal_app || user?.can_view_land_offers || user?.can_view_project_offers || user?.can_view_callcenter || user?.can_view_business_chat || user?.can_manage_users || user?.cp_can_manage_accounts || user?.cp_can_view_dalilak_reservations || user?.cp_can_add_dalilak_reservations)} collapsed={collapsed} open={!!openGroups["g5"]} onToggle={toggleGroup}>{/* v3.4.186 */}
          {/* v3.4.587 — مجموعات فرعية قابلة للطي داخل «نظام التسويق» (بنفس نمط «إدارة المشاريع» و«الشاشة التفاعلية»): المنظم التسويقي / نظام CRM / عروض عقارية / الكول سنتر والواتس */}
          {(() => {
            const P = location.pathname;
            const sub = (key, label, icon, show, onIt, children) => {
              if (!show) return null;
              const open = onIt || (pmSubs[key] !== undefined ? pmSubs[key] : false);
              if (collapsed) return <React.Fragment key={key}>{children}</React.Fragment>;
              return (
                <div key={key} style={{ margin: "6px 0 2px" }}>
                  <div role="button" tabIndex={0} onClick={() => !onIt && togglePmSub(key, open)} onKeyDown={ev => (ev.key === "Enter" || ev.key === " ") && !onIt && togglePmSub(key, open)}
                    title={onIt ? "أنت داخل هذه المجموعة" : open ? "طيّ" : "فتح"}
                    style={{ display: "flex", alignItems: "center", gap: 8, padding: "7px 10px", margin: "0 4px", borderRadius: 8, background: onIt ? "rgba(251,191,36,.16)" : "rgba(0,0,0,.24)", borderInlineStart: "3px solid #fbbf24", cursor: onIt ? "default" : "pointer", color: "#fde68a", fontSize: 11.5, fontWeight: 900, letterSpacing: ".3px", userSelect: "none" }}>
                    <span style={{ fontSize: 13 }}>{icon}</span><span style={{ flex: 1 }}>{label}</span>
                    <span style={{ fontSize: 9, color: "#fbbf24", transition: "transform .2s", transform: open ? "rotate(-90deg)" : "rotate(0)" }}>◀</span>
                  </div>
                  {open && <div style={{ marginInlineStart: 14, marginTop: 2, paddingInlineStart: 4, borderInlineStart: "1px dashed rgba(251,191,36,.35)" }}>{children}</div>}
                </div>
              );
            };
            const vApp = isAdmin || user?.can_view_portal_app, vAcc = isAdmin || user?.can_manage_users || user?.cp_can_manage_accounts;
            const vCrm = isAdmin || user?.can_view_client_prospects;
            const vLand = isAdmin || user?.can_view_land_offers, vAqar = isAdmin || user?.can_view_aqar_listings, vProj = isAdmin || user?.can_view_project_offers;
            const vCc = isAdmin || user?.can_view_callcenter, vBc = isAdmin || user?.can_view_business_chat;
            return <>
              {/* v3.4.250 — حجوزات دليلك: بند رئيسي مستقل — v3.4.589 أول بنود «نظام التسويق» */}
              {(isAdmin || user?.cp_can_view_dalilak_reservations || user?.cp_can_add_dalilak_reservations) && (
                <NavLink to="/dalilak-reservations" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiHome />{!collapsed && <span>حجوزات دليلك</span>}</NavLink>
              )}
              {sub("mk_org", "المنظم التسويقي", "📱", vApp || vAcc, P.startsWith("/portal-accounts"), <>
                {vApp && <a href="/portal" target="_blank" rel="noopener noreferrer" className="nav"><FiSmartphone />{!collapsed && <span>تطبيق المنظم التسويقي ↗</span>}</a>}
                {vAcc && <NavLink to="/portal-accounts" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiKey />{!collapsed && <span>إدارة حسابات البوابة</span>}</NavLink>}
              </>)}
              {sub("mk_crm", "نظام CRM", "🎯", vCrm, P.startsWith("/client-prospect"), <>
                <NavLink to="/client-prospects-inbox" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiInbox />{!collapsed && <span>وارد العملاء المحتملين الجديدة</span>}</NavLink>{/* v3.4.783 */}
                <NavLink to="/client-prospects" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiUserCheck />{!collapsed && <span>نظام CRM للعملاء المحتملين</span>}</NavLink>
                <NavLink to="/client-prospect-groups" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiGrid />{!collapsed && <span>مجموعات عملاء محتملين</span>}</NavLink>
              </>)}
              {sub("mk_offers", "عروض عقارية", "🏘️", vLand || vAqar || vProj, ["/land-offers", "/aqar-listings", "/project-offers"].some(x => P.startsWith(x)), <>
                {vLand && <NavLink to="/land-offers" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiMapPin />{!collapsed && <span>عروض الأراضي</span>}</NavLink>}
                {vAqar && <NavLink to="/aqar-listings" className={({ isActive }) => isActive ? "nav active" : "nav"}><span style={{ width: 16, textAlign: "center" }}>🏷️</span>{!collapsed && <span>إعلانات عقار</span>}</NavLink>}
                {vProj && <NavLink to="/project-offers" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiHome />{!collapsed && <span>عروض المشاريع</span>}</NavLink>}
              </>)}
              {sub("mk_cc", "الكول سنتر والواتس", "☎️", vCc || vBc, P.startsWith("/call-center") || P.startsWith("/business-chat"), <>
                {vCc && <NavLink to="/call-center" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiPhoneCall />{!collapsed && <span>إدارة الكول سنتر</span>}</NavLink>}
                {vBc && <NavLink to="/business-chat" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiMessageCircle />{!collapsed && <span>إدارة البزنس شات</span>}</NavLink>}
              </>)}
            </>;
          })()}
          {/* v3.3.849 — قسم إدارة المشاريع الإنشائية (Labor & Expenses) */}
          {/* v3.4.025 — كل صفحة بمجموعة إدارة المشاريع لها علم عرض مستقل (can_view_construction يبقى علم المقاول الرئيسي) */}
            {/* v3.4.560 — الشاشة التفاعلية (كانت مجموعة مستقلة) — v3.4.569: مجموعة فرعية قابلة للطي داخل «نظام التسويق» بنفس نمط «إدارة المشاريع» */}
            {(isAdmin || !!user?.can_view_screen || !!user?.screen_can_manage) && (() => {
              const onIt = location.pathname.startsWith("/screen-admin");
              const open = onIt || (pmSubs.screen !== undefined ? pmSubs.screen : false);
              if (collapsed) return <>
                <a href="/screen/" target="_blank" rel="noopener noreferrer" className="nav"><FiMonitor />{!collapsed && <span>فتح الشاشة ↗</span>}</a>{/* v3.4.496 — انتقل من «نظام التسويق» */}
                <NavLink to="/screen-admin" end className={({ isActive }) => isActive ? "nav active" : "nav"}><FiMonitor />{!collapsed && <span>رابط الشاشة والمشاريع</span>}</NavLink>
                {screenProjects.map(p => (
                  <NavLink key={p.id} to={`/screen-admin/${p.id}`} className={({ isActive }) => isActive ? "nav active" : "nav"}><FiHome />{!collapsed && <span>{p.title || p.name}</span>}</NavLink>
                ))}
              </>;
              return (
                <div style={{ margin: "6px 0 2px" }}>
                  <div role="button" tabIndex={0} onClick={() => !onIt && togglePmSub("screen", open)} onKeyDown={ev => (ev.key === "Enter" || ev.key === " ") && !onIt && togglePmSub("screen", open)}
                    title={onIt ? "أنت داخل هذه المجموعة" : open ? "طيّ" : "فتح"}
                    style={{ display: "flex", alignItems: "center", gap: 8, padding: "7px 10px", margin: "0 4px", borderRadius: 8, background: onIt ? "rgba(251,191,36,.16)" : "rgba(0,0,0,.24)", borderInlineStart: "3px solid #fbbf24", cursor: onIt ? "default" : "pointer", color: "#fde68a", fontSize: 12.5, fontWeight: 800 }}>
                    <span style={{ fontSize: 13 }}>🖥️</span><span style={{ flex: 1 }}>الشاشة التفاعلية</span>
                    <span style={{ fontSize: 9, color: "#fbbf24", transition: "transform .2s", transform: open ? "rotate(-90deg)" : "rotate(0)" }}>◀</span>
                  </div>
                  {open && <div style={{ marginInlineStart: 14, marginTop: 2, paddingInlineStart: 4, borderInlineStart: "1px dashed rgba(251,191,36,.35)" }}>
                <a href="/screen/" target="_blank" rel="noopener noreferrer" className="nav"><FiMonitor />{!collapsed && <span>فتح الشاشة ↗</span>}</a>{/* v3.4.496 — انتقل من «نظام التسويق» */}
                <NavLink to="/screen-admin" end className={({ isActive }) => isActive ? "nav active" : "nav"}><FiMonitor />{!collapsed && <span>رابط الشاشة والمشاريع</span>}</NavLink>
                {screenProjects.map(p => (
                  <NavLink key={p.id} to={`/screen-admin/${p.id}`} className={({ isActive }) => isActive ? "nav active" : "nav"}><FiHome />{!collapsed && <span>{p.title || p.name}</span>}</NavLink>
                ))}
                  </div>}
                </div>
              );
            })()}
          </NavGroup>
          <NavGroup id="g6" label="إدارة المشاريع" show={(isAdmin || user?.can_view_construction || user?.can_view_weekly_orders || user?.can_view_subcontracts || user?.can_view_contract_claims || user?.can_view_receipt_requests || user?.can_view_drawings || user?.can_view_contract_structure || user?.can_manage_users || user?.pm_can_manage_accounts || (user?.drawing_projects || []).length > 0)} collapsed={collapsed} open={!!openGroups["g6"]} onToggle={toggleGroup}>
          {/* v3.4.445 — ثلاث مجموعات فرعية: الإدارة / نظام المحاسبة للمشاريع / الخرائط المرجعية */}
          {(() => {
            const P = location.pathname;
            const sub = (key, label, icon, show, onIt, children) => {
              if (!show) return null;
              const open = onIt || (pmSubs[key] !== undefined ? pmSubs[key] : false); // v3.4.609 — مطويّة افتراضيًا
              if (collapsed) return <React.Fragment key={key}>{children}</React.Fragment>;
              return (
                <div key={key} style={{ margin: "6px 0 2px" }}>
                  <div role="button" tabIndex={0} onClick={() => !onIt && togglePmSub(key, open)} onKeyDown={ev => (ev.key === "Enter" || ev.key === " ") && !onIt && togglePmSub(key, open)}
                    title={onIt ? "أنت داخل هذه المجموعة" : open ? "طيّ" : "فتح"}
                    style={{ display: "flex", alignItems: "center", gap: 8, padding: "7px 10px", margin: "0 4px", borderRadius: 8, background: onIt ? "rgba(251,191,36,.16)" : "rgba(0,0,0,.24)", borderInlineStart: "3px solid #fbbf24", cursor: onIt ? "default" : "pointer", color: "#fde68a", fontSize: 11.5, fontWeight: 900, letterSpacing: ".3px", userSelect: "none" }}>{/* v3.4.448 — رأس المجموعة الفرعية شريط داكن بحد ذهبي ليتميّز عن الروابط */}
                    <span style={{ fontSize: 13 }}>{icon}</span><span style={{ flex: 1 }}>{label}</span>
                    <span style={{ fontSize: 9, color: "#fbbf24", transition: "transform .2s", transform: open ? "rotate(-90deg)" : "rotate(0)" }}>◀</span>
                  </div>
                  {open && <div style={{ marginInlineStart: 14, marginTop: 2, paddingInlineStart: 4, borderInlineStart: "1px dashed rgba(251,191,36,.35)" }}>{children}</div>}
                </div>
              );
            };
            const showAdmin = isAdmin || user?.can_view_construction || user?.can_manage_users || user?.pm_can_manage_accounts;
            const showAcct = isAdmin || user?.can_view_construction || user?.can_view_weekly_orders || user?.can_view_contract_claims || user?.can_view_subcontracts || user?.can_view_receipt_requests;
            const showMaps = isAdmin || user?.can_view_drawings || user?.can_view_contract_structure || user?.can_view_construction || user?.can_manage_projects || (user?.drawing_projects || []).length > 0; // v3.4.724 — + مرجع المساحات
            const onAcct = P === "/construction" || ["/construction-orders", "/construction-claims", "/construction-contracts", "/subcontractors", "/construction-receipts", "/supply-contracts", "/supply-orders"].some(x => P.startsWith(x));
            return <>
              {sub("admin", "الإدارة", "🗂️", showAdmin, P.startsWith("/pm-accounts"), <>
          {/* v3.3.982 — رابط تطبيق إدارة المشاريع أول بند بالمجموعة (يفتح بصفحة منفصلة) */}
          {(isAdmin || user?.can_view_construction) && (
            <a href="/pm" target="_blank" rel="noopener noreferrer" className="nav"><FiSmartphone />{!collapsed && <span>تطبيق إدارة المشاريع ↗</span>}</a>
          )}
          {/* v3.4.030 — إدارة المستخدمين — قسم المشاريع: انتقل لأعلى المجموعة تحت رابط التطبيق مباشرة */}
          {(isAdmin || user?.can_manage_users || user?.pm_can_manage_accounts) && (
            <NavLink to="/pm-accounts" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiKey />{!collapsed && <span>إدارة المستخدمين — قسم المشاريع</span>}</NavLink>
          )}
              </>)}
              {sub("acct", "نظام المحاسبة للمشاريع", "💼", showAcct, onAcct, <>
          {/* v3.4.412 — قائمة المقاولين المعتمدين (v3.4.452: أول المجموعة) (مرجع + ملف لكل مقاول عبر المشاريع) */}
          {(isAdmin || user?.can_view_subcontracts || user?.can_view_contract_claims) && (
            <NavLink to="/subcontractors" className={({ isActive }) => isActive ? "nav active" : "nav"}><span style={{ width: 16, textAlign: "center" }}>👥</span>{!collapsed && <span>قائمة المقاولين</span>}</NavLink>
          )}
          {(isAdmin || user?.can_view_construction) && (
            <NavLink to="/construction" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiTool />{!collapsed && <span>المقاول الرئيسي للمشاريع</span>}</NavLink>
          )}
          {/* v3.3.882 — دفعات المقاولين — v3.4.008: الاسم صار «عقود وأعمال مقاولي الباطن» */}
          {(isAdmin || user?.can_view_subcontracts) && (
            <NavLink to="/construction-contracts" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiCreditCard />{!collapsed && <span>عقود وأعمال مقاولي الباطن</span>}</NavLink>
          )}
          {/* v3.4.621 — عقود التوريدات والخدمات الاستشارية */}
          {(isAdmin || user?.can_view_supply_contracts) && (
            <NavLink to="/supply-contracts" className={({ isActive }) => isActive ? "nav active" : "nav"}><span style={{ width: 16, textAlign: "center" }}>📦</span>{!collapsed && <span>عقود التوريدات والخدمات الاستشارية</span>}</NavLink>
          )}
          {/* v3.4.442 — «أوامر صرف مستحقات المقاولين» صار تابًا داخل «نظام أوامر الصرف» */}
          {/* v3.3.971 — رفع مستخلص استلام */}
          {(isAdmin || user?.can_view_receipt_requests) && (
            <NavLink to="/construction-receipts" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiFileText />{!collapsed && <span>رفع مستخلص استلام</span>}</NavLink>
          )}
          {/* v3.4.442 — نظام أوامر الصرف (v3.4.447: آخر المجموعة): رابط واحد وتحته تابان (اليوميات الأسبوعية + مستحقات المقاولين) */}
          {(isAdmin || user?.can_view_weekly_orders || user?.can_view_contract_claims || user?.can_view_supply_contracts) && (
            <NavLink to={(isAdmin || user?.can_view_weekly_orders) ? "/construction-orders" : user?.can_view_contract_claims ? "/construction-claims" : "/supply-orders"} className={() => (location.pathname.startsWith("/construction-orders") || location.pathname.startsWith("/construction-claims") || location.pathname.startsWith("/supply-orders")) ? "nav active" : "nav"}><FiDollarSign />{!collapsed && <span>نظام أوامر الصرف</span>}</NavLink>
          )}
              </>)}
              {sub("maps", "الخرائط المرجعية", "🗺️", showMaps, P.startsWith("/construction-drawings") || P.startsWith("/unit-areas"), <>
          {/* v3.3.987 — مرجع الخرائط التنفيذية */}
          {(isAdmin || user?.can_view_drawings || user?.can_view_contract_structure || (user?.drawing_projects || []).length > 0) && ( /* v3.4.220 — المهندس المسؤول */
            <NavLink to="/construction-drawings" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiMapPin />{!collapsed && <span>مرجع الخرائط التنفيذية</span>}</NavLink>
          )}
          {/* v3.4.724 — مرجع مساحة الوحدات (المساحات البيعية) */}
          {(isAdmin || user?.can_view_drawings || user?.can_view_contract_structure || user?.can_view_construction || user?.can_manage_projects) && (
            <NavLink to="/unit-areas" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiMapPin />{!collapsed && <span>مرجع مساحة الوحدات (المساحات البيعية)</span>}</NavLink>
          )}
              </>)}
            </>;
          })()}
          {/* v3.3.760 — سجل زوار المكتب انتقل لمجموعة الحجوزات بالأعلى */}
          {/* v3.4.040 — مجموعة «الإجراءات» نُقلت للأعلى قبل مجموعة «البيانات» */}

          {/* المجموعة الجديدة: التحليل المالي — v3.3.308: صلاحيات منفصلة */}
          </NavGroup>
          {/* v3.4.560 — الشاشة التفاعلية انتقلت داخل «نظام التسويق» */}
          {/* v3.4.547 — المواقع الإلكترونية انتقلت إلى مجموعة «سوشل ميديا وجرافيك» */}
          <NavGroup id="g7" label="التحليل المالي" show={(isAdmin || user?.can_view_analytics || user?.can_view_financial_reports || user?.can_view_commissions || user?.can_view_cash_flow || user?.can_view_cash_flow_statement || user?.can_view_benchmarking || user?.can_view_company_assets || user?.can_view_capex || user?.can_view_treasury || user?.can_view_payroll /* v3.4.837 */ || user?.can_view_sukuk || user?.can_view_admin_fees || user?.can_view_accounting /* v3.4.496 — كل صفحات المجموعة */)} collapsed={collapsed} open={!!openGroups["g7"]} onToggle={toggleGroup}>
          {/* v3.4.327 — الداشبورد المالي أول عنصر في المجموعة */}
          {(isAdmin || user?.can_view_analytics || user?.can_view_financial_reports || user?.can_view_treasury) && (
            <NavLink to="/finance-dashboard" className={({ isActive }) => isActive ? "nav active" : "nav"}>
              <FiBarChart2 />{!collapsed && <span>الداشبورد المالي</span>}
            </NavLink>
          )}
          {/* v3.4.362 — ترتيب المجموعة: الداشبورد ← الخزينة ← المصاريف الرأسمالية ← التمويل ← البقية */}
          {/* v3.3.576 — Treasury (الخزينة المالية) */}
          {(isAdmin || user?.can_view_treasury) && (
            <NavLink to="/treasury" className={({ isActive }) => isActive ? "nav active" : "nav"}>
              <FiDollarSign />{!collapsed && <span>الخزينة المالية</span>}
            </NavLink>
          )}
          {/* v3.4.837 — إدارة الرواتب */}
          {(isAdmin || user?.can_view_payroll) && (
            <NavLink to="/payroll" className={({ isActive }) => isActive ? "nav active" : "nav"}>
              <FiUsers />{!collapsed && <span>إدارة الرواتب</span>}
            </NavLink>
          )}
          {(isAdmin || user?.can_view_capex) && (
            <NavLink to="/capex" className={({ isActive }) => isActive ? "nav active" : "nav"}>
              <FiTrendingUp />{!collapsed && <span>المصاريف الرأسمالية</span>}
            </NavLink>
          )}
          {/* v3.3.518 — Sukuk uses its own permission only (same reasoning as CAPEX) */}
          {(isAdmin || user?.can_view_sukuk) && (
            <NavLink to="/sukuk" className={({ isActive }) => isActive ? "nav active" : "nav"}>
              <FiDollarSign />{!collapsed && <span>التمويل</span>}
            </NavLink>
          )}
          {(isAdmin || user?.can_view_analytics) && (
            <NavLink to="/analytics" className={({ isActive }) => isActive ? "nav active" : "nav"}>
              <FiBarChart2 />{!collapsed && <span>الإحصائيات</span>}
            </NavLink>
          )}
          {(isAdmin || user?.can_view_company_assets) && (
            <NavLink to="/company-assets" className={({ isActive }) => isActive ? "nav active" : "nav"}>
              <FiHome />{!collapsed && <span>أصول الشركة</span>}
            </NavLink>
          )}
          {(isAdmin || user?.can_view_financial_reports) && (
            <NavLink to="/financial-reports" className={({ isActive }) => isActive ? "nav active" : "nav"}>
              <FiFileText />{!collapsed && <span>التقارير المالية</span>}
            </NavLink>
          )}
          {(isAdmin || user?.can_view_commissions) && (
            <NavLink to="/commissions" className={({ isActive }) => isActive ? "nav active" : "nav"}>
              <FiPercent />{!collapsed && <span>الدلالات والعمولات</span>}
            </NavLink>
          )}
          {/* v3.3.622 — الرسوم الإدارية للمشاريع؛ v3.3.691 — صلاحية مستقلة can_view_admin_fees (قسم خاص في البروفايل) */}
          {(isAdmin || user?.can_view_admin_fees) && (
            <NavLink to="/admin-fees" className={({ isActive }) => isActive ? "nav active" : "nav"}>
              <FiHome />{!collapsed && <span>الرسوم الإدارية للمشاريع</span>}
            </NavLink>
          )}
          {(isAdmin || user?.can_view_cash_flow) && (
            <NavLink to="/cash-flow" className={({ isActive }) => isActive ? "nav active" : "nav"}>
              <FiRefreshCw />{!collapsed && <span>تفاصيل الإيرادات</span>}
            </NavLink>
          )}
          {/* v3.3.431 — separate flag for cash flow statement */}
          {(isAdmin || user?.can_view_cash_flow_statement) && (
            <NavLink to="/cash-flow-statement" className={({ isActive }) => isActive ? "nav active" : "nav"}>
              <FiRefreshCw />{!collapsed && <span>التدفقات النقدية</span>}
            </NavLink>
          )}
          {(isAdmin || user?.can_view_benchmarking) && (
            <NavLink to="/benchmarking" className={({ isActive }) => isActive ? "nav active" : "nav"}>
              <FiGrid />{!collapsed && <span>مقارنة المشاريع</span>}
            </NavLink>
          )}
          {/* v3.3.487 — Accounting module (mirrors external accounting system) */}
          {(isAdmin || user?.can_view_accounting) && (
            <NavLink to="/accounting" className={({ isActive }) => isActive ? "nav active" : "nav"}>
              <FiDatabase />{!collapsed && <span>البرنامج المحاسبي</span>}
            </NavLink>
          )}

          {/* المجموعة الرابعة: النظام */}
          </NavGroup>
          <NavGroup id="g8" label="النظام" show={(canManage || user?.can_view_settings || user?.can_view_audit || user?.can_view_cloud_billing)} collapsed={collapsed} open={!!openGroups["g8"]} onToggle={toggleGroup}>
          {/* v3.3.970 — "الإعدادات" صارت "إعدادات القوائم"، وربط واتساب وإدارة المستخدمين نزلا هنا من تبويبات صفحة الإعدادات */}
          {(canManage || user?.can_view_settings) && <NavLink to="/settings" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiSettings />{!collapsed && <span>إعدادات القوائم</span>}</NavLink>}
          {(canManage || user?.can_view_settings) && <NavLink to="/whatsapp-settings" className={({ isActive }) => isActive ? "nav active" : "nav"}><FaWhatsapp />{!collapsed && <span>ربط واتساب</span>}</NavLink>}
          {canManage && <NavLink to="/users" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiUsers />{!collapsed && <span>إدارة المستخدمين</span>}</NavLink>}
          {(canManage || user?.can_view_audit) && <NavLink to="/audit" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiActivity />{!collapsed && <span>التنبيهات</span>}</NavLink>}
          {/* v3.3.683 — تكتات التحسينات: متاحة لكل المستخدمين */}
          {(isAdmin || user?.can_view_cloud_billing) && <NavLink to="/cloud-billing" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiCloud />{!collapsed && <span>فواتير الكلاود</span>}</NavLink>}{/* v3.4.255 */}
          {isAdmin && <NavLink to="/storage-map" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiHardDrive />{!collapsed && <span>خريطة التخزين</span>}</NavLink>}{/* v3.4.425 */}
          <NavLink to="/tickets" className={({ isActive }) => isActive ? "nav active" : "nav"}><FiTool />{!collapsed && <span>التحسينات</span>}</NavLink>
          </NavGroup>
        </nav>
        <div className="sb-foot">
          {!collapsed && <div style={{ fontSize: 10, color: "rgba(255,255,255,0.5)", textAlign: "center", marginBottom: 8, letterSpacing: 1, fontWeight: 600 }}>v{process.env.REACT_APP_VERSION || require("../package.json").version}</div>}
          {!collapsed && user && <div className="user-info">{user.avatar_url && <img src={user.avatar_url} alt="" />}<div><p className="uname">{user.display_name}</p><p className="urole">{user.role}</p></div></div>}
          {/* v3.3.435 — Refresh permissions button (no need to logout/login) */}
          <button
            className="logout-btn"
            onClick={async () => {
              try {
                await refreshUser();
                if (window.toast) window.toast.success("تم تحديث الصلاحيات");
                else alert("تم تحديث الصلاحيات");
              } catch (e) { alert("فشل التحديث"); }
            }}
            style={{ marginBottom: 4, background: "rgba(34, 197, 94, 0.15)", borderColor: "rgba(34, 197, 94, 0.3)" }}
            title="تحديث الصلاحيات بدون تسجيل خروج (لو تم منحك صلاحيات جديدة من المدير)"
          >
            <FiRefreshCw />{!collapsed && <span>تحديث الصلاحيات</span>}
          </button>
{/* v3.4.510 — التحقق بخطوتين: ربط تطبيق المصادقة والرموز الاحتياطية (وللمدير: السياسة والموظفون) */}
          <button className="logout-btn" onClick={() => navigate("/two-factor")} style={{ marginBottom: 4 }} title="التحقق بخطوتين — تطبيق المصادقة (Google Authenticator)">
            <FiSettings />{!collapsed && <span>التحقق بخطوتين</span>}
          </button>
          <button className="logout-btn" onClick={logout}><FiLogOut />{!collapsed && <span>خروج</span>}</button>
        </div>
      </aside>
      <main className={`content ${collapsed ? "expanded" : ""}`}>
        {/* Global Impersonation Banner */}
        {user?.impersonating && (
          <div style={{
            background: "linear-gradient(90deg, #f59e0b, #d97706)",
            color: "#fff", padding: "8px 20px", display: "flex", justifyContent: "space-between", alignItems: "center",
            boxShadow: "0 4px 12px rgba(245,158,11,0.3)", position: "sticky", top: 0, zIndex: 999,
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <FiEye size={18} />
              <span style={{ fontWeight: 700 }}>وضع المعاينة: {user.impersonating.profile_name}</span>
              <span style={{ fontSize: 12, opacity: 0.9 }}>— ترى النظام كما يراه مستخدم هذا البروفايل</span>
            </div>
            <button onClick={handleStopImpersonate} style={{
              background: "#fff", color: "#d97706", border: "none", padding: "6px 16px",
              borderRadius: 6, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", fontSize: 12,
            }}>إيقاف المعاينة</button>
          </div>
        )}
        <RefProvider>
          <Routes>
            <Route index element={<HomeGate user={user} isAdmin={isAdmin} />} />{/* v3.3.866 — من لا يملك صلاحية الحجوزات يُحوَّل لأول صفحة مخولة */}
            <Route path="clients" element={<RefListPage type="client" />} />
            <Route path="client-groups" element={<ClientGroupsPage />} />
            <Route path="marketer-groups" element={<MarketerGroupsPage />} />
            <Route path="developers" element={<RefListPage type="developer" />} />
            <Route path="marketers" element={<RefListPage type="marketer" />} />
            <Route path="disbursements" element={<DisbursementsPage />} />
            <Route path="contracts" element={<ContractsPage />} />
            <Route path="communication" element={<CommunicationPage key="comm-clients" defaultTab="clients" />} />
            <Route path="communication/clients" element={<CommunicationPage key="comm-clients" defaultTab="clients" />} />
            <Route path="communication/marketers" element={<CommunicationPage key="comm-marketers" defaultTab="marketers" />} />
            {(isAdmin || user?.can_view_chairman_office) && <Route path="communication/abubader2" element={<CommunicationPage key="comm-abubader2" defaultTab="abubader2" />} />}{/* v3.4.342 — لمكتب الرئيس فقط */}
            {(isAdmin || user?.can_view_chairman_office) && <Route path="communication/abubader-biz" element={<CommunicationPage key="comm-abubader-biz" defaultTab="abubader_biz" />} />}
            {(isAdmin || user?.can_view_chairman_office) && <Route path="chairman-comm" element={<ChairmanCommPage />} />}{/* v3.4.342 */}
            {(isAdmin || user?.can_view_chairman_office) && <Route path="chairman-contacts" element={<ChairmanContactsPage />} />}{/* v3.4.345 */}
            {(isAdmin || user?.can_view_media_library) && <Route path="media-library" element={<MediaLibraryPage />} />}{/* v3.4.361 */}
            {(isAdmin || user?.can_view_media_library) && <Route path="media-library/:projectId" element={<MediaLibraryPage />} />}
            {(canManage || user?.can_view_settings) && <Route path="settings" element={<SettingsPage />} />}
            {(canManage || user?.can_view_settings) && <Route path="whatsapp-settings" element={<WhatsAppSettingsPage />} />}
            {canManage && <Route path="users" element={<UserManagement />} />}{/* v3.3.970 — إدارة المستخدمين صفحة مستقلة */}
            <Route path="business-comm" element={<BusinessCommPage user={user} />} />
            <Route path="wa-updates-group" element={<WaUpdatesGroupPage />} />{/* v3.4.271 */}
            {(isAdmin || user?.can_manage_users || user?.can_view_wa_admin || user?.wa_admin_can_manage) && <Route path="wa-admin" element={<WaAdminPage />} />}{/* v3.4.513 · v3.4.744 */}
            <Route path="invitations" element={<InvitationsPage />} />{/* v3.4.062 */}
            <Route path="prospects" element={<ProspectsPage />} />
            <Route path="prospect-groups" element={<ProspectGroupsPage />} />
            {/* v3.3.679 — العملاء المحتملون */}
            <Route path="client-prospects" element={<ClientProspectsPage key="crm" />} />{/* v3.4.790 key: إعادة تركيب عند التنقل بين الصفحتين */}
            <Route path="client-prospects-inbox" element={<ClientProspectsPage key="inbox" mode="inbox" />} />{/* v3.4.783 */}
            <Route path="portal-accounts" element={<PortalAccountsPage />} />{/* v3.4.060 */}
            <Route path="dalilak-reservations" element={<DalilakReservationsPage />} />{/* v3.4.250 */}
            <Route path="client-prospect-groups" element={<ClientProspectGroupsPage />} />
            <Route path="social-campaigns" element={<Navigate to="/media-library/social" replace />} />{/* v3.4.280 — v3.4.385: انتقلت تحت مكتبة الميديا */}
            {(isAdmin || user?.can_view_media_library || user?.can_view_client_prospects || user?.can_view_social_media) && <Route path="media-library/social" element={<MediaLibraryPage />} />}{/* v3.4.385 — v3.4.553: + can_view_social_media (كان الرابط يظهر والمسار لا يُسجَّل) */}
            <Route path="land-offers" element={<LandOffersPage />} />{/* v3.3.824 */}
            <Route path="aqar-listings" element={<AqarListingsPage />} />{/* v3.4.399 */}
            <Route path="staff-tasks" element={<StaffTasksPage />} />{/* v3.4.207 */}
            <Route path="project-offers" element={<ProjectOffersPage />} />{/* v3.3.828 */}
            <Route path="call-center" element={<CallCenterPage />} />{/* v3.3.923 */}
            <Route path="business-chat" element={<BusinessChatPage />} />{/* v3.4.042 — إدارة البزنس شات */}
            <Route path="official-whatsapp" element={<CompanyWhatsAppPage />} />{/* v3.4.743 — الشاشة الموحّدة */}
            {(isAdmin || user?.can_view_letters) && <Route path="letters" element={<OfficialLettersPage />} />}{/* v3.4.815 */}
            <Route path="company-whatsapp" element={<CompanyWhatsAppPage />} />
            <Route path="daleelak-whatsapp" element={<CompanyWhatsAppPage variant="daleelak" />} />{/* v3.4.587 */}{/* v3.4.180 — واتس الرقم الرئيسي للشركة */}
            <Route path="construction" element={<ConstructionPage />} />{/* v3.3.849 */}
            <Route path="construction-orders" element={<PaymentOrdersHub />} />{/* v3.3.868 — v3.4.442: تاب داخل نظام أوامر الصرف */}
            <Route path="construction-contracts" element={<ContractPaymentsPage />} />{/* v3.3.882 */}
            <Route path="subcontractors" element={<SubcontractorsPage />} />{/* v3.4.412 */}
            <Route path="supply-contracts" element={<SupplyContractsPage />} />{/* v3.4.621 */}
            <Route path="supply-orders" element={<PaymentOrdersHub />} />{/* v3.4.621 — تاب أوامر صرف عقود التوريد والاستشارات */}
            <Route path="construction-claims" element={<PaymentOrdersHub />} />{/* v3.3.912 — v3.4.442: تاب داخل نظام أوامر الصرف */}
            <Route path="construction-receipts" element={<ReceiptRequestsPage />} />{/* v3.3.971 — رفع مستخلص استلام */}
            <Route path="construction-drawings" element={<DrawingsReferencePage />} />{/* v3.3.987 — مرجع الخرائط التنفيذية */}
            {(isAdmin || user?.can_view_drawings || user?.can_view_contract_structure || user?.can_view_construction || user?.can_manage_projects) && <Route path="unit-areas" element={<UnitAreasReferencePage />} />}{/* v3.4.724 — مرجع مساحة الوحدات */}
            <Route path="pm-accounts" element={<PmAccountsPage />} />{/* v3.4.028 — إدارة المستخدمين — قسم المشاريع */}
            {/* v3.3.718 — سجل زوار المكتب */}
            {(isAdmin || user?.can_view_office_visitors) && (
              <Route path="office-visitors" element={<OfficeVisitorsPage />} />
            )}
            {/* v3.3.759 — تحليل التسويق الداخلي */}
            {(isAdmin || user?.can_view_marketing_analytics) && (
              <Route path="marketing-analytics" element={<MarketingAnalyticsPage />} />
            )}
            {canManage && <Route path="audit" element={<AuditLogPage />} />}
            {/* v3.3.683 — تكتات التحسينات (لكل المستخدمين) */}
            <Route path="tickets" element={<TicketsPage user={user} isAdmin={isAdmin} />} />
            {(isAdmin || user?.can_view_cloud_billing) && <Route path="cloud-billing" element={<CloudBillingPage />} />}{/* v3.4.255 */}
            {isAdmin && <Route path="storage-map" element={<StorageMapPage />} />}{/* v3.4.425 */}
            <Route path="two-factor" element={<TwoFactorPage />} />{/* v3.4.510 — لكل المستخدمين (قسم المدير يظهر للمدير فقط) */}
            {(isAdmin || user?.can_view_websites || user?.websites_can_edit) && <Route path="websites/:key" element={<WebsitesPage />} />}{/* v3.4.489 */}
            {almaAccess && <Route path="alma-website" element={<AlmaCapitalPage />} />}{/* v3.4.817 — v3.4.835 */}
            {(isAdmin || user?.can_view_digital_accounts) && <Route path="digital-accounts" element={<DigitalAccountsPage />} />}{/* v3.4.547 */}
            {(isAdmin || user?.can_view_screen || user?.screen_can_manage) && <Route path="screen-admin" element={<ScreenAdminPage />} />}{/* v3.4.492 */}
            {(isAdmin || user?.can_view_screen || user?.screen_can_manage) && <Route path="screen-admin/:pid" element={<ScreenAdminPage />} />}
            {(isAdmin || user?.can_view_projects) && (
              <Route path="projects" element={<ProjectsPage />} />
            )}
            {(isAdmin || user?.can_view_projects) && (
              <Route path="projects/:projectId/units/:unitId" element={<UnitFullPage />} />
            )}
            {/* v3.4.136 — فحص اكتمال بيانات المبيعات (أدمن / إدارة المشاريع / صلاحية مخصصة) */}
            {(isAdmin || user?.can_manage_projects || user?.projects_can_view_completeness) && (
              <Route path="projects/completeness" element={<CompletenessPage />} />
            )}
            {/* v3.4.192 — الموارد البشرية */}
            {(isAdmin || user?.can_view_hr) && <Route path="hr" element={<HrPage />} />}
            {(isAdmin || user?.can_view_legal) && <Route path="legal" element={<LegalPage />} />}{/* v3.4.420 */}
            {/* Analytics routes — التحليل المالي */}
            {(isAdmin || user?.can_view_projects) && (
              <Route path="analytics" element={<AnalyticsPage />} />
            )}
            {(isAdmin || user?.can_view_projects) && (
              <Route path="analytics/:mode" element={<AnalyticsPage />} />
            )}
            {(isAdmin || user?.can_view_projects) && (
              <Route path="analytics/:mode/:id" element={<AnalyticsPage />} />
            )}
            {/* Financial Analysis pages */}
            {(isAdmin || user?.can_view_projects) && <Route path="reservations-scheduler" element={<ReservationsSchedulerPage />} />}
            {(isAdmin || user?.can_view_projects) && <Route path="company-assets" element={<CompanyAssetsPage />} />}
            {/* v3.3.518 — CAPEX/Sukuk routes use own permissions only (match sidebar logic) */}
            {(isAdmin || user?.can_view_capex) && <Route path="capex" element={<CapexPage />} />}
            {(isAdmin || user?.can_view_sukuk) && <Route path="sukuk" element={<SukukPage />} />}
            {(isAdmin || user?.can_view_accounting) && <Route path="accounting" element={<AccountingPage />} />}
            {(isAdmin || user?.can_view_projects) && <Route path="financial-reports" element={<FinancialReportsPage />} />}
            {(isAdmin || user?.can_view_sales) && <Route path="sales" element={<SalesPage />} />}{/* v3.4.538 */}
            {(isAdmin || user?.can_view_quotations) && <Route path="quotations" element={<QuotationsPage />} />}{/* v3.4.561 */}
            {(isAdmin || user?.can_view_vouchers) && <Route path="vouchers" element={<VouchersPage />} />}{/* v3.4.611 */}
            {(isAdmin || user?.can_view_projects) && <Route path="payments" element={<PaymentsPage />} />}
            {(isAdmin || user?.can_view_projects) && <Route path="collections" element={<CollectionsPage />} />}
            {(isAdmin || user?.can_view_projects) && <Route path="collections/client/:clientId" element={<ClientCollectionPage />} />}{/* v3.4.801 */}
            {(isAdmin || user?.can_view_projects) && <Route path="commissions" element={<CommissionsPage />} />}
            {(isAdmin || user?.can_view_admin_fees) && <Route path="admin-fees" element={<AdminFeesPage />} />}
            {(isAdmin || user?.can_view_projects) && <Route path="cash-flow" element={<CashFlowPage />} />}
            {(isAdmin || user?.can_view_projects) && <Route path="cash-flow-statement" element={<CashFlowStatementPage />} />}
            {(isAdmin || user?.can_view_projects) && <Route path="benchmarking" element={<BenchmarkingPage />} />}
            {/* v3.3.576 — Treasury (الخزينة المالية) */}
            {(isAdmin || user?.can_view_treasury) && <Route path="treasury" element={<TreasuryPage />} />}
            {(isAdmin || user?.can_view_payroll) && <Route path="payroll" element={<PayrollPage />} />}{/* v3.4.837 */}
            {(isAdmin || user?.can_view_analytics || user?.can_view_financial_reports || user?.can_view_treasury) && <Route path="finance-dashboard" element={<FinanceDashboardPage />} />}{/* v3.4.327 */}
            {(isAdmin || user?.can_view_chairman_office) && <Route path="chairman-mail" element={<ChairmanMailPage />} />}{/* v3.4.328 */}
            {(isAdmin || user?.can_view_chairman_office) && <Route path="chairman-calendar" element={<ChairmanCalendarPage />} />}{/* v3.4.339 */}
          </Routes>
        </RefProvider>
      </main>
    </div>
  );
}

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading">جاري التحميل...</div>;
  if (!user) return <Navigate to="/login" />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          {/* v3.3.769 — البوابة الخارجية: صفحة عامة معزولة تمامًا (توكن خاص، بلا Google) */}
          <Route path="/portal/*" element={<PortalPage />} />
          <Route path="/pm/*" element={<PmPortalPage />} />{/* v3.3.979 — تطبيق إدارة المشاريع */}
          <Route path="/*" element={<ProtectedRoute><Layout /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
